import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';

import * as CEGeneralReact from "../../CaptureExecGeneral/CEGeneralReact.js";
import * as CEComplexReact from "../../CaptureExecGeneral/CEComplexReact.js";
import * as CEIconsReact from "../../CaptureExecGeneral/CEIconsReact.js";
import * as LibraryReact from "../../Library/LibraryReact.js";
import * as JSFUNC from "../../Library/JSFUNC.js";

import * as OpenCaptureReact from '../OpenCapture/OpenCaptureReact.js';

export const ProposalManagementToDo = inject("ProposalManagementMobx")(observer(
class ProposalManagementToDo extends Component {
  render() {
    return(
      <div className="flex11a displayFlexColumnHcVc">
        <div className="flex00a displayFlexColumnHcVc border bevelBorderColorBlue bgLighterBlueGradient hugeFullPad textCenter">
          <LibraryReact.DivFont p_class="smallBottomMargin" p_fontClass="font16">
            {"We are currently developing the Proposal Management Module."}
          </LibraryReact.DivFont>
          <LibraryReact.DivFont p_class="" p_fontClass="font12">
            {"We'll let you know as soon as it's available for use."}
          </LibraryReact.DivFont>
        </div>
      </div>
    );
  }
}));















//===========================================================================================================================================================
//===========================================================================================================================================================
//Currently Open Capture - Proposal Management
//===========================================================================================================================================================
//===========================================================================================================================================================

export const OpenCaptureProposalManagementCardSnapshot = inject("ProposalManagementMobx")(observer(
class OpenCaptureProposalManagementCardSnapshot extends Component {
  select_proposal_subtab_proposal_themes = () => {
    this.props.ProposalManagementMobx.a_set_proposal_selected_tab_db_name("proposalThemes");
  }

  select_proposal_subtab_proposal_management = () => {
    this.props.ProposalManagementMobx.a_set_proposal_selected_tab_db_name("proposalManagement");
  }

  render() {
    const c_ocptDifferentiatorsArrayOfObjs = this.props.ProposalManagementMobx.c_ocptDifferentiatorsArrayOfObjs;
    const c_ocptWinThemesArrayOfObjs = this.props.ProposalManagementMobx.c_ocptWinThemesArrayOfObjs;
    const c_ocptGhostThemesArrayOfObjs = this.props.ProposalManagementMobx.c_ocptGhostThemesArrayOfObjs;
    const c_ocpmOpenCaptureProposalDueDateTimeUtcCaptureFieldValueObj = this.props.ProposalManagementMobx.c_ocpmOpenCaptureProposalDueDateTimeUtcCaptureFieldValueObj;
    const c_ocpmTodayIsPastProposalDueDateTimeUtcTF = this.props.ProposalManagementMobx.c_ocpmTodayIsPastProposalDueDateTimeUtcTF;
    const c_ocpmExpandedProposalObjOrUndefined = this.props.ProposalManagementMobx.c_ocpmExpandedProposalObjOrUndefined;
    const c_aptThemeModulesArrayOfObjs = this.props.ProposalManagementMobx.c_aptThemeModulesArrayOfObjs;

    const numEntriesArray = [c_ocptDifferentiatorsArrayOfObjs.length, c_ocptWinThemesArrayOfObjs.length, c_ocptGhostThemesArrayOfObjs.length];

    const proposalProcessStartedTF = (c_ocpmExpandedProposalObjOrUndefined !== undefined);
    var snapshotProposalProcessBgClass = "";
    var snapshotProposalProcessTextComponent = null;
    if(!proposalProcessStartedTF) { //proposal process is not started
      snapshotProposalProcessBgClass = "";
      snapshotProposalProcessTextComponent = (
        <>
          <LibraryReact.DivFont p_class="" p_fontClass="fontPurple">{"Proposal Process"}</LibraryReact.DivFont>
          <LibraryReact.DivFont p_class="" p_fontClass="fontItalic fontTextLightester">{"--Not Yet Started--"}</LibraryReact.DivFont>
        </>
      );
    }
    else { //proposal process is started
      if(!c_ocpmTodayIsPastProposalDueDateTimeUtcTF) { //proposal is still active with the due date in the future
        snapshotProposalProcessBgClass = "bgLighterPurpleGradient";
        snapshotProposalProcessTextComponent = (
          <>
            <LibraryReact.DivFont p_class="" p_fontClass="fontPurple">{"Proposal Due"}</LibraryReact.DivFont>
            <LibraryReact.DivFont p_class="" p_fontClass="fontBold fontItalic fontPurple">{JSFUNC.convert_ce_datetimeutc_to_mysqldatelocal(c_ocpmOpenCaptureProposalDueDateTimeUtcCaptureFieldValueObj.valueRaw)}</LibraryReact.DivFont>
          </>
        );
      }
      else { //proposal due date has passed
        snapshotProposalProcessBgClass = "bgLighterGrayGradient";
        snapshotProposalProcessTextComponent = (
          <>
            <LibraryReact.DivFont p_class="" p_fontClass="fontPurple">{"Proposal Process"}</LibraryReact.DivFont>
            <LibraryReact.DivFont p_class="" p_fontClass="fontItalic fontTextLightester">{"--Not Yet Started--"}</LibraryReact.DivFont>
          </>
        );
      }
    }

    return(
      <div className="flex11a displayFlexRow">
        <div
          className="flex11a displayFlexColumn borderR1eee smallFullPad"
          style={{flexBasis:"100em"}}
          onClick={this.select_proposal_subtab_proposal_themes}>
          {c_aptThemeModulesArrayOfObjs.map((m_proposalThemeModualObj, m_index) =>
            (m_proposalThemeModualObj.usingModuleTF) &&
            <div key={m_proposalThemeModualObj.adminSwitchTblCompanyColumnDbName} className="flex11a displayFlexRowVc borderB1eee" style={{flexBasis:"100em"}}>
              <div className="flex00a lrMedMargin textRight" style={{flexBasis:"3em", color:"#" + m_proposalThemeModualObj.headerDarkBgColor}}>
                <LibraryReact.NowrapEllipsis p_fontClass="font20">
                  {numEntriesArray[m_index]}
                </LibraryReact.NowrapEllipsis>
              </div>
              <div className="flex11a" style={{color:"#" + m_proposalThemeModualObj.middleFontColor}}>
                <LibraryReact.NowrapEllipsis p_fontClass="font13 fontItalic">
                  {JSFUNC.plural(numEntriesArray[m_index], m_proposalThemeModualObj.singleItemName, m_proposalThemeModualObj.pluralItemsName)}
                </LibraryReact.NowrapEllipsis>
              </div>
            </div>
          )}
        </div>
        <div
          className={"flex11a displayFlexColumnHcVc " + snapshotProposalProcessBgClass + " smallFullPad textCenter"}
          style={{flexBasis:"100em"}}
          onClick={this.select_proposal_subtab_proposal_management}>
          {snapshotProposalProcessTextComponent}
        </div>
      </div>
    );
  }
}));


export const OpenCaptureProposalManagementCard = inject("CaptureExecMobx", "ProposalManagementMobx")(observer(
class OpenCaptureProposalManagementCard extends Component { //props: p_container
  onclick_proposal_tab = (i_tabDbName) => {
    this.props.ProposalManagementMobx.a_set_proposal_selected_tab_db_name(i_tabDbName);
  }

  render() {
    const p_container = this.props.p_container;

    const c_isMobileOrTabletTF = this.props.CaptureExecMobx.c_isMobileOrTabletTF;
    const o_proposalSelectedTabDbName = this.props.ProposalManagementMobx.o_proposalSelectedTabDbName;

    var openCaptureProposalCardSelectedTabContentComponent = null;
    if(o_proposalSelectedTabDbName === "proposalThemes") {
      openCaptureProposalCardSelectedTabContentComponent = (<OpenCaptureProposalCardProposalThemesTabContent p_container={p_container} />);
    }
    else if(o_proposalSelectedTabDbName === "proposalManagement") {
      openCaptureProposalCardSelectedTabContentComponent = (<OpenCaptureProposalCardProposalManagementTabContent p_container={p_container} />);
    }

    return(
      <>
        <div className="flex00a displayFlexRow borderB1bbb tbPad lrMedPad" style={{borderBottom:"", background:"#948d99"}}>
          <CEGeneralReact.TabsList
            p_tabDbNamesArray={["proposalThemes", "proposalManagement"]}
            p_tabDisplayNamesArray={["Proposal Themes", "Proposal Management"]}
            p_selectedTabDbName={o_proposalSelectedTabDbName}
            p_tabHeight="1.8em"
            p_textMaxHeight="1.7em"
            p_tabWidth={((c_isMobileOrTabletTF) ? (undefined) : ("25em"))}
            p_selectedBgClass="bgPurpleGradient"
            p_selectedFontClass="fontBold fontAlmostWhite"
            p_unselectedBgClass="bgLightGrayGradient hoverLighterBlueGradient"
            p_unselectedFontClass="fontBold fontTextLighter"
            f_onSelect={this.onclick_proposal_tab}
          />
        </div>
        {openCaptureProposalCardSelectedTabContentComponent}
      </>
    );
  }
}));



//------------------------------------------------------------------------------------------------------
//Open Capture Proposal Card - Proposal Themes Tab

const OpenCaptureProposalCardProposalThemesTabContent = inject("OpenCaptureMobx", "ProposalManagementMobx")(observer(
class OpenCaptureProposalCardProposalThemesTabContent extends Component { //props: p_container
  render() {
    const p_container = this.props.p_container;

    const c_aptThemeModulesArrayOfObjs = this.props.ProposalManagementMobx.c_aptThemeModulesArrayOfObjs;
    
    const proposalThemesIsVerticalTF = this.props.OpenCaptureMobx.proposal_themes_is_vertical_tf(p_container);

    return(
      <div className={"flex11a " + ((proposalThemesIsVerticalTF) ? ("yScroll yScrollBottomPad") : ("displayFlexRow"))}>
        {c_aptThemeModulesArrayOfObjs.map((m_proposalThemeModualObj) =>
          (m_proposalThemeModualObj.usingModuleTF) &&
          <div
            key={m_proposalThemeModualObj.adminSwitchTblCompanyColumnDbName}
            className={((proposalThemesIsVerticalTF) ? ("borderB1bbb hugeBottomPad") : ("flex11a displayFlexColumn borderR1bbb"))}
            style={{flexBasis:((proposalThemesIsVerticalTF) ? (undefined) : ("100em")), background:"#" + m_proposalThemeModualObj.bodyLightBgColor}}>
            <div className={((proposalThemesIsVerticalTF) ? ("smallBottomMargin") : ("flex00a borderB1eee")) + " smallFullPad"} style={{background:"#" + m_proposalThemeModualObj.headerDarkBgColor}}>
              <LibraryReact.NowrapEllipsis p_fontClass="font12 fontWhite">
                {m_proposalThemeModualObj.moduleName}
              </LibraryReact.NowrapEllipsis>
            </div>
            <div className={((proposalThemesIsVerticalTF) ? (undefined) : ("flex11a yScroll yScrollBottomPad smallTopPad lrPad"))}>
              {(m_proposalThemeModualObj.isDifferentiatorsTF) ? (
                <Differentiators p_container={p_container} />
              ) : (
                <ThemesTable p_container={p_container} p_winTrueGhostFalse={m_proposalThemeModualObj.isWinThemesTF} />
              )}
            </div>
          </div>
        )}
      </div>
    );
  }
}));



const Differentiators = inject("ProposalManagementMobx", "UserMobx")(observer(
class Differentiators extends Component { //props: p_container
  onclick_add_differentiator = () => {
    this.props.ProposalManagementMobx.a_ocpt_differentiators_set_id_adding_or_editing(-1);
  }

  onclose_add_new_differentiator = () => {
    this.props.ProposalManagementMobx.a_ocpt_differentiators_set_id_adding_or_editing(undefined);
  }

  render() {
    const p_container = this.props.p_container;
    
    const o_ocptDifferentiatorIDAddingOrEditing = this.props.ProposalManagementMobx.o_ocptDifferentiatorIDAddingOrEditing;
    const c_ocptDifferentiatorsArrayOfObjs = this.props.ProposalManagementMobx.c_ocptDifferentiatorsArrayOfObjs;
    const c_userCanEditCaptureCardContentTF = this.props.UserMobx.c_userCanEditCaptureCardContentTF;

    const addingDifferentiatorTF = (o_ocptDifferentiatorIDAddingOrEditing === -1);

    const numDifferentiators = c_ocptDifferentiatorsArrayOfObjs.length;
    const isOnlyItemTF = (numDifferentiators === 1);

    return(
      <>
        {(c_userCanEditCaptureCardContentTF) &&
          <div className="displayFlexColumnHcVc tbMargin">
            <CEGeneralReact.CEButton
              p_type="blue"
              p_text="Add a Differentiator"
              f_onClick={this.onclick_add_differentiator}
            />
            {(addingDifferentiatorTF) &&
              <DifferentiatorAddNewOrEditDifferentiatorFloatingBox
                p_editDifferentiatorObj={undefined}
                f_onClose={this.onclose_add_new_differentiator}
              />
            }
          </div>
        }
        {(numDifferentiators === 0) ? (
          <LibraryReact.DivFont p_class="tbMedMargin textCenter" p_fontClass="fontItalic fontTextLighter">
            {"No Differentiators Added Yet"}
          </LibraryReact.DivFont>
        ) : (
          <div className="flex11a yScroll yScrollBottomPad">
            {c_ocptDifferentiatorsArrayOfObjs.map((m_differentiatorObj, m_index) =>
              <DifferentiatorItem
                key={m_differentiatorObj.id}
                p_container={p_container}
                p_differentiatorObj={m_differentiatorObj}
                p_isOnlyItemTF={isOnlyItemTF}
                p_isLastItemTF={(m_index === (numDifferentiators - 1))}
              />
            )}
          </div>
        )}
      </>
    );
  }
}));

const DifferentiatorItem = inject("OpenCaptureMobx", "ProposalManagementMobx", "UserMobx")(observer(
class DifferentiatorItem extends Component { //props: p_container, p_differentiatorObj, p_isOnlyItemTF, p_isLastItemTF
  onclick_edit_differentiator = () => {
    const p_differentiatorObj = this.props.p_differentiatorObj;
    this.props.ProposalManagementMobx.a_ocpt_differentiators_set_id_adding_or_editing(p_differentiatorObj.id);
  }

  onclose_edit_differentiator = () => {
    this.props.ProposalManagementMobx.a_ocpt_differentiators_set_id_adding_or_editing(undefined);
  }

  ondelete_differentiator = () => {
    const p_differentiatorObj = this.props.p_differentiatorObj;
    const o_openCaptureID = this.props.OpenCaptureMobx.o_openCaptureID;
    this.props.ProposalManagementMobx.a_ocpt_differentiators_delete_differentiator(o_openCaptureID, p_differentiatorObj);
  }

  render() {
    const p_container = this.props.p_container
    const p_differentiatorObj = this.props.p_differentiatorObj;
    const p_isOnlyItemTF = this.props.p_isOnlyItemTF;
    const p_isLastItemTF = this.props.p_isLastItemTF;

    const o_openCaptureID = this.props.OpenCaptureMobx.o_openCaptureID;
    const o_ocptDifferentiatorIDAddingOrEditing = this.props.ProposalManagementMobx.o_ocptDifferentiatorIDAddingOrEditing;
    const c_userCanEditCaptureCardContentTF = this.props.UserMobx.c_userCanEditCaptureCardContentTF;

    const editingDifferentiatorTF = (o_ocptDifferentiatorIDAddingOrEditing === p_differentiatorObj.id);
    const justificationIsFilledOutTF = JSFUNC.text_or_number_is_filled_out_tf(p_differentiatorObj.justification);

    const differentiatorItemHeight = "8.6em";

    return(
      <>
        <CEGeneralReact.CEDragToResortItemWithinDbTbl
          p_canResortTF={c_userCanEditCaptureCardContentTF}
          p_uniqueString="differentiators"
          p_itemID={p_differentiatorObj.id}
          p_itemSort={p_differentiatorObj.sort}
          p_itemSortColumnWidth={undefined}
          p_itemSortNumberFontClass={undefined}
          p_isOnlyItemTF={p_isOnlyItemTF}
          p_isLastItemTF={p_isLastItemTF}
          p_outerPadClass="medTopPad lrMedPad"
          p_itemClass="smallFullPad border1ddd bgLightestBlue hoverLighterBlueGradient"
          p_itemStyleObj={{height:differentiatorItemHeight, borderRadius:"3em"}}
          p_lastItemExtraDropZoneHeight={differentiatorItemHeight}
          p_dragEntireItemTrueOnlySortNumberFalse={true}
          p_tblName="tbl_c_pt_differentiators"
          p_tblSortFieldDbName="sort"
          p_filterFieldNamesArray={["capture_id"]}
          p_filterValuesArray={[o_openCaptureID]}>
          <div className="flex11a displayFlexRow cursorPointer" onClick={this.onclick_edit_differentiator}>
            <div className="flex11a displayFlexRowVc lrMargin" style={{flexBasis:"100em"}}>
              <LibraryReact.MaxHeightWrap p_maxHeight="6em">
                {p_differentiatorObj.differentiatorNameValueMaskSortIfoObj.valueMask}
              </LibraryReact.MaxHeightWrap>
            </div>
            <div className="flex11a displayFlexColumn tbMargin lrPad bgAlmostWhite border bevelBorderColors" style={{flexBasis:"250em", borderRadius:"0.4em"}}>
              <div className="flex00a textCenter">
                <LibraryReact.NowrapEllipsis p_fontClass="fontItalic fontTextLighter">
                  {"Justification"}
                </LibraryReact.NowrapEllipsis>
              </div>
              <div className="flex11a displayFlexRowVc">
                <LibraryReact.MaxHeightWrap p_maxHeight="5.3em" p_fontClass={((justificationIsFilledOutTF) ? ("") : ("fontItalic fontTextLighter"))}>
                  {((justificationIsFilledOutTF) ? (p_differentiatorObj.justification) : ("--No Text Entered--"))}
                </LibraryReact.MaxHeightWrap>
              </div>
            </div>
          </div>
          <div className="flex00a displayFlexColumnHcVc" style={{flexBasis:"1.5em", marginLeft:"0.3em"}}>
            {(c_userCanEditCaptureCardContentTF) &&
              <CEGeneralReact.DeleteMenu
                p_message={"Are you sure you want to remove this Differentiator?\n\n'" + p_differentiatorObj.differentiatorNameValueMaskSortIfoObj.valueMaskPlainText + "'"}
                f_onDelete={this.ondelete_differentiator}
              />
            }
          </div>
        </CEGeneralReact.CEDragToResortItemWithinDbTbl>
        {(editingDifferentiatorTF) &&
          <DifferentiatorAddNewOrEditDifferentiatorFloatingBox
            p_editDifferentiatorObj={p_differentiatorObj}
            f_onClose={this.onclose_edit_differentiator}
          />
        }
      </>
    );
  }
}));

const DifferentiatorAddNewOrEditDifferentiatorFloatingBox = inject("CaptureExecMobx", "OpenCaptureMobx", "ProposalManagementMobx", "DatabaseMobx", "UserMobx")(observer(
class DifferentiatorAddNewOrEditDifferentiatorFloatingBox extends Component { //props: p_editDifferentiatorObj, f_onClose
  constructor(props) {
    super(props);

    const p_editDifferentiatorObj = this.props.p_editDifferentiatorObj;

    var differentiator = -1; //initialization for a new differentiator
    var justification = "";
    if(p_editDifferentiatorObj !== undefined) { //editing an existing differentiator obj if it is provided (if not provided, creating a new differentiator)
      differentiator = p_editDifferentiatorObj.differentiator_id;
      justification = p_editDifferentiatorObj.justification;
    }

    this.state = {
      s_initDifferentiator: differentiator,
      s_initJustification: justification,
      s_updatedDifferentiator: differentiator,
      s_updatedJustification: justification
    }
  }

  onsave_differentiator_item = () => {
    const s_initDifferentiator = this.state.s_initDifferentiator;
    const s_initJustification = this.state.s_initJustification;
    const s_updatedDifferentiator = this.state.s_updatedDifferentiator;
    const s_updatedJustification = this.state.s_updatedJustification;

    const p_editDifferentiatorObj = this.props.p_editDifferentiatorObj;

    const o_openCaptureID = this.props.OpenCaptureMobx.o_openCaptureID;

    if(p_editDifferentiatorObj === undefined) { //adding a new item
      this.props.ProposalManagementMobx.a_ocpt_differentiators_insert_new_differentiator(o_openCaptureID, s_updatedDifferentiator, s_updatedJustification);
    }
    else { //editing an item
      var newDifferentiator = ((s_updatedDifferentiator !== s_initDifferentiator) ? (s_updatedDifferentiator) : (undefined));
      var newJustification = ((s_updatedJustification !== s_initJustification) ? (s_updatedJustification) : (undefined));
      this.props.ProposalManagementMobx.a_ocpt_differentiators_update_differentiator(o_openCaptureID, p_editDifferentiatorObj.id, newDifferentiator, newJustification);
    }

    if(JSFUNC.is_function(this.props.f_onClose)) {
      this.props.f_onClose();
    }
  }

  oncancel_differentiator_item = () => {
    if(JSFUNC.is_function(this.props.f_onClose)) {
      this.props.f_onClose();
    }
  }
  onchange_differentiator = (i_newValue) => { this.setState({s_updatedDifferentiator:i_newValue}); }
  onchange_justification = (i_newValue) => { this.setState({s_updatedJustification:i_newValue}); }

  render() {
    const s_initDifferentiator = this.state.s_initDifferentiator;
    const s_initJustification = this.state.s_initJustification;
    const s_updatedDifferentiator = this.state.s_updatedDifferentiator;
    const s_updatedJustification = this.state.s_updatedJustification;

    const p_editDifferentiatorObj = this.props.p_editDifferentiatorObj;

    const c_isMobileOrTabletTF = this.props.CaptureExecMobx.c_isMobileOrTabletTF;
    const c_ocptDifferentiatorIDsAlreadyAddedArray = this.props.ProposalManagementMobx.c_ocptDifferentiatorIDsAlreadyAddedArray;
    const c_genericTextareaFieldTypeObj = this.props.DatabaseMobx.c_genericTextareaFieldTypeObj;
    const c_selectAddPTDifferentiatorsFieldTypeObj = this.props.DatabaseMobx.c_selectAddPTDifferentiatorsFieldTypeObj;
    const c_userCanEditCaptureCardContentTF = this.props.UserMobx.c_userCanEditCaptureCardContentTF;

    const isAddingNewDifferentiatorTF = (p_editDifferentiatorObj === undefined);
    const anyFieldIsUpdatedTF = ((s_initDifferentiator !== s_updatedDifferentiator) || (s_initJustification !== s_updatedJustification));

    var differentiatorIDsToNotIncludeArray = undefined;
    if(isAddingNewDifferentiatorTF) {
      differentiatorIDsToNotIncludeArray = c_ocptDifferentiatorIDsAlreadyAddedArray;
    }
    else {
      differentiatorIDsToNotIncludeArray = JSFUNC.remove_all_values_from_array(p_editDifferentiatorObj.differentiator_id, c_ocptDifferentiatorIDsAlreadyAddedArray);
    }

    var differentiatorComponent = null;
    var justificationComponent = null;
    if(c_userCanEditCaptureCardContentTF) {
      differentiatorComponent = (
        <CEGeneralReact.GenericInputOrSelectFromInputType
          p_fieldTypeObj={c_selectAddPTDifferentiatorsFieldTypeObj}
          p_valueRaw={s_updatedDifferentiator}
          p_valuesToNotIncludeArray={differentiatorIDsToNotIncludeArray}
          p_tabIndex={2}
          f_onChangeOrOnSelect={this.onchange_differentiator}
        />
      );
  
      justificationComponent = (
        <CEGeneralReact.GenericInputOrSelectFromInputType
          p_fieldTypeObj={c_genericTextareaFieldTypeObj}
          p_valueRaw={s_updatedJustification}
          p_tabIndex={1}
          f_onChangeOrOnSelect={this.onchange_justification}
        />
      );
    }
    else {
      differentiatorComponent = this.props.DatabaseMobx.value_mask_from_value_raw_and_field_type_obj(s_updatedDifferentiator, c_selectAddPTDifferentiatorsFieldTypeObj);

      justificationComponent = (
        <LibraryReact.DivFont p_class="flex11a border1bbb bgWhite smallFullPad yScroll" p_fontClass="">
          {s_updatedJustification}
        </LibraryReact.DivFont>
      );
    }

    var floatingBoxContentComponent = null;
    if(c_isMobileOrTabletTF) {
      floatingBoxContentComponent = (
        <div className="flex11a yScroll yScrollBottomPad">
          <LibraryReact.DivFont p_class="bigTopMargin microBottomMargin lrMargin" p_fontClass="font11 fontBlue">
            {"Differentiator"}
          </LibraryReact.DivFont>
          <LibraryReact.DivFont p_class="flex11a displayFlexColumn lrMargin" p_styleObj={{height:"15em"}}>
            {differentiatorComponent}
          </LibraryReact.DivFont>
          <LibraryReact.DivFont p_class="bigTopMargin microBottomMargin lrMargin" p_fontClass="font11 fontBlue">
            {"Justification"}
          </LibraryReact.DivFont>
          <LibraryReact.DivFont p_class="flex11a displayFlexColumn lrMargin" p_styleObj={{height:"15em"}}>
            {justificationComponent}
          </LibraryReact.DivFont>
        </div>
      );
    }
    else {
      floatingBoxContentComponent = (
        <div className="flex11a displayFlexRow">
          <div className="flex11a displayFlexColumn medFullPad" style={{flexBasis:"100em", borderRight:"solid 1px #eee"}}>
            <LibraryReact.DivFont p_class="flex00a microBottomMargin" p_fontClass="font11 fontBlue">
              {"Differentiator"}
            </LibraryReact.DivFont>
            {differentiatorComponent}
          </div>
          <div className="flex11a displayFlexColumn medFullPad" style={{flexBasis:"200em"}}>
            <LibraryReact.DivFont p_class="flex00a microBottomMargin" p_fontClass="font11 fontBlue">
              {"Justification"}
            </LibraryReact.DivFont>
            {justificationComponent}
          </div>
        </div>
      );
    }

    return(
      <CEGeneralReact.FloatingBoxWithSaveCancel
        p_trblFlag="themes"
        p_title={((isAddingNewDifferentiatorTF) ? ("Adding New Differentiator"): ("Editing Differentiator"))}
        p_cancelConfirmationMessage={((anyFieldIsUpdatedTF) ? ("Are you sure you want to cancel editing this Differentiator? Any entered data will be lost.") : (undefined))}
        f_onClickSave={((c_userCanEditCaptureCardContentTF) ? (this.onsave_differentiator_item) : (undefined))}
        f_onClickCancel={this.oncancel_differentiator_item}>
        {floatingBoxContentComponent}
      </CEGeneralReact.FloatingBoxWithSaveCancel>
    );
  }
}));





const ThemesTable = inject("ProposalManagementMobx", "UserMobx")(observer(
class ThemesTable extends Component { //props: p_container, p_winTrueGhostFalse
  onclick_add_theme = () => {
    if(this.props.p_winTrueGhostFalse) {
      this.props.ProposalManagementMobx.a_ocpt_win_themes_set_id_adding_or_editing(-1);
    }
    else {
      this.props.ProposalManagementMobx.a_ocpt_ghost_themes_set_id_adding_or_editing(-1);
    }
  }

  onclose_add_new_theme = () => {
    if(this.props.p_winTrueGhostFalse) {
      this.props.ProposalManagementMobx.a_ocpt_win_themes_set_id_adding_or_editing(undefined);
    }
    else {
      this.props.ProposalManagementMobx.a_ocpt_ghost_themes_set_id_adding_or_editing(undefined);
    }
  }

  render() {
    const p_container = this.props.p_container;
    const p_winTrueGhostFalse = this.props.p_winTrueGhostFalse;

    const o_ocptWinThemeIDAddingOrEditing = this.props.ProposalManagementMobx.o_ocptWinThemeIDAddingOrEditing;
    const o_ocptGhostThemeIDAddingOrEditing = this.props.ProposalManagementMobx.o_ocptGhostThemeIDAddingOrEditing;
    const c_ocptWinThemesArrayOfObjs = this.props.ProposalManagementMobx.c_ocptWinThemesArrayOfObjs;
    const c_ocptGhostThemesArrayOfObjs = this.props.ProposalManagementMobx.c_ocptGhostThemesArrayOfObjs;
    const c_userCanEditCaptureCardContentTF = this.props.UserMobx.c_userCanEditCaptureCardContentTF;

    const addingThemeTF = ((p_winTrueGhostFalse) ? (o_ocptWinThemeIDAddingOrEditing === -1) : (o_ocptGhostThemeIDAddingOrEditing === -1));
    const themesArrayOfObjs = ((p_winTrueGhostFalse) ? (c_ocptWinThemesArrayOfObjs) : (c_ocptGhostThemesArrayOfObjs));
    const winGhostString = ((p_winTrueGhostFalse) ? ("Win") : ("Ghost"));

    const numThemes = themesArrayOfObjs.length;
    const isOnlyItemTF = (numThemes === 1);

    return(
      <>
        {(c_userCanEditCaptureCardContentTF) &&
          <div className="displayFlexColumnHcVc tbMargin">
            <CEGeneralReact.CEButton
              p_type="blue"
              p_text={"Add a " + winGhostString + " Theme"}
              f_onClick={this.onclick_add_theme}
            />
            {(addingThemeTF) &&
              <ThemeAddNewOrEditThemeFloatingBox
                p_winTrueGhostFalse={p_winTrueGhostFalse}
                p_editThemeObj={undefined}
                f_onClose={this.onclose_add_new_theme}
              />
            }
          </div>
        }
        {(numThemes === 0) ? (
          <LibraryReact.DivFont p_class="tbMedMargin textCenter" p_fontClass="fontItalic fontTextLighter">
            {"No " + winGhostString + " Themes Written Yet"}
          </LibraryReact.DivFont>
        ) : (
          <div className="flex11a yScroll yScrollBottomPad">
            {themesArrayOfObjs.map((m_themeObj, m_index) =>
              <ThemeItem
                key={m_themeObj.id}
                p_container={p_container}
                p_winTrueGhostFalse={p_winTrueGhostFalse}
                p_themeObj={m_themeObj}
                p_isOnlyItemTF={isOnlyItemTF}
                p_isLastItemTF={(m_index === (numThemes - 1))}
              />
            )}
          </div>
        )}
      </>
    );
  }
}));

const ThemeItem = inject("OpenCaptureMobx", "ProposalManagementMobx", "UserMobx")(observer(
class ThemeItem extends Component { //props: p_container, p_winTrueGhostFalse, p_themeObj, p_isOnlyItemTF, p_isLastItemTF
  onclick_edit_theme = () => {
    const p_winTrueGhostFalse = this.props.p_winTrueGhostFalse;
    const p_themeObj = this.props.p_themeObj;
    if(p_winTrueGhostFalse) {
      this.props.ProposalManagementMobx.a_ocpt_win_themes_set_id_adding_or_editing(p_themeObj.id);
    }
    else {
      this.props.ProposalManagementMobx.a_ocpt_ghost_themes_set_id_adding_or_editing(p_themeObj.id);
    }
  }

  onclose_edit_theme = () => {
    const p_winTrueGhostFalse = this.props.p_winTrueGhostFalse;
    if(p_winTrueGhostFalse) {
      this.props.ProposalManagementMobx.a_ocpt_win_themes_set_id_adding_or_editing(undefined);
    }
    else {
      this.props.ProposalManagementMobx.a_ocpt_ghost_themes_set_id_adding_or_editing(undefined);
    }
  }

  ondelete_theme = () => {
    const p_winTrueGhostFalse = this.props.p_winTrueGhostFalse;
    const p_themeObj = this.props.p_themeObj;
    const o_openCaptureID = this.props.OpenCaptureMobx.o_openCaptureID;
    this.props.ProposalManagementMobx.a_ocpt_themes_delete_theme(o_openCaptureID, p_winTrueGhostFalse, p_themeObj);
  }

  render() {
    const p_container = this.props.p_container;
    const p_winTrueGhostFalse = this.props.p_winTrueGhostFalse;
    const p_themeObj = this.props.p_themeObj;
    const p_isOnlyItemTF = this.props.p_isOnlyItemTF;
    const p_isLastItemTF = this.props.p_isLastItemTF;

    const o_openCaptureID = this.props.OpenCaptureMobx.o_openCaptureID;
    const o_ocptWinThemeIDAddingOrEditing = this.props.ProposalManagementMobx.o_ocptWinThemeIDAddingOrEditing;
    const o_ocptGhostThemeIDAddingOrEditing = this.props.ProposalManagementMobx.o_ocptGhostThemeIDAddingOrEditing;
    const c_userCanEditCaptureCardContentTF = this.props.UserMobx.c_userCanEditCaptureCardContentTF;

    const editingThemeTF = ((p_winTrueGhostFalse) ? (o_ocptWinThemeIDAddingOrEditing === p_themeObj.id) : (o_ocptGhostThemeIDAddingOrEditing === p_themeObj.id));
    const tblName = ((p_winTrueGhostFalse) ? ("tbl_c_pt_win_themes") : ("tbl_c_pt_ghost_themes"));
    const winGhostString = ((p_winTrueGhostFalse) ? ("Win") : ("Ghost"));

    const themeItemHeight = "10em";

    return(
      <>
        <CEGeneralReact.CEDragToResortItemWithinDbTbl
          p_canResortTF={c_userCanEditCaptureCardContentTF}
          p_uniqueString="themes"
          p_itemID={p_themeObj.id}
          p_itemSort={p_themeObj.sort}
          p_itemSortColumnWidth={undefined}
          p_itemSortNumberFontClass={undefined}
          p_isOnlyItemTF={p_isOnlyItemTF}
          p_isLastItemTF={p_isLastItemTF}
          p_outerPadClass="medTopPad lrMedPad"
          p_itemClass="smallFullPad bgWhite hoverLighterBlueGradient"
          p_itemStyleObj={{height:themeItemHeight, border:"solid 1px #ddd", borderRadius:"0.5em"}}
          p_lastItemExtraDropZoneHeight={themeItemHeight}
          p_dragEntireItemTrueOnlySortNumberFalse={true}
          p_tblName={tblName}
          p_tblSortFieldDbName="sort"
          p_filterFieldNamesArray={["capture_id"]}
          p_filterValuesArray={[o_openCaptureID]}>
          <div className="flex11a displayFlexRow cursorPointer" onClick={this.onclick_edit_theme}>
            <ThemeTextarea p_label={winGhostString + " Theme"} p_text={p_themeObj.theme} />
            <ThemeTextarea p_label="Justification" p_text={p_themeObj.justification} />
          </div>
          <div className="flex00a displayFlexColumnHcVc" style={{flexBasis:"1.5em", marginLeft:"0.3em"}}>
            {(c_userCanEditCaptureCardContentTF) &&
              <CEGeneralReact.DeleteMenu
                p_message={"Are you sure you want to remove this Theme?\n\n'" + p_themeObj.theme + "'"}
                f_onDelete={this.ondelete_theme}
              />
            }
          </div>
        </CEGeneralReact.CEDragToResortItemWithinDbTbl>
        {(editingThemeTF) &&
          <ThemeAddNewOrEditThemeFloatingBox
            p_winTrueGhostFalse={p_winTrueGhostFalse}
            p_editThemeObj={p_themeObj}
            f_onClose={this.onclose_edit_theme}
          />
        }
      </>
    );
  }
}));

function ThemeTextarea(props) { //props: p_label, p_text
  const p_label = props.p_label;
  const p_text = props.p_text;

  const themeTextIsFilledOutTF = JSFUNC.text_or_number_is_filled_out_tf(p_text);

  return(
    <div className="flex11a displayFlexColumn lrPad" style={{flexBasis:"100em", borderRight:"solid 1px #eee"}}>
      <div className="flex00a textCenter">
        <LibraryReact.NowrapEllipsis p_fontClass="fontItalic fontTextLighter">
          {p_label}
        </LibraryReact.NowrapEllipsis>
      </div>
      <div className="flex11a displayFlexRowVc microTopMargin">
        <LibraryReact.MaxHeightWrap p_maxHeight="7.7em" p_fontClass={((themeTextIsFilledOutTF) ? ("") : ("fontItalic fontTextLighter"))}>
          {((themeTextIsFilledOutTF) ? (p_text) : ("--No Text Entered--"))}
        </LibraryReact.MaxHeightWrap>
      </div>
    </div>
  );
}

const ThemeAddNewOrEditThemeFloatingBox = inject("CaptureExecMobx", "OpenCaptureMobx", "ProposalManagementMobx", "DatabaseMobx", "UserMobx")(observer(
class ThemeAddNewOrEditThemeFloatingBox extends Component { //props: p_winTrueGhostFalse, p_editThemeObj, f_onClose
  constructor(props) {
    super(props);

    const p_editThemeObj = this.props.p_editThemeObj;

    var theme = ""; //initialization for a new theme
    var justification = "";
    if(p_editThemeObj !== undefined) { //editing an existing theme obj if it is provided (if not provided, creating a new theme)
      theme = p_editThemeObj.theme;
      justification = p_editThemeObj.justification;
    }

    this.state = {
      s_initTheme: theme,
      s_initJustification: justification,
      s_updatedTheme: theme,
      s_updatedJustification: justification
    }
  }

  onsave_theme_item = () => {
    const s_initTheme = this.state.s_initTheme;
    const s_initJustification = this.state.s_initJustification;
    const s_updatedTheme = this.state.s_updatedTheme;
    const s_updatedJustification = this.state.s_updatedJustification;

    const p_winTrueGhostFalse = this.props.p_winTrueGhostFalse;
    const p_editThemeObj = this.props.p_editThemeObj;

    const o_openCaptureID = this.props.OpenCaptureMobx.o_openCaptureID;

    if(p_editThemeObj === undefined) { //adding a new item
      this.props.ProposalManagementMobx.a_ocpt_themes_insert_new_theme(o_openCaptureID, p_winTrueGhostFalse, s_updatedTheme, s_updatedJustification);
    }
    else { //editing an item

      var newTheme = ((s_updatedTheme !== s_initTheme) ? (s_updatedTheme) : (undefined));
      var newJustification = ((s_updatedJustification !== s_initJustification) ? (s_updatedJustification) : (undefined));
      this.props.ProposalManagementMobx.a_ocpt_themes_update_theme(o_openCaptureID, p_winTrueGhostFalse, p_editThemeObj.id, newTheme, newJustification);
    }

    if(JSFUNC.is_function(this.props.f_onClose)) {
      this.props.f_onClose();
    }
  }

  oncancel_theme_item = () => {
    if(JSFUNC.is_function(this.props.f_onClose)) {
      this.props.f_onClose();
    }
  }
  onchange_theme = (i_newValue) => { this.setState({s_updatedTheme:i_newValue}); }
  onchange_justification = (i_newValue) => { this.setState({s_updatedJustification:i_newValue}); }

  render() {
    const s_initTheme = this.state.s_initTheme;
    const s_initJustification = this.state.s_initJustification;
    const s_updatedTheme = this.state.s_updatedTheme;
    const s_updatedJustification = this.state.s_updatedJustification;

    const p_winTrueGhostFalse = this.props.p_winTrueGhostFalse;
    const p_editThemeObj = this.props.p_editThemeObj;

    const c_isMobileOrTabletTF = this.props.CaptureExecMobx.c_isMobileOrTabletTF;
    const c_userCanEditCaptureCardContentTF = this.props.UserMobx.c_userCanEditCaptureCardContentTF;

    const isAddingNewThemeTF = (p_editThemeObj === undefined);
    const anyFieldIsUpdatedTF = ((s_initTheme !== s_updatedTheme) || (s_initJustification !== s_updatedJustification));

    const winGhostString = ((p_winTrueGhostFalse) ? ("Win") : ("Ghost"));

    var themeComponent = null;
    var justificationComponent = null;
    if(c_userCanEditCaptureCardContentTF) {
      themeComponent = (
        <CEGeneralReact.GenericInputOrSelectFromInputType
          p_fieldTypeObj={this.props.DatabaseMobx.c_genericTextareaFieldTypeObj}
          p_valueRaw={s_updatedTheme}
          p_tabIndex={1}
          f_onChangeOrOnSelect={this.onchange_theme}
        />
      );
  
      justificationComponent = (
        <CEGeneralReact.GenericInputOrSelectFromInputType
          p_fieldTypeObj={this.props.DatabaseMobx.c_genericTextareaFieldTypeObj}
          p_valueRaw={s_updatedJustification}
          p_tabIndex={2}
          f_onChangeOrOnSelect={this.onchange_justification}
        />
      );
    }
    else {
      themeComponent = (
        <LibraryReact.DivFont p_class="flex11a border1bbb bgWhite smallFullPad yScroll" p_fontClass="">
          {s_updatedTheme}
        </LibraryReact.DivFont>
      );

      justificationComponent = (
        <LibraryReact.DivFont p_class="flex11a border1bbb bgWhite smallFullPad yScroll" p_fontClass="">
          {s_updatedJustification}
        </LibraryReact.DivFont>
      );
    }

    var floatingBoxContentComponent = null;
    if(c_isMobileOrTabletTF) {
      floatingBoxContentComponent = (
        <div className="flex11a yScroll yScrollBottomPad">
          <LibraryReact.DivFont p_class="bigTopMargin microBottomMargin lrMargin" p_fontClass="font11 fontBlue">
            {winGhostString + " Theme"}
          </LibraryReact.DivFont>
          <LibraryReact.DivFont p_class="flex11a displayFlexColumn lrMargin" p_styleObj={{height:"15em"}}>
            {themeComponent}
          </LibraryReact.DivFont>
          <LibraryReact.DivFont p_class="bigTopMargin microBottomMargin lrMargin" p_fontClass="font11 fontBlue">
            {"Justification"}
          </LibraryReact.DivFont>
          <LibraryReact.DivFont p_class="flex11a displayFlexColumn lrMargin" p_styleObj={{height:"15em"}}>
            {justificationComponent}
          </LibraryReact.DivFont>
        </div>
      );
    }
    else {
      floatingBoxContentComponent = (
        <div className="flex11a displayFlexRow">
          <div className="flex11a displayFlexColumn medFullPad" style={{flexBasis:"100em", borderRight:"solid 1px #eee"}}>
            <LibraryReact.DivFont p_class="flex00a microBottomMargin" p_fontClass="font11 fontBlue">
              {winGhostString + " Theme"}
            </LibraryReact.DivFont>
            {themeComponent}
          </div>
          <div className="flex11a displayFlexColumn medFullPad" style={{flexBasis:"100em"}}>
            <LibraryReact.DivFont p_class="flex00a microBottomMargin" p_fontClass="font11 fontBlue">
              {"Justification"}
            </LibraryReact.DivFont>
            {justificationComponent}
          </div>
        </div>
      );
    }

    return(
      <CEGeneralReact.FloatingBoxWithSaveCancel
        p_trblFlag="themes"
        p_title={((isAddingNewThemeTF) ? ("Adding New " + winGhostString + " Theme"): ("Editing " + winGhostString + " Theme"))}
        p_cancelConfirmationMessage={((anyFieldIsUpdatedTF) ? ("Are you sure you want to cancel editing this Theme? Any entered data will be lost.") : (undefined))}
        f_onClickSave={((c_userCanEditCaptureCardContentTF) ? (this.onsave_theme_item) : (undefined))}
        f_onClickCancel={this.oncancel_theme_item}>
        {floatingBoxContentComponent}
      </CEGeneralReact.FloatingBoxWithSaveCancel>
    );
  }
}));











//------------------------------------------------------------------------------------------------------
//Open Capture Proposal Card - Proposal Management Tab
const OpenCaptureProposalCardProposalManagementTabContent = inject("OpenCaptureMobx", "ProposalManagementMobx")(observer(
class OpenCaptureProposalCardProposalManagementTabContent extends Component { //props: p_container
  render() {
    const p_container = this.props.p_container;

    const c_ocpmExpandedProposalObjOrUndefined = this.props.ProposalManagementMobx.c_ocpmExpandedProposalObjOrUndefined;

    if(c_ocpmExpandedProposalObjOrUndefined === undefined) {
      return(
        <OpenCaptureProposalRecordNotYetCreatedProcess p_container={p_container} />
      );
    }
    
    return(
      <OpenCaptureProposalManagement p_expandedProposalObj={c_ocpmExpandedProposalObjOrUndefined} />
    );
  }
}));


const OpenCaptureProposalRecordNotYetCreatedProcess = inject("OpenCaptureMobx", "ProposalManagementMobx", "DatabaseMobx")(observer(
class OpenCaptureProposalRecordNotYetCreatedProcess extends Component { //props: p_container
  render() {
    const p_container = this.props.p_container;
    
    const proposalManagementIsVerticalTF = this.props.OpenCaptureMobx.proposal_management_is_vertical_tf(p_container);

    const dividerBorderColor = "aaaaaa";
    const requestProposalManagerCardWidthEm = 35;

    var createProposalProcessComponent = null;
    if(proposalManagementIsVerticalTF) { //vertical screen
      createProposalProcessComponent = (
        <>
          <div className="flex00a displayFlexColumn">
            <CreateProposalRequestProposalManager />
          </div>
          <div className="flex00a tbHugeMargin" style={{border:"solid 1px #" + dividerBorderColor}} />
          <div className="flex00a displayFlexColumn">
            <CreateProposalSelectProposalManager />
          </div>
        </>
      );
    }
    else { //horizontal
      createProposalProcessComponent = (
        <div className="displayFlexColumnHcVc">
          <div className="flex00a displayFlexRow">
            <div className="flex00a displayFlexColumn" style={{flexBasis:requestProposalManagerCardWidthEm + "em"}}>
              <CreateProposalRequestProposalManager />
            </div>
            <div className="flex00a lrHugeMargin" style={{borderRight:"solid 1px #" + dividerBorderColor}} />
            <div className="flex00a displayFlexColumn" style={{flexBasis:requestProposalManagerCardWidthEm + "em"}}>
              <CreateProposalSelectProposalManager />
            </div>
          </div>
        </div>
      );
    }


    return(
      <div className="flex11a displayFlexColumn yScroll medFullPad">
        <LibraryReact.DivFont p_class="medBottomMargin textCenter" p_fontClass="font12 fontItalic fontTextLighter">
          {"Proposal Process Not Started Yet for this Capture"}
        </LibraryReact.DivFont>
        {createProposalProcessComponent}
      </div>
    );
  }
}));


const CreateProposalRequestProposalManager = inject("ProposalManagementMobx")(observer(
class CreateProposalRequestProposalManager extends Component {
  onclick_request_proposal_manager_assignment = () => {
    this.props.ProposalManagementMobx.a_ocpm_insert_proposal(-1, true);
  }

  render() {
    return(
      <div className="flex11a displayFlexColumn border1bbb borderRadius05 bgLightesterGray hugeFullPad">
        <LibraryReact.DivFont p_class="textCenter" p_fontClass="fontItalic fontTextLight">
          <span className="fontBold">{"Option 1: "}</span>{"Start the Proposal process by requesting a Proposal Manager to be Assigned to this Capture"}
        </LibraryReact.DivFont>
        <div className="flex00a displayFlexColumnHcVc medTopMargin">
          <CEGeneralReact.CEButton
            p_text="Request Proposal Manager Assignment"
            p_type="blue"
            f_onClick={this.onclick_request_proposal_manager_assignment}
          />
        </div>
      </div>
    );
  }
}));


const CreateProposalSelectProposalManager = inject("ProposalManagementMobx", "DatabaseMobx")(observer(
class CreateProposalSelectProposalManager extends Component {
  constructor(props) {
    super(props);
    this.state = {
      s_selectedProposalManagerUserID: -1
    }
  }

  onselect_proposal_manager = (i_selectedUserID) => {
    this.setState({s_selectedProposalManagerUserID:i_selectedUserID});
  }

  onclick_confirm_selected_proposal_manager = () => {
    const s_selectedProposalManagerUserID = this.state.s_selectedProposalManagerUserID;
    this.props.ProposalManagementMobx.a_ocpm_insert_proposal(s_selectedProposalManagerUserID, false);
  }

  render() {
    const s_selectedProposalManagerUserID = this.state.s_selectedProposalManagerUserID;

    const c_selectUserWithProposalPowerFieldTypeObj = this.props.DatabaseMobx.c_selectUserWithProposalPowerFieldTypeObj;

    return(
      <div className="flex11a displayFlexColumn border1bbb borderRadius05 bgLightesterGray hugeFullPad">
        <LibraryReact.DivFont p_class="textCenter" p_fontClass="fontItalic fontTextLight">
          <span className="fontBold">{"Option 2: "}</span>{"Select a Proposal Manager from the list of users to start the Proposal process for this Capture. You can leave it blank for now and assign a Proposal Manager later if you want."}
        </LibraryReact.DivFont>
        <div className="flex00a displayFlexColumn medTopMargin">
          <CEGeneralReact.GenericInputOrSelectFromInputType
            p_fieldTypeObj={c_selectUserWithProposalPowerFieldTypeObj}
            p_valueRaw={s_selectedProposalManagerUserID}
            f_onChangeOrOnSelect={this.onselect_proposal_manager}
          />
        </div>
        <div className="flex00a displayFlexColumnHcVc medTopMargin">
          <CEGeneralReact.CEButton
            p_text="Select Proposal Manager"
            p_type="blue"
            f_onClick={this.onclick_confirm_selected_proposal_manager}
          />
        </div>
      </div>
    );
  }
}));


const OpenCaptureProposalManagement = inject("CaptureExecMobx", "OpenCaptureMobx", "ProposalManagementMobx", "DatabaseMobx")(observer(
class OpenCaptureProposalManagement extends Component { //props: p_expandedProposalObj
  a_ocpm_update_proposal_manager_user_id = (i_newProposalManagerUserID) => {
    const p_expandedProposalObj = this.props.p_expandedProposalObj;
    this.props.ProposalManagementMobx.a_ocpm_update_proposal_manager_user_id(p_expandedProposalObj.id, i_newProposalManagerUserID);
  }

  onchange_proposal_selected_subtab = (i_selectedSubtabDbName) => {
    this.props.ProposalManagementMobx.a_ocpm_set_selected_subtab_db_name(i_selectedSubtabDbName);
  }

  render() {
    const p_expandedProposalObj = this.props.p_expandedProposalObj;

    const c_isMobileOrTabletTF = this.props.CaptureExecMobx.c_isMobileOrTabletTF;
    const o_ocpmSelectedSubtabDbName = this.props.ProposalManagementMobx.o_ocpmSelectedSubtabDbName;
    const c_proposalManagerCaptureFieldValueObj = this.props.OpenCaptureMobx.c_proposalManagerCaptureFieldValueObj;
    const c_ocpmOpenCaptureProposalDueDateTimeUtcCaptureFieldValueObj = this.props.ProposalManagementMobx.c_ocpmOpenCaptureProposalDueDateTimeUtcCaptureFieldValueObj;
    const k_cardIDProposalManagement = this.props.DatabaseMobx.k_cardIDProposalManagement;

    var selectedProposalManagementSubtabContentComponent = null;
    if(o_ocpmSelectedSubtabDbName === "calendar") {
      selectedProposalManagementSubtabContentComponent = (<ProposalManagementCalendarSubtab p_expandedProposalObj={p_expandedProposalObj} />);
    }
    else if(o_ocpmSelectedSubtabDbName === "workAssignments") {
      selectedProposalManagementSubtabContentComponent = (<ProposalManagementWorkAssignmentsSubtab />);
    }
    
    return(
      <>
        <div className="flex00a displayFlexRow flexWrap borderB1bbb bgLighterGray tbMicroPad">
          <div className="flex00a displayFlexColumnVc lrMedMargin" style={{flexBasis:"35em"}}>
            <OpenCaptureReact.DetailsItem
              p_captureID={p_expandedProposalObj.capture_id}
              p_cardID={k_cardIDProposalManagement}
              p_captureFieldValueObj={c_proposalManagerCaptureFieldValueObj}
              p_fieldWidth="10em"
              p_isSnapshotTF={false}
              p_fieldClass="fontBlue"
              p_valueClass={undefined}
              p_fieldValueVerticallyAlignedTF={true}
              p_showFieldNameTF={true}
            />
          </div>
          <div className="flex00a displayFlexColumnVc lrMedMargin" style={{flexBasis:"40em"}}>
            <OpenCaptureReact.DetailsItem
              p_captureID={p_expandedProposalObj.capture_id}
              p_cardID={k_cardIDProposalManagement}
              p_captureFieldValueObj={c_ocpmOpenCaptureProposalDueDateTimeUtcCaptureFieldValueObj}
              p_fieldWidth="12em"
              p_isSnapshotTF={false}
              p_fieldClass="fontBlue"
              p_valueClass={undefined}
              p_fieldValueVerticallyAlignedTF={true}
              p_showFieldNameTF={true}
            />
          </div>
          <div className="flex11a" />
        </div>
        <div className={"flex11a " + ((c_isMobileOrTabletTF) ? ("displayFlexColumn") : ("displayFlexRow"))}>
          <div
            className={(c_isMobileOrTabletTF) ? ("flex00a displayFlexRow borderB1bbb bgLightesterGray tbMicroPad lrPad") : ("flex00a displayFlexColumn borderR1bbb bgLightesterGray smallFullPad")}
            style={c_isMobileOrTabletTF ? undefined : {flexBasis:"10em"}}>
            <CEGeneralReact.TabsList
              p_tabDbNamesArray={["calendar", "workAssignments"]}
              p_tabDisplayNamesArray={["Calendar", "Work Assignments"]}
              p_selectedTabDbName={o_ocpmSelectedSubtabDbName}
              p_tabHeight={c_isMobileOrTabletTF ? "1.6em" : "3.3em"}
              p_textMaxHeight={c_isMobileOrTabletTF ? "1em" : "3em"}
              p_tabWidth={undefined}
              p_selectedBgClass="bgGoldGradient"
              p_selectedFontClass="fontBold"
              p_unselectedBgClass="bgLightGrayGradient"
              p_unselectedFontClass="fontBold fontTextLight"
              p_rowFlexWrapTF={false}
              p_verticalTabsTF={!c_isMobileOrTabletTF}
              p_tabSpacing={c_isMobileOrTabletTF ? "0.2em" : undefined}
              p_borderRadiusClass=""
              f_onSelect={this.onchange_proposal_selected_subtab}
            />
          </div>
          <div className="flex11a displayFlexColumn">
            {selectedProposalManagementSubtabContentComponent}
          </div>
        </div>
      </>
    );
  }
}));


const ProposalManagementCalendarSubtab = inject("ProposalManagementMobx", "DatabaseMobx", "UserMobx")(observer(
class ProposalManagementCalendarSubtab extends Component { //props: p_expandedProposalObj
  constructor(props) {
    super(props);
    this.state = {
      s_editingMilestoneIDOrUndefined: undefined
    }
  }

  onclick_milestone_open_edit_floating_box = (i_expandedMilestoneObj) => {
    this.setState({s_editingMilestoneIDOrUndefined:i_expandedMilestoneObj.id});
  }

  onclick_close_milestone_edit_floating_box = () => {
    this.setState({s_editingMilestoneIDOrUndefined:undefined});
  }

  onedit_calendar_event_fields = (i_expandedEventObj, i_fieldDbNamesArray, i_newValuesArray) => {
    this.props.ProposalManagementMobx.a_ocpm_update_milestone_fields(i_expandedEventObj, i_fieldDbNamesArray, i_newValuesArray);
  }

  ondelete_single_calendar_event = (i_expandedEventObj) => {
    this.props.ProposalManagementMobx.a_ocpm_delete_milestone(i_expandedEventObj);
  }

  render() {
    const s_editingMilestoneIDOrUndefined = this.state.s_editingMilestoneIDOrUndefined;

    const p_expandedProposalObj = this.props.p_expandedProposalObj;

    const c_combinedUserObj = this.props.UserMobx.c_combinedUserObj;

    const expandedMilestonesArrayOfObjs = p_expandedProposalObj.expandedMilestonesArrayOfObjs;

    return(
      <>
        <div className="flex00a displayFlexColumn borderB1bbb">
          <ProposalManagementCalendarControls p_expandedProposalObj={p_expandedProposalObj} />
        </div>
        <div className="flex11a displayFlexColumn hugeBottomPad xyScroll">
          <ProposalManagementCalendar
            p_inputDatesRealCalendarTrueCountdownToZeroFalse={true}
            p_calendarEventsArrayOfObjs={expandedMilestonesArrayOfObjs}
            p_proposalDueDateCeDateTimeUtc={p_expandedProposalObj.proposalDueDateCeDateTimeUtc}
            p_startDateYmd={c_combinedUserObj.propmgmt_card_calendar_start_date}
            p_endDateYmd={c_combinedUserObj.propmgmt_card_calendar_end_date}
            p_weekHeightEm={c_combinedUserObj.propmgmt_card_calendar_week_height_em}
            p_weekStartDayIndex0To6={c_combinedUserObj.propmgmt_card_calendar_week_start_day_0to6}
            f_onClickCalendarEvent={this.onclick_milestone_open_edit_floating_box}
            f_onEditSingleEventFields={this.onedit_calendar_event_fields}
            f_onDeleteEvent={this.ondelete_single_calendar_event}
          />
        </div>
        {(s_editingMilestoneIDOrUndefined !== undefined) &&
          <ProposalManagementCalendarEditMilestoneFloatingBox
            p_editingMilestoneIDOrUndefined={s_editingMilestoneIDOrUndefined}
            f_onClickClose={this.onclick_close_milestone_edit_floating_box}
          />
        }
      </>
    );
  }
}));


const ProposalManagementCalendarEditMilestoneFloatingBox = inject("ProposalManagementMobx", "DatabaseMobx", "UserMobx")(observer(
class ProposalManagementCalendarEditMilestoneFloatingBox extends Component { //props: p_editingMilestoneIDOrUndefined, f_onClickClose
  get_editing_expanded_milestone_obj_or_undefined = () => {
    const p_editingMilestoneIDOrUndefined = this.props.p_editingMilestoneIDOrUndefined;
    const c_ocpmExpandedProposalObjOrUndefined = this.props.ProposalManagementMobx.c_ocpmExpandedProposalObjOrUndefined;
    if(p_editingMilestoneIDOrUndefined !== undefined) {
      if(c_ocpmExpandedProposalObjOrUndefined !== undefined) {
        if(JSFUNC.is_array(c_ocpmExpandedProposalObjOrUndefined.expandedMilestonesArrayOfObjs)) {
          return(JSFUNC.get_first_obj_from_arrayOfObjs_matching_field_value(c_ocpmExpandedProposalObjOrUndefined.expandedMilestonesArrayOfObjs, "id", p_editingMilestoneIDOrUndefined));
        }
      }
    }
  }

  onsave_edit_single_milestone_field = (i_iefFieldObj, i_newValueRaw) => {
    const editingExpandedMilestoneObjOrUndefined = this.get_editing_expanded_milestone_obj_or_undefined();
    if(editingExpandedMilestoneObjOrUndefined !== undefined) {
      this.props.ProposalManagementMobx.a_ocpm_update_milestone_fields(editingExpandedMilestoneObjOrUndefined, i_iefFieldObj.fieldDbName, i_newValueRaw);
    }
  }

  render() {
    const p_editingMilestoneIDOrUndefined = this.props.p_editingMilestoneIDOrUndefined;
    const f_onClickClose = this.props.f_onClickClose;

    const c_ocpmCreateNewMilestoneIefFieldsArrayOfObjs = this.props.ProposalManagementMobx.c_ocpmCreateNewMilestoneIefFieldsArrayOfObjs;
    
    const editingExpandedMilestoneObjOrUndefined = this.get_editing_expanded_milestone_obj_or_undefined();
    if(editingExpandedMilestoneObjOrUndefined === undefined) {
      return(null);
    }

    //need to write all current valueRaw of each milestone field into the IefFields input to initialize values for edit
    var editMilestoneIefFieldsArrayOfObjs = [];
    for(let milestoneIefFieldObj of c_ocpmCreateNewMilestoneIefFieldsArrayOfObjs) {
      var editMilestoneIefFieldObj = JSFUNC.copy_obj(milestoneIefFieldObj);

      var milestoneFieldValueRaw = undefined;
      if(milestoneIefFieldObj.fieldDbName === "startAndEndCeDateTimesUtcSemi") { //combine start_ce_datetime_utc and end_ce_datetime_utc into a semicolon separated double input raw value for the startAndEnd datetime field editor
        milestoneFieldValueRaw = editingExpandedMilestoneObjOrUndefined.start_ce_datetime_utc + ";" + editingExpandedMilestoneObjOrUndefined.end_ce_datetime_utc;
      }
      else { //other normal milestone database fields
        milestoneFieldValueRaw = editingExpandedMilestoneObjOrUndefined[milestoneIefFieldObj.fieldDbName];
      }
      editMilestoneIefFieldObj.valueRaw = milestoneFieldValueRaw;

      editMilestoneIefFieldsArrayOfObjs.push(editMilestoneIefFieldObj);
    }
    
    return(
      <CEGeneralReact.InsertOrEditFieldsFormFloatingBox
        p_insertTrueEditFalse={false}
        p_iefFieldsArrayOfObjs={editMilestoneIefFieldsArrayOfObjs}
        p_itemName="Milestone"
        p_floatingBoxTrblFlag="smallVertical"
        p_floatingBoxTitle="Edit Milestone"
        p_containerClass="medBottomMargin"
        p_fieldClass="fontBlue"
        p_fieldWidth="13em"
        f_onClickSaveSingleFieldEdit={this.onsave_edit_single_milestone_field}
        f_onClickInsertCreate={undefined}
        f_onClickClose={f_onClickClose}
      />
    );
  }
}));




const ProposalManagementCalendarControls = inject("ProposalManagementMobx", "DatabaseMobx", "UserMobx")(observer(
class ProposalManagementCalendarControls extends Component { //props: p_expandedProposalObj
  constructor(props) {
    super(props);
    this.state = {
      s_applyTemplateModeTF: false,
      s_createMilestoneFloatingBoxIsOpenTF: false,
      s_editCalendarWeekStyleFloatingBoxIsOpenTF: false
    };
  }

  onclick_open_apply_template_mode = () => {
    this.setState({s_applyTemplateModeTF:true});
  }

  onclick_cancel_apply_template_mode = () => {
    this.setState({
      s_applyTemplateModeTF: false
    });
  }

  onclick_open_create_new_milestone_floating_box = () => {
    this.setState({s_createMilestoneFloatingBoxIsOpenTF:true});
  }

  onclick_close_create_new_milestone_floating_box = () => {
    this.setState({s_createMilestoneFloatingBoxIsOpenTF:false});
  }

  onclick_open_edit_calendar_week_style_floating_box = () => {
    this.setState({s_editCalendarWeekStyleFloatingBoxIsOpenTF:true});
  }

  onclick_close_edit_calendar_week_style_floating_box = () => {
    this.setState({s_editCalendarWeekStyleFloatingBoxIsOpenTF:false});
  }

  oncreate_new_milestone = (i_newFieldDbNamesValuesObj) => {
    const p_expandedProposalObj = this.props.p_expandedProposalObj;
    this.setState({s_createMilestoneFloatingBoxIsOpenTF:false});
    this.props.ProposalManagementMobx.a_ocpm_insert_new_milestone(p_expandedProposalObj, i_newFieldDbNamesValuesObj);
  }

  onsave_start_and_end_dates = (i_startDateYmd, i_endDateYmd) => {
    const fieldDbNamesArray = ["propmgmt_card_calendar_start_date", "propmgmt_card_calendar_end_date"];
    const valuesArray = [i_startDateYmd, i_endDateYmd];
    const idsbArray = ["s", "s"]
    this.props.UserMobx.a_update_logged_in_user_per_email_field(fieldDbNamesArray, valuesArray, idsbArray);
  }

  onselect_week_height_em = (i_newWeekHeightEm) => {
    this.props.UserMobx.a_update_logged_in_user_per_email_field("propmgmt_card_calendar_week_height_em", i_newWeekHeightEm, "s");
  }

  onselect_week_start_day_0to6 = (i_newWeekStartDay0To6) => {
    this.props.UserMobx.a_update_logged_in_user_per_email_field("propmgmt_card_calendar_week_start_day_0to6", i_newWeekStartDay0To6, "i");
  }

  onclick_zoom_to_fit_all_events = () => {
    const p_expandedProposalObj = this.props.p_expandedProposalObj;

    const c_ocpmOpenCaptureProposalDueDateTimeUtcCaptureFieldValueObj = this.props.ProposalManagementMobx.c_ocpmOpenCaptureProposalDueDateTimeUtcCaptureFieldValueObj;

    const todayDateYmd = JSFUNC.now_dateYmd();

    //initialize with today date and the proposal due date
    var viewAllMilestonesStartDateYmd = todayDateYmd;
    var viewAllMilestonesEndDateYmd = todayDateYmd;
    if(c_ocpmOpenCaptureProposalDueDateTimeUtcCaptureFieldValueObj.isFilledOutTF) {
      if(c_ocpmOpenCaptureProposalDueDateTimeUtcCaptureFieldValueObj.valueRaw < viewAllMilestonesStartDateYmd) {
        viewAllMilestonesStartDateYmd = c_ocpmOpenCaptureProposalDueDateTimeUtcCaptureFieldValueObj.valueRaw;
      }
      
      if(c_ocpmOpenCaptureProposalDueDateTimeUtcCaptureFieldValueObj.valueRaw > viewAllMilestonesEndDateYmd) {
        viewAllMilestonesEndDateYmd = c_ocpmOpenCaptureProposalDueDateTimeUtcCaptureFieldValueObj.valueRaw;
      }
    }

    for(let expandedMilestoneObj of p_expandedProposalObj.expandedMilestonesArrayOfObjs) {
      const startCEDateTimeUtc = expandedMilestoneObj.startCEDateTimeUtc;
      const endCEDateTimeUtcRaw = expandedMilestoneObj.endCEDateTimeUtc;
      if(!JSFUNC.datetime_is_filled_out_tf(startCEDateTimeUtc)) {
        continue;
      }

      var startDateYmd = JSFUNC.convert_ce_datetimeutc_to_mysqldatelocal(startCEDateTimeUtc);
      var endDateYmd = JSFUNC.convert_ce_datetimeutc_to_mysqldatelocal(((JSFUNC.datetime_is_filled_out_tf(endCEDateTimeUtcRaw)) ? (endCEDateTimeUtcRaw) : (startCEDateTimeUtc)));
      if(!JSFUNC.date_is_filled_out_tf(startDateYmd)) {
        continue;
      }
      if(!JSFUNC.date_is_filled_out_tf(endDateYmd)) {
        endDateYmd = startDateYmd;
      }

      if(endDateYmd < startDateYmd) {
        const tempDateYmd = startDateYmd;
        startDateYmd = endDateYmd;
        endDateYmd = tempDateYmd;
      }

      if(startDateYmd < viewAllMilestonesStartDateYmd) {
        viewAllMilestonesStartDateYmd = startDateYmd;
      }

      if(endDateYmd > viewAllMilestonesEndDateYmd) {
        viewAllMilestonesEndDateYmd = endDateYmd;
      }
    }

    if(JSFUNC.date_is_filled_out_tf(viewAllMilestonesStartDateYmd) && JSFUNC.date_is_filled_out_tf(viewAllMilestonesEndDateYmd)) {
      this.onsave_start_and_end_dates(viewAllMilestonesStartDateYmd, viewAllMilestonesEndDateYmd);
      this.onselect_week_height_em(1); //force Week Height to "Auto" to best fit all events in the view after zooming to fit all events
    }
  }

  ondelete_all_calendar_events = () => {
    const p_expandedProposalObj = this.props.p_expandedProposalObj;
    this.props.ProposalManagementMobx.a_ocpm_delete_all_calendar_milestones(p_expandedProposalObj);
  }

  render() {
    const s_applyTemplateModeTF = this.state.s_applyTemplateModeTF;
    const s_createMilestoneFloatingBoxIsOpenTF = this.state.s_createMilestoneFloatingBoxIsOpenTF;
    const s_editCalendarWeekStyleFloatingBoxIsOpenTF = this.state.s_editCalendarWeekStyleFloatingBoxIsOpenTF;

    const p_expandedProposalObj = this.props.p_expandedProposalObj;

    const c_ocpmOpenCaptureProposalDueDateTimeUtcCaptureFieldValueObj = this.props.ProposalManagementMobx.c_ocpmOpenCaptureProposalDueDateTimeUtcCaptureFieldValueObj;
    const c_ocpmCreateNewMilestoneIefFieldsArrayOfObjs = this.props.ProposalManagementMobx.c_ocpmCreateNewMilestoneIefFieldsArrayOfObjs;
    const c_ocpmSelectWeekHeightEmFieldTypeObj = this.props.ProposalManagementMobx.c_ocpmSelectWeekHeightEmFieldTypeObj;
    const c_ocpmSelectWeekStartDay0To6FieldTypeObj = this.props.ProposalManagementMobx.c_ocpmSelectWeekStartDay0To6FieldTypeObj;
    const c_combinedUserObj = this.props.UserMobx.c_combinedUserObj;

    const calendarControlsVerticalDotsMenuItemsArrayOfObjs = [
      {
        displayName: "Edit Calendar Options",
        functionOnClickMenuItem: this.onclick_open_edit_calendar_week_style_floating_box
      },
      {
        displayName: "Zoom to Fit All Events",
        functionOnClickMenuItem: this.onclick_zoom_to_fit_all_events
      },
      {
        displayName: "Remove All Calendar Events",
        confirmType: "confirmDelete",
        confirmMessage: "Are you sure you want to remove all events on this proposal calendar for this capture?",
        functionOnClickConfirmButton: this.ondelete_all_calendar_events
      }
    ];

    return(
      <div className="flex00a displayFlexRow flexWrap">
        <div className="flex00a displayFlexColumnHcVc tbMargin lrMedMargin">
          <CEGeneralReact.CEButton
            p_text="Apply Proposal Template"
            p_type="add"
            p_title="Apply a Proposal Template to this Proposal. This will create Milestones on the calendar based on the selected template, calculated based on the Proposal Due Date"
            f_onClick={this.onclick_open_apply_template_mode}
          />
        </div>
        <div className="flex00a displayFlexColumnHcVc tbMargin lrMedMargin">
          <CEGeneralReact.CEButton
            p_text="Create New Milestone"
            p_type="blue"
            p_title="Create a new Milestone event on the calendar for this Proposal"
            f_onClick={this.onclick_open_create_new_milestone_floating_box}
          />
        </div>
        <div className="flex11a" />
        <div className="flex00a displayFlexColumnHcVc tbMargin" style={{flexBasis:"20em"}}>
          <CEGeneralReact.SelectStartDateAndEndDateButtonWithFlexibleMenu
            p_startDateYmd={c_combinedUserObj.propmgmt_card_calendar_start_date}
            p_endDateYmd={c_combinedUserObj.propmgmt_card_calendar_end_date}
            f_onChange={this.onsave_start_and_end_dates}
          />
        </div>
        <div className="flex00a displayFlexColumnHcVc tbMargin" style={{flexBasis:"8em"}}>
          <div className="flex00a displayFlexColumnHcVc border bevelBorderColors bgLightestGray" style={{width:"8em", height:"4.5em"}}>
            <CalendarButtonAdvanceStartAndEndDateNumDays p_numWeeksToAdvance={-3} />
            <LibraryReact.DivFont p_class="microBottomMargin textCenter" p_styleObj={{height:"1em"}} p_fontClass="font09 fontTextLight">
              {"Calendar View"}
            </LibraryReact.DivFont>
            <CalendarButtonAdvanceStartAndEndDateNumDays p_numWeeksToAdvance={3} />
          </div>
        </div>
        <div className="flex00a" style={{flexBasis:"1em"}} />
        <div className="flex00a displayFlexColumnHcVc tbMargin" style={{flexBasis:"7em"}}>
          <div className="flex00a displayFlexColumnHcVc border bevelBorderColors bgLightestGray" style={{width:"7em", height:"4.5em"}}>
            <LibraryReact.DivFont p_class="microBottomMargin textCenter" p_fontClass="fontTextLight">
              {"Week Height"}
            </LibraryReact.DivFont>
            <div className="flex00a displayFlexColumn" style={{width:"5em"}}>
              <CEGeneralReact.GenericInputOrSelectFromInputType
                p_fieldTypeObj={c_ocpmSelectWeekHeightEmFieldTypeObj}
                p_valueRaw={c_combinedUserObj.propmgmt_card_calendar_week_height_em}
                f_onChangeOrOnSelect={this.onselect_week_height_em}
              />
            </div>
          </div>
        </div>
        <div className="flex00a displayFlexColumnHcVc" style={{flexBasis:"2.5em"}}>
          <CEGeneralReact.VerticalDotsMenu
            p_menuItemsArrayOfObjs={calendarControlsVerticalDotsMenuItemsArrayOfObjs}
          />
        </div>
        {(s_applyTemplateModeTF) &&
          <CalendarControlApplyAdminTemplateFloatingBox
            p_expandedProposalObj={p_expandedProposalObj}
            f_onClickCancelApplyTemplateMode={this.onclick_cancel_apply_template_mode}
          />
        }
        {(s_createMilestoneFloatingBoxIsOpenTF) &&
          <CEGeneralReact.InsertOrEditFieldsFormFloatingBox
            p_insertTrueEditFalse={true}
            p_iefFieldsArrayOfObjs={c_ocpmCreateNewMilestoneIefFieldsArrayOfObjs}
            p_itemName="Milestone"
            p_floatingBoxTrblFlag="smallVertical"
            p_floatingBoxTitle="Create New Milestone"
            p_containerClass="medBottomMargin"
            p_fieldClass="fontBlue"
            p_fieldWidth="13em"
            f_onClickSaveSingleFieldEdit={undefined}
            f_onClickInsertCreate={this.oncreate_new_milestone}
            f_onClickClose={this.onclick_close_create_new_milestone_floating_box}
          />
        }
        {(s_editCalendarWeekStyleFloatingBoxIsOpenTF) &&
          <CalendarControlEditCalendarWeekStyleFloatingBox
            p_weekStartDay0To6FieldTypeObj={c_ocpmSelectWeekStartDay0To6FieldTypeObj}
            p_weekStartDay0To6={c_combinedUserObj.propmgmt_card_calendar_week_start_day_0to6}
            f_onSaveWeekStartDay0To6={this.onselect_week_start_day_0to6}
            f_onClose={this.onclick_close_edit_calendar_week_style_floating_box}
          />
        }
      </div>
    );
  }
}));


const CalendarButtonAdvanceStartAndEndDateNumDays = inject("UserMobx")(observer(
class CalendarButtonAdvanceStartAndEndDateNumDays extends Component { //props:  p_numWeeksToAdvance
  onclick_advance_start_and_end_date_button = () => {
    const p_numWeeksToAdvance = this.props.p_numWeeksToAdvance;

    const c_combinedUserObj = this.props.UserMobx.c_combinedUserObj;

    const numDaysToAdvance = (p_numWeeksToAdvance * 7);
    const newStartDateYmd = JSFUNC.date_add_days(c_combinedUserObj.propmgmt_card_calendar_start_date, numDaysToAdvance);
    const newEndDateYmd = JSFUNC.date_add_days(c_combinedUserObj.propmgmt_card_calendar_end_date, numDaysToAdvance);
    this.props.UserMobx.a_update_logged_in_user_per_email_field(["propmgmt_card_calendar_start_date", "propmgmt_card_calendar_end_date"], [newStartDateYmd, newEndDateYmd], ["s", "s"]);
  }

  render() {
    const p_numWeeksToAdvance = this.props.p_numWeeksToAdvance;

    const advanceForwardTrueBackFalse = (p_numWeeksToAdvance > 0);

    return(
      <div className="flex00a displayFlexColumnHcVc" style={{flexBasis:"1.8em"}}>
        <LibraryReact.Button
          p_class="displayFlexColumnHcVc border1bbb bgLightGrayGradient hoverLighterBlueGradient textCenter cursorPointer"
          p_styleObj={{width:"1.8em", height:"1.2em"}}
          p_tabIndex={undefined}
          p_hoverText={"Move the calendar " + ((advanceForwardTrueBackFalse) ? ("forward") : ("back")) + " " + Math.abs(p_numWeeksToAdvance) + " weeks"}
          p_errorTF={undefined}
          f_onClick={this.onclick_advance_start_and_end_date_button}>
          <CEIconsReact.SvgUpDownCarat
            p_isDownTF={advanceForwardTrueBackFalse}
            p_sizeEm={1}
            p_color="666666"
          />
        </LibraryReact.Button>
      </div>
    );
  }
}));


const CalendarControlApplyAdminTemplateFloatingBox = inject("ProposalManagementMobx", "DatabaseMobx")(observer(
class CalendarControlApplyAdminTemplateFloatingBox extends Component { //props: p_expandedProposalObj, f_onClickCancelApplyTemplateMode
  constructor(props) {
    super(props);
    this.state = {
      s_selectedTurnaroundTemplateID: -1
    };
  }

  onchange_selected_turnaround_template = (i_selectedAdminTurnaroundTimelineTemplateID) => {
    this.setState({s_selectedTurnaroundTemplateID:i_selectedAdminTurnaroundTimelineTemplateID});
  }

  onclick_apply_selected_template = () => {
    const s_selectedTurnaroundTemplateID = this.state.s_selectedTurnaroundTemplateID;

    this.props.ProposalManagementMobx.a_ocpm_apply_turnaround_template_to_open_proposal(s_selectedTurnaroundTemplateID);

    if(JSFUNC.is_function(this.props.f_onClickCancelApplyTemplateMode)) {
      this.props.f_onClickCancelApplyTemplateMode();
    }
  }

  render() {
    const s_selectedTurnaroundTemplateID = this.state.s_selectedTurnaroundTemplateID;

    const p_expandedProposalObj = this.props.p_expandedProposalObj;
    const f_onClickCancelApplyTemplateMode = this.props.f_onClickCancelApplyTemplateMode;

    const c_ocpmExpandedProposalObjOrUndefined = this.props.ProposalManagementMobx.c_ocpmExpandedProposalObjOrUndefined;
    const c_ocpmOpenCaptureProposalDueDateTimeUtcCaptureFieldValueObj = this.props.ProposalManagementMobx.c_ocpmOpenCaptureProposalDueDateTimeUtcCaptureFieldValueObj;
    const c_ocpmSelectAdminTurnaroundTimelineTemplateFieldTypeObj = this.props.ProposalManagementMobx.c_ocpmSelectAdminTurnaroundTimelineTemplateFieldTypeObj;
    const c_apmAllExpandedTurnaroundsSequencesMilestonesArrayOfObjs = this.props.ProposalManagementMobx.c_apmAllExpandedTurnaroundsSequencesMilestonesArrayOfObjs;
    const k_cardIDProposalManagement = this.props.DatabaseMobx.k_cardIDProposalManagement;
    const c_fieldMapOfProposalDueDateTimeUtc = this.props.DatabaseMobx.c_fieldMapOfProposalDueDateTimeUtc;

    if(c_ocpmExpandedProposalObjOrUndefined === undefined) {
      return(null);
    }

    var canApplySelectedTemplateTF = false;
    var applyProposalTemplateFloatingBoxTopContentComponent = null;
    var applyProposalTemplateFloatingBoxBottomContentComponent = null;
    if(!c_ocpmExpandedProposalObjOrUndefined.proposalDueDateIsFilledOutTF) {
      applyProposalTemplateFloatingBoxTopContentComponent = (
        <LibraryReact.DivFont p_class="flex00a bigFullPad textCenter" p_fontClass="fontItalic fontTextLighter">
          {"--A Template can not be applied until " + c_fieldMapOfProposalDueDateTimeUtc.get("display_name") + " is set on this Proposal--"}
        </LibraryReact.DivFont>
      );

      applyProposalTemplateFloatingBoxBottomContentComponent = (
        <OpenCaptureReact.DetailsItem
          p_captureID={p_expandedProposalObj.capture_id}
          p_cardID={k_cardIDProposalManagement}
          p_captureFieldValueObj={c_ocpmOpenCaptureProposalDueDateTimeUtcCaptureFieldValueObj}
          p_fieldWidth="12em"
          p_isSnapshotTF={false}
          p_fieldClass="fontBlue"
          p_valueClass={undefined}
          p_fieldValueVerticallyAlignedTF={true}
          p_showFieldNameTF={true}
        />
      );
    }
    else {
      canApplySelectedTemplateTF = JSFUNC.select_int_is_filled_out_tf(s_selectedTurnaroundTemplateID);
      const selectedExpandedTurnaroundObjOrUndefined = JSFUNC.get_first_obj_from_arrayOfObjs_matching_field_value(c_apmAllExpandedTurnaroundsSequencesMilestonesArrayOfObjs, "id", s_selectedTurnaroundTemplateID);
      
      applyProposalTemplateFloatingBoxTopContentComponent = (
        <>
          <LibraryReact.DivFont p_class="flex00a tbPad lrMedPad textCenter" p_fontClass="fontItalic fontTextLighter">
            {c_ocpmExpandedProposalObjOrUndefined.proposalDueOnDateTimeWithNumDaysString}
          </LibraryReact.DivFont>
          <div className="flex00a displayFlexRowVc flexWrap medFullPad">
            <div className="flex00a" style={{flexBasis:"18em"}}>
              <LibraryReact.DivFont p_fontClass="fontBold fontTextLighter">
                {"Select a Proposal Template to Apply:"}
              </LibraryReact.DivFont>
            </div>
            <div className="flex00a" style={{flexBasis:"22em"}}>
              <CEGeneralReact.GenericInputOrSelectFromInputType
                p_fieldTypeObj={c_ocpmSelectAdminTurnaroundTimelineTemplateFieldTypeObj}
                p_valueRaw={s_selectedTurnaroundTemplateID}
                p_selectInitOptionsBoxOpenTF={true}
                f_onChangeOrOnSelect={this.onchange_selected_turnaround_template}
              />
            </div>
          </div>
        </>
      );

      if(selectedExpandedTurnaroundObjOrUndefined === undefined) {
        applyProposalTemplateFloatingBoxBottomContentComponent = (
          <LibraryReact.DivFont p_class="flex00a tbPad lrMedPad textCenter" p_fontClass="fontItalic fontTextLighter">
            {"--No Proposal Turnaround Template Selected--"}
          </LibraryReact.DivFont>
        );
      }
      else {
        if(selectedExpandedTurnaroundObjOrUndefined.numSequences === 0) {
          applyProposalTemplateFloatingBoxBottomContentComponent = (
            <LibraryReact.DivFont p_class="flex00a tbPad lrMedPad textCenter" p_fontClass="fontItalic fontTextLighter">
              {"--No Sequences in Turnaround Template '" + selectedExpandedTurnaroundObjOrUndefined.name + "'--"}
            </LibraryReact.DivFont>
          );
        }
        else {
          applyProposalTemplateFloatingBoxBottomContentComponent = (
            <>
              <LibraryReact.DivFont p_class="flex00a tbPad lrMedPad textCenter" p_fontClass="fontItalic fontTextLighter">
                {"Previewing turnaround template: " + selectedExpandedTurnaroundObjOrUndefined.name}
              </LibraryReact.DivFont>
              {selectedExpandedTurnaroundObjOrUndefined.expandedSequencesArrayOfObjs.map((m_expandedSequenceObj) => 
                <div key={m_expandedSequenceObj.id} className="flex00a displayFlexColumn bigBottomMargin" title={m_expandedSequenceObj.sequenceHoverText}>
                  <div className="flex00a displayFlexRowVc lrMedPad border bevelBorderDarkColors bgGray" style={{flexBasis:"1.7em"}}>
                    <LibraryReact.NowrapEllipsis p_fontClass="fontBold fontWhite">
                      {m_expandedSequenceObj.sequenceDisplayName}
                    </LibraryReact.NowrapEllipsis>
                  </div>
                  <div className="flex00a displayFlexColumn smallFullPad">
                    {(m_expandedSequenceObj.numMilestones === 0) ? (
                      <LibraryReact.DivFont p_class="flex00a textCenter" p_fontClass="fontItalic fontTextLighter">
                        {"--No Milestones in this Sequence--"}
                      </LibraryReact.DivFont>
                    ) : (
                      m_expandedSequenceObj.expandedMilestonesArrayOfObjs.map((m_expandedMilestoneObj) => 
                        <ApplyAdminTemplateFloatingBoxSingleMilestoneBubble
                          key={m_expandedMilestoneObj.id}
                          p_expandedMilestoneObj={m_expandedMilestoneObj}
                        />
                      )
                    )}
                  </div>
                </div>
              )}
            </>
          );
        }
      }
    }

    return(
      <CEGeneralReact.FloatingBoxWithSaveCancel
        p_trblFlag="smallVertical"
        p_title="Apply Proposal Template"
        f_onClickCancel={f_onClickCancelApplyTemplateMode}>
        {applyProposalTemplateFloatingBoxTopContentComponent}
        <div className="flex11a displayFlexColumn borderT1bbb smallTopPad medBottomPad lrMedPad yScroll">
          {applyProposalTemplateFloatingBoxBottomContentComponent}
        </div>
        <div className="flex00a displayFlexRowHcVc borderT1bbb tbMedPad">
          <div className="flex00a lrMedPad">
            <CEGeneralReact.CEButton
              p_text="Apply Template"
              p_type={((canApplySelectedTemplateTF) ? ("blue") : ("blueDisabled"))}
              f_onClick={((canApplySelectedTemplateTF) ? (this.onclick_apply_selected_template) : (undefined))}
            />
          </div>
          <div className="flex00a lrMedPad">
            <CEGeneralReact.CEButton
              p_text="Cancel"
              p_type="gray"
              f_onClick={f_onClickCancelApplyTemplateMode}
            />
          </div>
        </div>
      </CEGeneralReact.FloatingBoxWithSaveCancel>
    );
  }
}));

function ApplyAdminTemplateFloatingBoxSingleMilestoneBubble(props) { //props: p_expandedMilestoneObj
  const p_expandedMilestoneObj = props.p_expandedMilestoneObj;

  return(
    <div
      className="flex00a displayFlexRowVc lrMedPad microBottomMargin textCenter"
      style={{minHeight:"2.3em", border:"solid 1px #" + p_expandedMilestoneObj.calSeqBorderColor, borderRadius:"2em", background:"#" + p_expandedMilestoneObj.calSeqBgColor}}>
      <div className="flex11a displayFlexColumn">
        <LibraryReact.NowrapEllipsis p_fontClass={p_expandedMilestoneObj.calSeqFontClassString} p_fontStyleObj={{color:"#" + p_expandedMilestoneObj.calSeqFontColor}}>
          {p_expandedMilestoneObj.milestoneDisplayName}
        </LibraryReact.NowrapEllipsis>
      </div>
      <div className="flex00a displayFlexColumnVc lrMedPad" style={{flexBasis:"12em"}}>
        <LibraryReact.DivFont p_fontClass={("font09 " + p_expandedMilestoneObj.calSeqFontClassString)} p_fontStyleObj={{color:"#" + p_expandedMilestoneObj.calSeqFontColor}}>
          <div className="textRight">{"# Days Prior: " + p_expandedMilestoneObj.initial_num_days_prior_to_proposal_due_date}</div>
          <div className="textRight">{"Duration (# Days): " + p_expandedMilestoneObj.initial_duration_num_days}</div>
        </LibraryReact.DivFont>
      </div>
    </div>
  );
}


function CalendarControlEditCalendarWeekStyleFloatingBox(props) { //props: p_weekStartDay0To6FieldTypeObj, p_weekStartDay0To6, f_onSaveWeekStartDay0To6, f_onClose
  const p_weekStartDay0To6FieldTypeObj = props.p_weekStartDay0To6FieldTypeObj;
  const p_weekStartDay0To6 = props.p_weekStartDay0To6;
  const f_onSaveWeekStartDay0To6 = props.f_onSaveWeekStartDay0To6;
  const f_onClose = props.f_onClose;

  return(
    <CEGeneralReact.FloatingBoxWithSaveCancel
      p_trblFlag="confirmBox"
      p_title="Edit Calendar Options"
      f_onClickSave={f_onClose}>
      <div className="flex11a displayFlexColumn medFullPad yScroll">
        <CEGeneralReact.CaptureExecFieldEditSaveCancel
          p_ceEditItemString="pmCalWeekStartDay"
          p_fieldDisplayName="Week Start Day"
          p_fieldTypeObj={p_weekStartDay0To6FieldTypeObj}
          p_valueRaw={p_weekStartDay0To6}
          p_valueIsEditableTFU={true}
          p_fieldClass="fontBlue"
          p_fieldWidth="8em"
          f_onSaveChanged={f_onSaveWeekStartDay0To6}
        />
        <div className="flex00a enormousTopMargin" />
      </div>
    </CEGeneralReact.FloatingBoxWithSaveCancel>
  );
}







const ProposalManagementWorkAssignmentsSubtab = inject("ProposalManagementMobx")(observer(
class ProposalManagementWorkAssignmentsSubtab extends Component {
  render() {
    return(
      <div className="flex00a displayFlexColumnHcVc medFullPad textCenter">
        <LibraryReact.DivFont p_class="bigFullPad" p_fontClass="font11 fontBold fontItalic fontTextLighter">
          <div>{"The Work Assignments tab is currently in development."}</div>
          <div className="medTopMargin">{"This feature within Proposal Management will allow that Proposal Manager to delegate writing assignments both internally and externally to SMEs, and manage time for delivery and writing progress."}</div>
        </LibraryReact.DivFont>
      </div>
    );
  }
}));



function ProposalManagementCalendar(props) { //props: p_inputDatesRealCalendarTrueCountdownToZeroFalse, p_calendarEventsArrayOfObjs, p_proposalDueDateCeDateTimeUtc, p_startDateYmd, p_endDateYmd, p_weekHeightEm, p_weekStartDayIndex0To6, p_countdownMustDrawNumDaysPriorMax, p_countdownMustDrawNumDaysPriorMin, f_onClickCalendarEvent, f_onEditSingleEventFields, f_onDeleteEvent
  //countdown to zero calendar layout (if p_inputDatesRealCalendarTrueCountdownToZeroFalse is false):
  //  5: [41 40 39 38 37 36 35]
  //  4: [34 33 32 31 30 29 28]
  //  3: [27 26 25 24 23 22 21]
  //  2: [20 19 18 17 16 15 14]
  //  1: [13 12 11 10 9 8 7]
  //  0: [6 5 4 3 2 1 0]
  //  -1: [-1 -2 -3 -4 -5 -6 -7]
  
  const p_inputDatesRealCalendarTrueCountdownToZeroFalse = props.p_inputDatesRealCalendarTrueCountdownToZeroFalse;
  const p_calendarEventsArrayOfObjs = props.p_calendarEventsArrayOfObjs;
  const p_proposalDueDateCeDateTimeUtc = JSFUNC.prop_value(props.p_proposalDueDateCeDateTimeUtc, JSFUNC.blank_datetime());
  const p_startDateYmd = JSFUNC.prop_value(props.p_startDateYmd, JSFUNC.blank_date());
  const p_endDateYmd = JSFUNC.prop_value(props.p_endDateYmd, JSFUNC.blank_date());
  const p_weekHeightEm = JSFUNC.prop_value(props.p_weekHeightEm, 5);
  const p_weekStartDayIndex0To6 = JSFUNC.prop_value(props.p_weekStartDayIndex0To6, 0);
  const p_countdownMustDrawNumDaysPriorMax = props.p_countdownMustDrawNumDaysPriorMax;
  const p_countdownMustDrawNumDaysPriorMin = props.p_countdownMustDrawNumDaysPriorMin;
  const f_onClickCalendarEvent = props.f_onClickCalendarEvent;
  const f_onEditSingleEventFields = props.f_onEditSingleEventFields;
  const f_onDeleteEvent = props.f_onDeleteEvent;

  //state/refs
  const [s_activeDropIndicatorObj, f_setActiveDropIndicatorObjOrUndefined] = React.useState(undefined); //{dayKey, visualFlag}
  const activeResizeDragDataObjRef = React.useRef(undefined);
  const activeDropIndicatorObjRef = React.useRef(undefined);

  //input calcs
  const calendarEventsArrayOfObjs = ((JSFUNC.is_array(p_calendarEventsArrayOfObjs)) ? (p_calendarEventsArrayOfObjs) : ([]));

  const weekHeightInputNum = Number(p_weekHeightEm);
  const weekHeightAutoTF = (weekHeightInputNum === 1);
  var baseWeekHeightEm = weekHeightInputNum;
  if(!JSFUNC.is_number_not_nan_gt_0(weekHeightInputNum)) { baseWeekHeightEm = 5; }
  else if(!weekHeightAutoTF && weekHeightInputNum < 3) { baseWeekHeightEm = 3; }

  //define calendar visual constants
  const calendarUiConstantsObj = {
    CALENDAR_GRID_MIN_WIDTH_EM: 56,
    CALENDAR_GRID_BORDER_HASH_COLOR: "#e0e1e4",
    MONTH_LABEL_WIDTH_EM: 5,
    MONTH_LABEL_FONT_SIZE_EM: 1.1,
    MONTH_LABEL_TEXT_HASH_COLOR: "#666677",
    CALENDAR_HEADER_BG_HASH_COLOR: "#f2f5f8",
    DAY_NAMES_HEADER_HEIGHT_EM: 1.8,
    ALTERNATING_MONTH_WEEKDAY_BG_HASH_COLORS_ARRAY: ["#f8f9fc", "#f7f7f8"],
    ALTERNATING_MONTH_WEEKEND_BG_HASH_COLORS_ARRAY: ["#f2f3f6", "#f1f1f2"],
    WEEK_HEADER_HEIGHT_EM: 1.3,
    WEEK_HEADER_TEXT_TOP_OFFSET_EM: 0.2,
    WEEK_HEADER_TEXT_SIDE_OFFSET_EM: 0.4,
    DAY_BOX_BORDER_WIDTH_EM: 0.15,
    TODAY_BOX_BORDER_HASH_COLOR: "#2f7cff",
    PROPOSAL_DUE_BOX_BORDER_HASH_COLOR: "#8b0000",
    TODAY_AND_PROPOSAL_DUE_SAME_DATE_BORDER_HASH_COLOR: "#6a3db8",
    DRAGOVER_MOVE_START_VALID_BG_HASH_COLOR: "#f6e6d6",
    DRAGOVER_RESIZE_END_VALID_BG_HASH_COLOR: "#e6f6e6",
    DRAGOVER_RESIZE_END_INVALID_BG_HASH_COLOR: "#f6e6e6",
    EVENT_LANE_HEIGHT_EM: 1.4,
    EVENT_LANE_GAP_EM: 0.15,
    EVENT_BARS_TOP_OFFSET_EM: 0.2,
    EVENT_BARS_BOTTOM_OFFSET_EM: 0.2
  };

  //internal functions
  const date_to_key = (i_dateObj) => {
    return JSFUNC.get_dateYmd_from_jsDateObj_and_utctf(i_dateObj, false);
  };

  const date_with_days_added = (i_dateObj, i_daysToAdd) => {
    return JSFUNC.jsdateobj_add_days(i_dateObj, i_daysToAdd);
  };

  const start_of_day = (i_dateObj) => {
    const localDateYmd = JSFUNC.get_dateYmd_from_jsDateObj_and_utctf(i_dateObj, false);
    return JSFUNC.convert_mysqldate_to_jsdateobj(localDateYmd);
  };

  const is_valid_jsdate_obj = (i_jsDateObj) => {
    return ((i_jsDateObj instanceof Date) && !Number.isNaN(JSFUNC.num_seconds_from_jsDateObj1_to_jsDateObj2(i_jsDateObj, i_jsDateObj)));
  };

  const compare_jsdate_objs = (i_jsDateObjA, i_jsDateObjB) => {
    return JSFUNC.num_seconds_from_jsDateObj1_to_jsDateObj2(i_jsDateObjB, i_jsDateObjA);
  };

  const num_days_between_dates = (i_startDateObj, i_endDateObj) => {
    return JSFUNC.num_days_from_jsDateObj1_to_jsDateObj2(i_startDateObj, i_endDateObj);
  };

  const normalized_week_start_day_index = (i_rawDayIndex) => {
    const dayIndexNumber = Number(i_rawDayIndex);
    if(!Number.isInteger(dayIndexNumber) || dayIndexNumber < 0 || dayIndexNumber > 6) {
      return 0;
    }
    return dayIndexNumber;
  };

  const week_start_date_from_date = (i_dateObj, i_weekStartDayIndex0To6) => {
    const daysBackToWeekStart = (i_dateObj.getDay() - i_weekStartDayIndex0To6 + 7) % 7;
    return date_with_days_added(i_dateObj, -daysBackToWeekStart);
  };

  const week_end_date_from_date = (i_dateObj, i_weekStartDayIndex0To6) => {
    const weekStartDate = week_start_date_from_date(i_dateObj, i_weekStartDayIndex0To6);
    return date_with_days_added(weekStartDate, 6);
  };

  const synthetic_zero_date_from_week_start_day_index = (i_weekStartDayIndex0To6) => {
    const targetDayIndex0To6 = (i_weekStartDayIndex0To6 + 6) % 7;
    const baseDate = JSFUNC.convert_mysqldate_to_jsdateobj("2024-01-01");
    const daysForwardToTarget = (targetDayIndex0To6 - baseDate.getDay() + 7) % 7;
    return date_with_days_added(baseDate, daysForwardToTarget);
  };

  const memoizedCalendarDataObj = React.useMemo(() => {
    //pre-process and normalize input data
    const weekStartDayIndex0To6 = normalized_week_start_day_index(p_weekStartDayIndex0To6);
    const todayDateKey = JSFUNC.now_dateYmd();

    let computedWeekHeightEm = baseWeekHeightEm;

    let proposalDueDateYmdLocal = JSFUNC.blank_date();
    let proposalDueTimeLocalString = "--:--";
    if(JSFUNC.datetime_is_filled_out_tf(p_proposalDueDateCeDateTimeUtc)) {
      proposalDueDateYmdLocal = JSFUNC.convert_ce_datetimeutc_to_mysqldatelocal(p_proposalDueDateCeDateTimeUtc);
      const proposalDueDateTimeJsObj = JSFUNC.convert_ce_datetimeutc_to_jsdateobj(p_proposalDueDateCeDateTimeUtc);
      proposalDueTimeLocalString = JSFUNC.get_giA_time_with_59sec_not_set_from_jsdateobj_and_utctf(proposalDueDateTimeJsObj, false);
    }

    let proposalDueDateKey = undefined;
    if(JSFUNC.date_is_filled_out_tf(proposalDueDateYmdLocal)) {
      const proposalDueDateObj = JSFUNC.convert_mysqldate_to_jsdateobj(proposalDueDateYmdLocal);
      if(is_valid_jsdate_obj(proposalDueDateObj)) {
        proposalDueDateKey = date_to_key(start_of_day(proposalDueDateObj));
      }
    }

    let firstDate = undefined;
    let lastDate = undefined;
    let zeroDateKey = undefined;
    let zeroDateReferenceDateObj = undefined;
    let weekRowsArrayOfObjs = [];
    let normalizedEventsArrayOfObjs = [];
    let leftLabelGroupsArrayOfObjs = [];

    if(p_inputDatesRealCalendarTrueCountdownToZeroFalse) {
      const startDateObj = JSFUNC.convert_mysqldate_to_jsdateobj(p_startDateYmd);
      const endDateObj = JSFUNC.convert_mysqldate_to_jsdateobj(p_endDateYmd);
      const startDateIsValidTF = is_valid_jsdate_obj(startDateObj);
      const endDateIsValidTF = is_valid_jsdate_obj(endDateObj);
      if(!startDateIsValidTF || !endDateIsValidTF) {
        return({
          invalidDateMessageString: "Unable to draw calendar: invalid " + (startDateIsValidTF ? "end" : "start") + " date",
          weekHeightEm: computedWeekHeightEm,
          weekStartDayIndex0To6: weekStartDayIndex0To6,
          todayDateKey: todayDateKey,
          proposalDueDateKey: proposalDueDateKey,
          zeroDateKey: zeroDateKey,
          leftLabelGroupsArrayOfObjs: [],
          weekRowsArrayOfObjs: [],
          weekBarsMapByWeekIndex: {},
          totalCalendarWeeks: 0,
          orderedDayNamesArray: [],
          eventObjByID: {}
        });
      }

      const startDate = start_of_day(startDateObj);
      const endDate = start_of_day(endDateObj);
      const safeEndDate = ((compare_jsdate_objs(endDate, startDate) >= 0) ? (endDate) : (startDate));

      firstDate = week_start_date_from_date(startDate, weekStartDayIndex0To6);
      lastDate = week_end_date_from_date(safeEndDate, weekStartDayIndex0To6);
    }
    else {
      zeroDateReferenceDateObj = synthetic_zero_date_from_week_start_day_index(weekStartDayIndex0To6);
      zeroDateKey = date_to_key(zeroDateReferenceDateObj);
    }

    for(let e = 0; e < calendarEventsArrayOfObjs.length; e++) {
      const eventObj = calendarEventsArrayOfObjs[e];
      if(eventObj === undefined || eventObj === null) {
        continue;
      }

      const startCEDateTimeUtc = eventObj.startCEDateTimeUtc;
      const endCEDateTimeUtcRaw = eventObj.endCEDateTimeUtc;
      if(!JSFUNC.datetime_is_filled_out_tf(startCEDateTimeUtc)) {
        continue;
      }

      const startDateTimeRaw = JSFUNC.convert_ce_datetimeutc_to_jsdateobj(startCEDateTimeUtc);
      if(!is_valid_jsdate_obj(startDateTimeRaw)) {
        continue;
      }

      const endCEDateTimeUtc = ((JSFUNC.datetime_is_filled_out_tf(endCEDateTimeUtcRaw)) ? (endCEDateTimeUtcRaw) : (startCEDateTimeUtc));
      const endDateTimeRaw = JSFUNC.convert_ce_datetimeutc_to_jsdateobj(endCEDateTimeUtc);
      const safeStartDateTime = ((is_valid_jsdate_obj(endDateTimeRaw) && compare_jsdate_objs(startDateTimeRaw, endDateTimeRaw) <= 0) ? (startDateTimeRaw) : ((is_valid_jsdate_obj(endDateTimeRaw)) ? (endDateTimeRaw) : (startDateTimeRaw)));
      const safeEndDateTime = ((is_valid_jsdate_obj(endDateTimeRaw) && compare_jsdate_objs(startDateTimeRaw, endDateTimeRaw) <= 0) ? (endDateTimeRaw) : (startDateTimeRaw));
      const startDayDate = start_of_day(safeStartDateTime);
      const endDayDate = start_of_day(safeEndDateTime);

      normalizedEventsArrayOfObjs.push({
        ...eventObj,
        sourceIndex: ((Number.isFinite(eventObj.sourceIndex)) ? (eventObj.sourceIndex) : (e)),
        startCEDateTimeUtc: startCEDateTimeUtc,
        endCEDateTimeUtc: endCEDateTimeUtc,
        startDayDateKey: date_to_key(startDayDate),
        endDayDateKey: date_to_key(endDayDate),
        startDayDate: startDayDate,
        endDayDate: endDayDate,
        startDateTime: safeStartDateTime,
        endDateTime: safeEndDateTime
      });
    }

    //"Auto" week height mode derives a single row height that can fit the max number of events occurring on any single day across all milestone events.
    if(weekHeightAutoTF) {
      const eventsCountByDateKeyObj = {};
      let maxEventsOnSameDay = 0;

      for(let i = 0; i < normalizedEventsArrayOfObjs.length; i++) {
        const eventObj = normalizedEventsArrayOfObjs[i];
        let dayCursorDate = new Date(eventObj.startDayDate.getTime());
        const endDayDate = eventObj.endDayDate;

        while(compare_jsdate_objs(dayCursorDate, endDayDate) <= 0) {
          const dayKey = date_to_key(dayCursorDate);
          const nextCount = ((eventsCountByDateKeyObj[dayKey] || 0) + 1);
          eventsCountByDateKeyObj[dayKey] = nextCount;
          if(nextCount > maxEventsOnSameDay) {
            maxEventsOnSameDay = nextCount;
          }
          dayCursorDate = date_with_days_added(dayCursorDate, 1);
        }
      }

      const lanesNeeded = Math.max(1, maxEventsOnSameDay);
      const eventBarVerticalBorderTotalEm = (2 / 16); // event bars use a 1px top and bottom border
      const minRequiredWeekHeightEm = (
        calendarUiConstantsObj.WEEK_HEADER_HEIGHT_EM +
        calendarUiConstantsObj.EVENT_BARS_TOP_OFFSET_EM +
        calendarUiConstantsObj.EVENT_BARS_BOTTOM_OFFSET_EM +
        (lanesNeeded * calendarUiConstantsObj.EVENT_LANE_HEIGHT_EM) +
        (Math.max(0, lanesNeeded - 1) * calendarUiConstantsObj.EVENT_LANE_GAP_EM) +
        eventBarVerticalBorderTotalEm
      );
      computedWeekHeightEm = Math.max(3, minRequiredWeekHeightEm);
    }

    if(!p_inputDatesRealCalendarTrueCountdownToZeroFalse) {
      let highestNumDaysPriorToZeroDate = 0;
      let lowestNumDaysPriorToZeroDate = 0;
      for(let i = 0; i < normalizedEventsArrayOfObjs.length; i++) {
        const eventObj = normalizedEventsArrayOfObjs[i];
        const numDaysPriorToZeroDate = Number(eventObj.numDaysPriorToZeroDate);
        const endNumDaysPriorToZeroDate = Number(eventObj.endNumDaysPriorToZeroDate);
        if(Number.isFinite(numDaysPriorToZeroDate)) {
          highestNumDaysPriorToZeroDate = Math.max(highestNumDaysPriorToZeroDate, numDaysPriorToZeroDate);
        }
        if(Number.isFinite(endNumDaysPriorToZeroDate)) {
          lowestNumDaysPriorToZeroDate = Math.min(lowestNumDaysPriorToZeroDate, endNumDaysPriorToZeroDate);
        }
      }

      const countdownMustDrawNumDaysPriorMax = Number(p_countdownMustDrawNumDaysPriorMax);
      if(Number.isFinite(countdownMustDrawNumDaysPriorMax)) {
        highestNumDaysPriorToZeroDate = Math.max(highestNumDaysPriorToZeroDate, Math.round(countdownMustDrawNumDaysPriorMax));
      }

      const countdownMustDrawNumDaysPriorMin = Number(p_countdownMustDrawNumDaysPriorMin);
      if(Number.isFinite(countdownMustDrawNumDaysPriorMin)) {
        lowestNumDaysPriorToZeroDate = Math.min(lowestNumDaysPriorToZeroDate, Math.round(countdownMustDrawNumDaysPriorMin));
      }

      const highestNumRemainder = ((highestNumDaysPriorToZeroDate % 7) + 7) % 7;
      const firstDisplayedNumDaysPriorToZeroDate = highestNumDaysPriorToZeroDate + ((6 - highestNumRemainder + 7) % 7);
      const totalCountdownCalendarDays = (firstDisplayedNumDaysPriorToZeroDate - lowestNumDaysPriorToZeroDate) + 1;
      const numWeeks = Math.max(1, Math.ceil(totalCountdownCalendarDays / 7));
      const lastDisplayedNumDaysPriorToZeroDate = firstDisplayedNumDaysPriorToZeroDate - ((numWeeks * 7) - 1);

      firstDate = start_of_day(date_with_days_added(zeroDateReferenceDateObj, -firstDisplayedNumDaysPriorToZeroDate));
      lastDate = start_of_day(date_with_days_added(zeroDateReferenceDateObj, -lastDisplayedNumDaysPriorToZeroDate));
    }

    const numWeeks = Math.floor(num_days_between_dates(firstDate, lastDate) / 7) + 1;
    for(let w = 0; w < numWeeks; w++) {
      const weekStartDate = date_with_days_added(firstDate, w * 7);
      const daysArrayOfObjs = [];
      for(let d = 0; d < 7; d++) {
        const dayDate = date_with_days_added(weekStartDate, d);
        let dayDisplayText = "";
        let isZeroDateTF = false;
        let isNegativeCountdownDayTF = false;

        if(p_inputDatesRealCalendarTrueCountdownToZeroFalse) {
          dayDisplayText = String(dayDate.getDate());
        }
        else {
          const numDaysPriorToZeroDate = num_days_between_dates(dayDate, zeroDateReferenceDateObj);
          dayDisplayText = String(numDaysPriorToZeroDate);
          isZeroDateTF = (numDaysPriorToZeroDate === 0);
          isNegativeCountdownDayTF = (numDaysPriorToZeroDate < 0);
        }

        const dayMonthBgColor = calendarUiConstantsObj.ALTERNATING_MONTH_WEEKDAY_BG_HASH_COLORS_ARRAY[dayDate.getMonth() % 2];
        const weekendDayMonthBgColor = calendarUiConstantsObj.ALTERNATING_MONTH_WEEKEND_BG_HASH_COLORS_ARRAY[dayDate.getMonth() % 2];
        const isWeekendDayTF = (dayDate.getDay() === 0 || dayDate.getDay() === 6);
        const countdownDefaultDayBgColor = calendarUiConstantsObj.ALTERNATING_MONTH_WEEKDAY_BG_HASH_COLORS_ARRAY[0];
        const countdownNegativeDayBgColor = calendarUiConstantsObj.ALTERNATING_MONTH_WEEKEND_BG_HASH_COLORS_ARRAY[1];
        let dayBgColor = ((isWeekendDayTF) ? (weekendDayMonthBgColor) : (dayMonthBgColor));
        if(!p_inputDatesRealCalendarTrueCountdownToZeroFalse) {
          dayBgColor = ((isNegativeCountdownDayTF) ? (countdownNegativeDayBgColor) : (countdownDefaultDayBgColor));
        }
        daysArrayOfObjs.push({
          dateObj: dayDate,
          dateKey: date_to_key(dayDate),
          dayDisplayText: dayDisplayText,
          isZeroDateTF: isZeroDateTF,
          dayBgColor: dayBgColor
        });
      }

      weekRowsArrayOfObjs.push({
        weekIndex: w,
        weekStartDate: weekStartDate,
        weekEndDate: date_with_days_added(weekStartDate, 6),
        daysArrayOfObjs: daysArrayOfObjs
      });
    }

    const visibleEventsArrayOfObjs = [];
    for(let i = 0; i < normalizedEventsArrayOfObjs.length; i++) {
      const eventObj = normalizedEventsArrayOfObjs[i];
      if((compare_jsdate_objs(eventObj.endDayDate, firstDate) >= 0) && (compare_jsdate_objs(eventObj.startDayDate, lastDate) <= 0)) {
        visibleEventsArrayOfObjs.push(eventObj);
      }
    }

    if(p_inputDatesRealCalendarTrueCountdownToZeroFalse) {
      const monthNamesArray = JSFUNC.all_12_month_full_names_array();
      for(let i = 0; i < weekRowsArrayOfObjs.length; i++) {
        const weekRowObj = weekRowsArrayOfObjs[i];
        let monthStartDayObj = undefined;
        for(let d = 0; d < weekRowObj.daysArrayOfObjs.length; d++) {
          const dayObj = weekRowObj.daysArrayOfObjs[d];
          if(Number(dayObj.dayDisplayText) === 1) {
            monthStartDayObj = dayObj;
            break;
          }
        }

        const shouldStartNewGroupTF = (i === 0 || monthStartDayObj !== undefined);
        if(shouldStartNewGroupTF) {
          const labelDateObj = ((monthStartDayObj !== undefined) ? (monthStartDayObj.dateObj) : (weekRowObj.daysArrayOfObjs[0].dateObj));
          const monthKey = labelDateObj.getFullYear() + "-" + JSFUNC.zero_pad_integer_from_left(labelDateObj.getMonth() + 1, 2);
          leftLabelGroupsArrayOfObjs.push({
            groupKey: monthKey,
            labelText: monthNamesArray[labelDateObj.getMonth()] + " " + labelDateObj.getFullYear(),
            numWeeks: 0
          });
        }

        leftLabelGroupsArrayOfObjs[leftLabelGroupsArrayOfObjs.length - 1].numWeeks += 1;
      }
    }
    else {
      for(let i = 0; i < weekRowsArrayOfObjs.length; i++) {
        leftLabelGroupsArrayOfObjs.push({
          groupKey: "countdown_week_" + weekRowsArrayOfObjs[i].weekIndex,
          labelText: "",
          numWeeks: 1
        });
      }
    }

    const sortedEventsArrayOfObjs = visibleEventsArrayOfObjs.sort((a, b) => {
      const startCompare = compare_jsdate_objs(a.startDateTime, b.startDateTime);
      if(startCompare !== 0) {
        return startCompare;
      }
      const endCompare = compare_jsdate_objs(a.endDateTime, b.endDateTime);
      if(endCompare !== 0) {
        return endCompare;
      }
      return a.sourceIndex - b.sourceIndex;
    });

    const eventNamesByDateKeyObj = {};
    for(let i = 0; i < sortedEventsArrayOfObjs.length; i++) {
      const eventObj = sortedEventsArrayOfObjs[i];
      const eventNameText = ((JSFUNC.text_or_number_is_filled_out_tf(eventObj.eventName)) ? (String(eventObj.eventName)) : ("(Untitled Event)"));
      let dayCursorDate = new Date(eventObj.startDayDate.getTime());
      const endDayDate = eventObj.endDayDate;

      while(compare_jsdate_objs(dayCursorDate, endDayDate) <= 0) {
        const dayKey = date_to_key(dayCursorDate);
        if(eventNamesByDateKeyObj[dayKey] === undefined) {
          eventNamesByDateKeyObj[dayKey] = [];
        }
        eventNamesByDateKeyObj[dayKey].push(eventNameText);
        dayCursorDate = date_with_days_added(dayCursorDate, 1);
      }
    }

    for(let w = 0; w < weekRowsArrayOfObjs.length; w++) {
      for(let d = 0; d < weekRowsArrayOfObjs[w].daysArrayOfObjs.length; d++) {
        const dayObj = weekRowsArrayOfObjs[w].daysArrayOfObjs[d];
        let dayLabelTextTF = false;
        let dayLabelText = "";
        let dayLabelFontHashColor = undefined;
        let dayIsTodayTF = false;
        let dayIsProposalDueTF = false;
        if(p_inputDatesRealCalendarTrueCountdownToZeroFalse) {
          dayIsTodayTF = (dayObj.dateKey === todayDateKey);
          dayIsProposalDueTF = (JSFUNC.text_or_number_is_filled_out_tf(proposalDueDateKey) && dayObj.dateKey === proposalDueDateKey);
        }
        else {
          dayIsTodayTF = false;
          dayIsProposalDueTF = (dayObj.isZeroDateTF === true && dayObj.dateKey === zeroDateKey);
        }

        if(dayIsProposalDueTF) {
          dayLabelTextTF = true;
          dayLabelText = "Proposal Due" + ((p_inputDatesRealCalendarTrueCountdownToZeroFalse) ? (" (" + proposalDueTimeLocalString + ")") : (""));
          dayLabelFontHashColor = calendarUiConstantsObj.PROPOSAL_DUE_BOX_BORDER_HASH_COLOR;
        }
        else if(dayIsTodayTF) {
          dayLabelTextTF = true;
          dayLabelText = "Today";
          dayLabelFontHashColor = calendarUiConstantsObj.TODAY_BOX_BORDER_HASH_COLOR;
        }

        dayObj.dayLabelTextTF = dayLabelTextTF;
        dayObj.dayLabelText = dayLabelText;
        dayObj.dayLabelFontHashColor = dayLabelFontHashColor;

        let dayDateHoverText;
        if(p_inputDatesRealCalendarTrueCountdownToZeroFalse) { //calendar mode
          dayDateHoverText = dayObj.dateObj.toLocaleDateString("en-US", {month:"long", day:"numeric", year:"numeric"});
        }
        else { //countdown mode - show days relative to zero date
          const numDaysPriorToZeroDate = num_days_between_dates(dayObj.dateObj, zeroDateReferenceDateObj);
          if(numDaysPriorToZeroDate === 0) {
            dayDateHoverText = "Proposal Due Date (0)";
          }
          else if(numDaysPriorToZeroDate > 0) {
            dayDateHoverText = numDaysPriorToZeroDate + " day" + ((numDaysPriorToZeroDate !== 1) ? "s" : "") + " prior to the Proposal Due Date";
          }
          else {
            const numDaysAfterZeroDate = (-numDaysPriorToZeroDate);
            dayDateHoverText = numDaysAfterZeroDate + " day" + ((numDaysAfterZeroDate !== 1) ? "s" : "") + " after the Proposal Due Date";
          }
        }
        const eventNamesArray = ((JSFUNC.is_array(eventNamesByDateKeyObj[dayObj.dateKey])) ? (eventNamesByDateKeyObj[dayObj.dateKey]) : ([]));
        dayObj.hoverText = dayDateHoverText + "\r\n" + ((eventNamesArray.length > 0) ? (eventNamesArray.join("\r\n")) : ("--No Events--"));
      }
    }

    const weekBarsMapByWeekIndex = {};
    for(let w = 0; w < weekRowsArrayOfObjs.length; w++) {
      const weekRowObj = weekRowsArrayOfObjs[w];
      const weekStartDate = weekRowObj.weekStartDate;
      const weekEndDate = weekRowObj.weekEndDate;

      const eventSegmentsArrayOfObjs = [];
      for(let e = 0; e < sortedEventsArrayOfObjs.length; e++) {
        const eventObj = sortedEventsArrayOfObjs[e];
        const segmentStartDate = ((compare_jsdate_objs(eventObj.startDayDate, weekStartDate) > 0) ? (eventObj.startDayDate) : (weekStartDate));
        const segmentEndDate = ((compare_jsdate_objs(eventObj.endDayDate, weekEndDate) < 0) ? (eventObj.endDayDate) : (weekEndDate));
        if(compare_jsdate_objs(segmentStartDate, segmentEndDate) > 0) {
          continue;
        }

        const startDayIndex = Math.max(0, num_days_between_dates(weekStartDate, segmentStartDate));
        const endDayIndex = Math.min(6, num_days_between_dates(weekStartDate, segmentEndDate));

        eventSegmentsArrayOfObjs.push({
          eventObj: eventObj,
          startDayIndex: startDayIndex,
          endDayIndex: endDayIndex
        });
      }

      const laneEndDayIndexArray = [];
      const positionedSegmentsArrayOfObjs = [];
      for(let s = 0; s < eventSegmentsArrayOfObjs.length; s++) {
        const segmentObj = eventSegmentsArrayOfObjs[s];
        var placedLaneIndex = -1;
        for(let laneIndex = 0; laneIndex < laneEndDayIndexArray.length; laneIndex++) {
          if(segmentObj.startDayIndex > laneEndDayIndexArray[laneIndex]) {
            placedLaneIndex = laneIndex;
            break;
          }
        }

        if(placedLaneIndex === -1) {
          placedLaneIndex = laneEndDayIndexArray.length;
          laneEndDayIndexArray.push(segmentObj.endDayIndex);
        }
        else {
          laneEndDayIndexArray[placedLaneIndex] = segmentObj.endDayIndex;
        }

        positionedSegmentsArrayOfObjs.push({
          ...segmentObj,
          laneIndex: placedLaneIndex
        });
      }

      weekBarsMapByWeekIndex[weekRowObj.weekIndex] = {
        maxLaneCount: laneEndDayIndexArray.length,
        positionedSegmentsArrayOfObjs: positionedSegmentsArrayOfObjs
      };
    }
    const totalCalendarWeeks = weekRowsArrayOfObjs.length;
    const dayNamesArray = JSFUNC.all_7_day_3_letter_names_starting_sunday_array();
    const orderedDayNamesArray = [];
    for(let dayOffset = 0; dayOffset < 7; dayOffset++) {
      if(p_inputDatesRealCalendarTrueCountdownToZeroFalse) {
        orderedDayNamesArray.push(dayNamesArray[(weekStartDayIndex0To6 + dayOffset) % 7]);
      }
      else {
        orderedDayNamesArray.push("");
      }
    }

    const eventObjByID = {};
    for(let i = 0; i < sortedEventsArrayOfObjs.length; i++) {
      const eventObj = sortedEventsArrayOfObjs[i];
      if(Number.isFinite(eventObj.id)) {
        eventObjByID[eventObj.id] = eventObj;
      }
    }

    return({
      invalidDateMessageString: undefined,
      weekHeightEm: computedWeekHeightEm,
      weekStartDayIndex0To6: weekStartDayIndex0To6,
      todayDateKey: todayDateKey,
      proposalDueDateKey: proposalDueDateKey,
      zeroDateKey: zeroDateKey,
      leftLabelGroupsArrayOfObjs: leftLabelGroupsArrayOfObjs,
      weekRowsArrayOfObjs: weekRowsArrayOfObjs,
      weekBarsMapByWeekIndex: weekBarsMapByWeekIndex,
      totalCalendarWeeks: totalCalendarWeeks,
      orderedDayNamesArray: orderedDayNamesArray,
      eventObjByID: eventObjByID
    });
  }, [
    p_inputDatesRealCalendarTrueCountdownToZeroFalse,
    calendarEventsArrayOfObjs,
    p_proposalDueDateCeDateTimeUtc,
    p_startDateYmd,
    p_endDateYmd,
    p_weekHeightEm,
    p_weekStartDayIndex0To6,
    p_countdownMustDrawNumDaysPriorMax,
    p_countdownMustDrawNumDaysPriorMin
  ]);

  const weekHeightEm = memoizedCalendarDataObj.weekHeightEm;
  const weekStartDayIndex0To6 = memoizedCalendarDataObj.weekStartDayIndex0To6;
  const todayDateKey = memoizedCalendarDataObj.todayDateKey;
  const proposalDueDateKey = memoizedCalendarDataObj.proposalDueDateKey;
  const zeroDateKey = memoizedCalendarDataObj.zeroDateKey;
  const leftLabelGroupsArrayOfObjs = memoizedCalendarDataObj.leftLabelGroupsArrayOfObjs;
  const weekRowsArrayOfObjs = memoizedCalendarDataObj.weekRowsArrayOfObjs;
  const weekBarsMapByWeekIndex = memoizedCalendarDataObj.weekBarsMapByWeekIndex;
  const totalCalendarWeeks = memoizedCalendarDataObj.totalCalendarWeeks;
  const orderedDayNamesArray = memoizedCalendarDataObj.orderedDayNamesArray;
  const eventObjByID = memoizedCalendarDataObj.eventObjByID;

  if(JSFUNC.is_string_not_empty(memoizedCalendarDataObj.invalidDateMessageString)) {
    return(
      <LibraryReact.DivFont p_class="fontItalic fontTextLighter" p_fontClass="font11">
        {memoizedCalendarDataObj.invalidDateMessageString}
      </LibraryReact.DivFont>
    );
  }

  const get_resize_drag_data_obj_or_undefined = (i_dragDataString) => {
    if(!JSFUNC.is_string_not_empty(i_dragDataString)) {
      return undefined;
    }

    try {
      const parsedObj = JSON.parse(i_dragDataString);
      if(parsedObj === null || typeof(parsedObj) !== "object") {
        return undefined;
      }
      if(!Number.isFinite(Number(parsedObj.eventID))) {
        return undefined;
      }
      if(!JSFUNC.in_array(parsedObj.dragType, ["move_start_keep_duration", "resize_end_only"])) {
        return undefined;
      }
      return {
        eventID: Number(parsedObj.eventID),
        dragType: parsedObj.dragType
      };
    }
    catch(errObj) {
      return undefined;
    }
  };

  const can_drop_resize_on_day_tf = (i_dragDataObj, i_dayDateKey) => {
    if(i_dragDataObj === undefined || !JSFUNC.date_is_filled_out_tf(i_dayDateKey)) {
      return false;
    }

    const eventObj = eventObjByID[i_dragDataObj.eventID];
    if(eventObj === undefined) {
      return false;
    }

    if(i_dragDataObj.dragType === "resize_end_only") {
      return (i_dayDateKey >= eventObj.startDayDateKey);
    }

    return true;
  };

  const resize_end_before_start_day_tf = (i_dragDataObj, i_dayDateKey) => {
    if(i_dragDataObj === undefined || !JSFUNC.date_is_filled_out_tf(i_dayDateKey)) {
      return false;
    }
    if(i_dragDataObj.dragType !== "resize_end_only") {
      return false;
    }

    const eventObj = eventObjByID[i_dragDataObj.eventID];
    if(eventObj === undefined) {
      return false;
    }

    return (i_dayDateKey < eventObj.startDayDateKey);
  };

  const compose_cedatetimeutc_from_date_key_and_source_datetime = (i_dayDateKey, i_sourceCEDateTimeUtc) => {
    if(!JSFUNC.date_is_filled_out_tf(i_dayDateKey)) {
      return "";
    }
    if(!JSFUNC.datetime_is_filled_out_tf(i_sourceCEDateTimeUtc)) {
      return i_dayDateKey + " 23:59:58";
    }

    const sourceDateTimeString = String(i_sourceCEDateTimeUtc);
    const timePortion = sourceDateTimeString.substring(10);
    if(!JSFUNC.is_string_not_empty(timePortion)) {
      return i_dayDateKey + " 23:59:58";
    }
    return i_dayDateKey + timePortion;
  };

  const ondragstart_event_resize_handle = (i_domEvent, i_eventObj, i_dragType) => {
    if(!JSFUNC.is_function(f_onEditSingleEventFields) || i_domEvent === undefined || i_domEvent.dataTransfer === undefined) {
      return;
    }

    const dragDataObj = {
      eventID: i_eventObj.id,
      dragType: i_dragType
    };
    activeResizeDragDataObjRef.current = dragDataObj;

    i_domEvent.stopPropagation();
    i_domEvent.dataTransfer.effectAllowed = "move";
    i_domEvent.dataTransfer.setData("text/plain", JSON.stringify(dragDataObj));
  };

  const ondragend_handle = () => {
    activeResizeDragDataObjRef.current = undefined;
    activeDropIndicatorObjRef.current = undefined;
    f_setActiveDropIndicatorObjOrUndefined(undefined);
  };

  const set_active_drop_indicator_if_changed = (i_newIndicatorObjOrUndefined) => {
    const currentIndicatorObjOrUndefined = activeDropIndicatorObjRef.current;
    const changedTF = (
      (currentIndicatorObjOrUndefined === undefined && i_newIndicatorObjOrUndefined !== undefined) ||
      (currentIndicatorObjOrUndefined !== undefined && i_newIndicatorObjOrUndefined === undefined) ||
      (
        currentIndicatorObjOrUndefined !== undefined &&
        i_newIndicatorObjOrUndefined !== undefined &&
        (
          currentIndicatorObjOrUndefined.dayKey !== i_newIndicatorObjOrUndefined.dayKey ||
          currentIndicatorObjOrUndefined.visualFlag !== i_newIndicatorObjOrUndefined.visualFlag
        )
      )
    );

    if(changedTF) {
      activeDropIndicatorObjRef.current = i_newIndicatorObjOrUndefined;
      f_setActiveDropIndicatorObjOrUndefined(i_newIndicatorObjOrUndefined);
    }
  };

  const ondragover_day_cell = (i_domEvent, i_dayObj) => {
    if(!JSFUNC.is_function(f_onEditSingleEventFields) || i_domEvent === undefined || i_domEvent.dataTransfer === undefined) {
      return;
    }

    const dragDataObj = get_resize_drag_data_obj_or_undefined(i_domEvent.dataTransfer.getData("text/plain")) || activeResizeDragDataObjRef.current;
    const canDropTF = can_drop_resize_on_day_tf(dragDataObj, i_dayObj.dateKey);
    const resizeEndBeforeStartTF = resize_end_before_start_day_tf(dragDataObj, i_dayObj.dateKey);

    if(canDropTF) {
      i_domEvent.preventDefault();
      i_domEvent.dataTransfer.dropEffect = "move";
      const visualFlag = ((dragDataObj.dragType === "move_start_keep_duration") ? ("move_valid") : ("resize_valid"));
      set_active_drop_indicator_if_changed({dayKey:i_dayObj.dateKey, visualFlag:visualFlag});
    }
    else {
      i_domEvent.dataTransfer.dropEffect = "none";
      if(resizeEndBeforeStartTF) {
        set_active_drop_indicator_if_changed({dayKey:i_dayObj.dateKey, visualFlag:"resize_invalid_before_start"});
      }
      else {
        set_active_drop_indicator_if_changed(undefined);
      }
    }
  };

  const ondrop_day_cell = (i_domEvent, i_dayObj) => {
    if(!JSFUNC.is_function(f_onEditSingleEventFields) || i_domEvent === undefined || i_domEvent.dataTransfer === undefined) {
      return;
    }

    const dragDataObj = get_resize_drag_data_obj_or_undefined(i_domEvent.dataTransfer.getData("text/plain")) || activeResizeDragDataObjRef.current;
    if(!can_drop_resize_on_day_tf(dragDataObj, i_dayObj.dateKey)) {
      activeResizeDragDataObjRef.current = undefined;
      set_active_drop_indicator_if_changed(undefined);
      return;
    }

    const eventObj = eventObjByID[dragDataObj.eventID];
    if(eventObj === undefined) {
      activeResizeDragDataObjRef.current = undefined;
      set_active_drop_indicator_if_changed(undefined);
      return;
    }

    i_domEvent.preventDefault();

    if(dragDataObj.dragType === "resize_end_only") {
      const newEndCEDateTimeUtcValue = compose_cedatetimeutc_from_date_key_and_source_datetime(i_dayObj.dateKey, eventObj.endCEDateTimeUtc);
      if(JSFUNC.datetime_is_filled_out_tf(newEndCEDateTimeUtcValue)) {
        f_onEditSingleEventFields(eventObj, ["end_ce_datetime_utc"], [newEndCEDateTimeUtcValue]);
      }
      activeResizeDragDataObjRef.current = undefined;
      set_active_drop_indicator_if_changed(undefined);
      return;
    }

    const newStartCEDateTimeUtcValue = compose_cedatetimeutc_from_date_key_and_source_datetime(i_dayObj.dateKey, eventObj.startCEDateTimeUtc);
    if(!JSFUNC.datetime_is_filled_out_tf(newStartCEDateTimeUtcValue)) {
      return;
    }

    const startDateTimeJsObj = JSFUNC.convert_ce_datetimeutc_to_jsdateobj(eventObj.startCEDateTimeUtc);
    const endDateTimeJsObj = JSFUNC.convert_ce_datetimeutc_to_jsdateobj(eventObj.endCEDateTimeUtc);
    const newStartDateTimeJsObj = JSFUNC.convert_ce_datetimeutc_to_jsdateobj(newStartCEDateTimeUtcValue);
    const durationNumSeconds = Math.max(0, Math.round(JSFUNC.num_seconds_from_jsDateObj1_to_jsDateObj2(startDateTimeJsObj, endDateTimeJsObj)));
    const newEndDateTimeJsObj = new Date(newStartDateTimeJsObj.getTime() + (durationNumSeconds * 1000));
    const newEndCEDateTimeUtcValue = JSFUNC.get_naturalDateTimeYmdHis_local_or_utc_from_jsDateObj_and_utctf(newEndDateTimeJsObj, true);

    f_onEditSingleEventFields(eventObj, ["start_ce_datetime_utc", "end_ce_datetime_utc"], [newStartCEDateTimeUtcValue, newEndCEDateTimeUtcValue]);
    activeResizeDragDataObjRef.current = undefined;
    set_active_drop_indicator_if_changed(undefined);
  };

  return(
    <div className="displayFlexRow" style={{minWidth:(calendarUiConstantsObj.CALENDAR_GRID_MIN_WIDTH_EM + calendarUiConstantsObj.MONTH_LABEL_WIDTH_EM) + "em"}}>
      <ProposalManagementCalendarMonthLabelColumn
        p_leftLabelGroupsArray={leftLabelGroupsArrayOfObjs}
        p_totalWeeks={totalCalendarWeeks}
        p_weekHeightEm={weekHeightEm}
        p_calendarUiConstantsObj={calendarUiConstantsObj}
      />
      <div className="flex11a displayFlexColumn" style={{minWidth:calendarUiConstantsObj.CALENDAR_GRID_MIN_WIDTH_EM + "em"}}>
        <ProposalManagementCalendarDayNamesHeader
          p_orderedDayNamesArray={orderedDayNamesArray}
          p_calendarUiConstantsObj={calendarUiConstantsObj}
        />
        {weekRowsArrayOfObjs.map((m_weekRowObj) => 
          <ProposalManagementCalendarWeekRow
            key={m_weekRowObj.weekIndex}
            p_weekRowObj={m_weekRowObj}
            p_weekBarsMapByWeekIndex={weekBarsMapByWeekIndex}
            p_weekHeightEm={weekHeightEm}
            p_weekHeightIsAutoTF={weekHeightAutoTF}
            p_todayDateKey={todayDateKey}
            p_proposalDueDateKey={proposalDueDateKey}
            p_zeroDateKey={zeroDateKey}
            p_inputDatesRealCalendarTrueCountdownToZeroFalse={p_inputDatesRealCalendarTrueCountdownToZeroFalse}
            p_calendarUiConstantsObj={calendarUiConstantsObj}
            p_activeDropIndicatorObj={s_activeDropIndicatorObj}
            f_onDragStartResizeHandle={ondragstart_event_resize_handle}
            f_onDragEndHandle={ondragend_handle}
            f_onDragOverDayCell={ondragover_day_cell}
            f_onDropOnDayCell={ondrop_day_cell}
            f_onClickCalendarEvent={f_onClickCalendarEvent}
            f_onEditSingleEventFields={f_onEditSingleEventFields}
            f_onDeleteEvent={f_onDeleteEvent}
          />
        )}
      </div>
    </div>
  );
}


function ProposalManagementCalendarMonthLabelColumn(props) { //props: p_leftLabelGroupsArray, p_totalWeeks, p_weekHeightEm, p_calendarUiConstantsObj
  const p_leftLabelGroupsArray = props.p_leftLabelGroupsArray;
  const p_totalWeeks = props.p_totalWeeks;
  const p_weekHeightEm = props.p_weekHeightEm;
  const p_calendarUiConstantsObj = props.p_calendarUiConstantsObj;

  const borderLineStyleString = "solid 1px " + p_calendarUiConstantsObj.CALENDAR_GRID_BORDER_HASH_COLOR;

  return(
    <div className="flex00a displayFlexColumn" style={{flexBasis:p_calendarUiConstantsObj.MONTH_LABEL_WIDTH_EM + "em"}}>
      <div
        className="flex00a"
        style={{height:p_calendarUiConstantsObj.DAY_NAMES_HEADER_HEIGHT_EM + "em", borderTop:borderLineStyleString, borderLeft:borderLineStyleString, background:p_calendarUiConstantsObj.CALENDAR_HEADER_BG_HASH_COLOR}}
      />
      <div className="flex00a displayFlexColumn" style={{height:(p_totalWeeks * p_weekHeightEm) + "em"}}>
        {p_leftLabelGroupsArray.map((m_leftLabelGroupObj, m_leftLabelGroupIdx) => {
          const groupHeightEm = m_leftLabelGroupObj.numWeeks * p_weekHeightEm;
          const isLastLabelGroupTF = (m_leftLabelGroupIdx === p_leftLabelGroupsArray.length - 1);
          return(
            <div
              key={m_leftLabelGroupObj.groupKey}
              className="flex00a displayFlexColumnHcVc"
              style={{height:groupHeightEm + "em", background:"transparent", borderTop:borderLineStyleString, borderBottom:((isLastLabelGroupTF) ? (borderLineStyleString) : (undefined)), borderLeft:borderLineStyleString}}>
              <div className="overflowHidden nowrap" style={{maxHeight:(groupHeightEm - 0.4) + "em", writingMode:"vertical-rl", transform:"rotate(180deg)"}}>
                {JSFUNC.text_or_number_is_filled_out_tf(m_leftLabelGroupObj.labelText) &&
                  <span style={{fontSize:p_calendarUiConstantsObj.MONTH_LABEL_FONT_SIZE_EM + "em", fontWeight:"bold", color:p_calendarUiConstantsObj.MONTH_LABEL_TEXT_HASH_COLOR}}>
                    {m_leftLabelGroupObj.labelText}
                  </span>
                }
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}


function ProposalManagementCalendarDayNamesHeader(props) { //props: p_orderedDayNamesArray, p_calendarUiConstantsObj
  const p_orderedDayNamesArray = props.p_orderedDayNamesArray;
  const p_calendarUiConstantsObj = props.p_calendarUiConstantsObj;

  const borderLineStyleString = "solid 1px " + p_calendarUiConstantsObj.CALENDAR_GRID_BORDER_HASH_COLOR;

  return(
    <div className="displayFlexRow" style={{height:p_calendarUiConstantsObj.DAY_NAMES_HEADER_HEIGHT_EM + "em", borderTop:borderLineStyleString, borderRight:borderLineStyleString, borderLeft:borderLineStyleString, background:p_calendarUiConstantsObj.CALENDAR_HEADER_BG_HASH_COLOR}}>
      {p_orderedDayNamesArray.map((m_dayName, m_dayIndex) =>
        <div key={m_dayName + "_" + m_dayIndex} className="flex11a displayFlexColumnHcVc" style={{flexBasis:"100em", borderRight:((m_dayIndex < 6) ? (borderLineStyleString) : (undefined))}}>
          <LibraryReact.NowrapEllipsis p_fontClass="font10 fontBold fontTextLighter">
            {m_dayName}
          </LibraryReact.NowrapEllipsis>
        </div>
      )}
    </div>
  );
}


function ProposalManagementCalendarWeekRow(props) { //props: 
  //p_weekRowObj, p_weekBarsMapByWeekIndex, p_weekHeightEm, p_weekHeightIsAutoTF, p_todayDateKey, p_proposalDueDateKey, p_zeroDateKey, p_inputDatesRealCalendarTrueCountdownToZeroFalse, p_calendarUiConstantsObj, p_activeDropIndicatorObj, 
  //f_onDragStartResizeHandle, f_onDragEndHandle, f_onDragOverDayCell, f_onDropOnDayCell, f_onClickCalendarEvent, f_onEditSingleEventFields, f_onDeleteEvent
  const p_weekRowObj = props.p_weekRowObj;
  const p_weekBarsMapByWeekIndex = props.p_weekBarsMapByWeekIndex;
  const p_weekHeightEm = props.p_weekHeightEm;
  const p_weekHeightIsAutoTF = props.p_weekHeightIsAutoTF;
  const p_todayDateKey = props.p_todayDateKey;
  const p_proposalDueDateKey = props.p_proposalDueDateKey;
  const p_zeroDateKey = props.p_zeroDateKey;
  const p_inputDatesRealCalendarTrueCountdownToZeroFalse = props.p_inputDatesRealCalendarTrueCountdownToZeroFalse;
  const p_calendarUiConstantsObj = props.p_calendarUiConstantsObj;
  const p_activeDropIndicatorObj = props.p_activeDropIndicatorObj;
  const f_onDragStartResizeHandle = props.f_onDragStartResizeHandle;
  const f_onDragEndHandle = props.f_onDragEndHandle;
  const f_onDragOverDayCell = props.f_onDragOverDayCell;
  const f_onDropOnDayCell = props.f_onDropOnDayCell;
  const f_onClickCalendarEvent = props.f_onClickCalendarEvent;
  const f_onEditSingleEventFields = props.f_onEditSingleEventFields;
  const f_onDeleteEvent = props.f_onDeleteEvent;

  const weekBarLayoutObj = p_weekBarsMapByWeekIndex[p_weekRowObj.weekIndex] || {maxLaneCount:0, positionedSegmentsArrayOfObjs:[]};

  // Explicit layout math for how many event lanes can fit in a day cell:
  // event area = week height - header - top padding - bottom padding
  // each lane consumes lane height, and each lane after the first consumes one gap above it
  // max lanes that fit = floor((event area + gap) / (lane height + gap))
  const eventBarsAvailableHeightEm = Math.max(0, p_weekHeightEm - p_calendarUiConstantsObj.WEEK_HEADER_HEIGHT_EM - p_calendarUiConstantsObj.EVENT_BARS_TOP_OFFSET_EM - p_calendarUiConstantsObj.EVENT_BARS_BOTTOM_OFFSET_EM);
  const eventLaneStepEm = (p_calendarUiConstantsObj.EVENT_LANE_HEIGHT_EM + p_calendarUiConstantsObj.EVENT_LANE_GAP_EM);
  const maxEventLanesThatFit = Math.max(1, Math.floor((eventBarsAvailableHeightEm + p_calendarUiConstantsObj.EVENT_LANE_GAP_EM) / eventLaneStepEm));

  const maxVisibleLanesByHeight = maxEventLanesThatFit;
  const weekHasOverflowTF = ((!p_weekHeightIsAutoTF) && (weekBarLayoutObj.maxLaneCount > maxVisibleLanesByHeight));
  const maxVisibleEventLanes = ((weekHasOverflowTF) ? (Math.max(0, maxVisibleLanesByHeight - 1)) : (maxVisibleLanesByHeight));
  const placeholderLaneIndex = maxVisibleEventLanes;

  const dayRowRef = React.useRef(null);

  const get_day_obj_from_client_x = (i_clientX) => {
    if(dayRowRef.current === null) { return undefined; }
    const rect = dayRowRef.current.getBoundingClientRect();
    const dayIdx = Math.max(0, Math.min(6, Math.floor(((i_clientX - rect.left) / rect.width) * 7)));
    return p_weekRowObj.daysArrayOfObjs[dayIdx];
  };

  const visiblePositionedSegmentsArrayOfObjs = weekBarLayoutObj.positionedSegmentsArrayOfObjs.filter((m_segmentObj) => m_segmentObj.laneIndex < maxVisibleEventLanes);

  const overflowBubbleByDayIdxObj = {};
  if(weekHasOverflowTF) {
    for(let dayIdx = 0; dayIdx < 7; dayIdx++) {
      const hiddenEventNamesArray = [];
      for(let s = 0; s < weekBarLayoutObj.positionedSegmentsArrayOfObjs.length; s++) {
        const segmentObj = weekBarLayoutObj.positionedSegmentsArrayOfObjs[s];
        const dayContainsSegmentTF = (dayIdx >= segmentObj.startDayIndex && dayIdx <= segmentObj.endDayIndex);
        if(dayContainsSegmentTF && segmentObj.laneIndex >= maxVisibleEventLanes) {
          const eventName = ((JSFUNC.text_or_number_is_filled_out_tf(segmentObj.eventObj.eventName)) ? (String(segmentObj.eventObj.eventName)) : ("(Untitled Event)"));
          hiddenEventNamesArray.push(" - " + eventName);
        }
      }
      var numHiddenEvents = hiddenEventNamesArray.length;

      if(numHiddenEvents > 0) {
        const dayObj = p_weekRowObj.daysArrayOfObjs[dayIdx];
        const dayDateObj = dayObj.dateObj;
        let dayDateDisplayString = "";
        if(p_inputDatesRealCalendarTrueCountdownToZeroFalse) {
          dayDateDisplayString = dayDateObj.toLocaleDateString("en-US", {month:"long", day:"numeric", year:"numeric"});
        }
        else {
          const numDaysPriorToZeroDate = Number(dayObj.dayDisplayText);
          if(Number.isFinite(numDaysPriorToZeroDate)) {
            if(numDaysPriorToZeroDate === 0) {
              dayDateDisplayString = "Proposal Due Date (0)";
            }
            else if(numDaysPriorToZeroDate > 0) {
              dayDateDisplayString = numDaysPriorToZeroDate + " day" + ((numDaysPriorToZeroDate !== 1) ? "s" : "") + " prior to the Proposal Due Date";
            }
            else {
              const numDaysAfterZeroDate = (-numDaysPriorToZeroDate);
              dayDateDisplayString = numDaysAfterZeroDate + " day" + ((numDaysAfterZeroDate !== 1) ? "s" : "") + " after the Proposal Due Date";
            }
          }
        }
        overflowBubbleByDayIdxObj[dayIdx] = {
          numHiddenEvents: numHiddenEvents,
          hiddenEventsHoverText: numHiddenEvents + " " + JSFUNC.plural(numHiddenEvents, "event", "events") + " for " + dayDateDisplayString + " not visible (extend 'Week Height' to view):\r\n" + hiddenEventNamesArray.join("\r\n")
        };
      }
    }
  }

  return(
    <div
      className="positionRelative displayFlexColumn bgWhite"
      style={{height:p_weekHeightEm + "em", border:"solid 1px " + p_calendarUiConstantsObj.CALENDAR_GRID_BORDER_HASH_COLOR}}>
      <div ref={dayRowRef} className="displayFlexRow" style={{height:p_weekHeightEm + "em"}}>
        {p_weekRowObj.daysArrayOfObjs.map((m_dayObj, m_dayIdx) =>
          <ProposalManagementCalendarWeekRowDayCell
            key={m_dayObj.dateKey}
            p_dayObj={m_dayObj}
            p_dayIdx={m_dayIdx}
            p_todayDateKey={p_todayDateKey}
            p_proposalDueDateKey={p_proposalDueDateKey}
            p_zeroDateKey={p_zeroDateKey}
            p_inputDatesRealCalendarTrueCountdownToZeroFalse={p_inputDatesRealCalendarTrueCountdownToZeroFalse}
            p_calendarUiConstantsObj={p_calendarUiConstantsObj}
            p_activeDropIndicatorObj={p_activeDropIndicatorObj}
            f_onDragOver={f_onDragOverDayCell}
            f_onDrop={f_onDropOnDayCell}
          />
        )}
      </div>
      <div
        className="positionAbsolute overflowHidden pointerEventsNone"
        style={{top:p_calendarUiConstantsObj.WEEK_HEADER_HEIGHT_EM + p_calendarUiConstantsObj.EVENT_BARS_TOP_OFFSET_EM + "em", right:0, bottom:p_calendarUiConstantsObj.EVENT_BARS_BOTTOM_OFFSET_EM + "em", left:0}}>
        {visiblePositionedSegmentsArrayOfObjs.map((m_segmentObj) =>
          <ProposalManagementCalendarEventBar
            key={p_weekRowObj.weekIndex + "_" + m_segmentObj.eventObj.sourceIndex + "_" + m_segmentObj.startDayIndex + "_" + m_segmentObj.endDayIndex}
            p_segmentObj={m_segmentObj}
            p_weekIndex={p_weekRowObj.weekIndex}
            p_calendarUiConstantsObj={p_calendarUiConstantsObj}
            f_getDayObjFromClientX={get_day_obj_from_client_x}
            f_onDragStartResizeHandle={f_onDragStartResizeHandle}
            f_onDragEndHandle={f_onDragEndHandle}
            f_onDragOverDayCell={f_onDragOverDayCell}
            f_onDropOnDayCell={f_onDropOnDayCell}
            f_onClickCalendarEvent={f_onClickCalendarEvent}
            f_onEditSingleEventFields={f_onEditSingleEventFields}
            f_onDeleteEvent={f_onDeleteEvent}
          />
        )}
        {Object.keys(overflowBubbleByDayIdxObj).map((m_dayIdxString) => {
          const dayIdx = Number(m_dayIdxString);
          const overflowObj = overflowBubbleByDayIdxObj[dayIdx];
          const leftPct = ((dayIdx / 7) * 100);
          const widthPct = (100 / 7);
          const bubbleTopEm = (placeholderLaneIndex * (p_calendarUiConstantsObj.EVENT_LANE_HEIGHT_EM + p_calendarUiConstantsObj.EVENT_LANE_GAP_EM));
          return(
            <div
              key={"overflow_" + p_weekRowObj.weekIndex + "_" + dayIdx}
              className="positionAbsolute displayFlexRowHcVc textCenter"
              style={{top:bubbleTopEm + "em", left:leftPct + "%", width:widthPct + "%", height:p_calendarUiConstantsObj.EVENT_LANE_HEIGHT_EM + "em", border:"solid 1px #c8ccd3", background:"#eceff3", pointerEvents:"auto"}}
              title={overflowObj.hiddenEventsHoverText}>
              <LibraryReact.NowrapEllipsis p_fontClass="font09 fontItalic fontTextLighter">
                {overflowObj.numHiddenEvents + " more " + JSFUNC.plural(overflowObj.numHiddenEvents, "event", "events")}
              </LibraryReact.NowrapEllipsis>
            </div>
          );
        })}
      </div>
    </div>
  );
}


function ProposalManagementCalendarWeekRowDayCell(props) { //props: p_dayObj, p_dayIdx, p_todayDateKey, p_proposalDueDateKey, p_zeroDateKey, p_inputDatesRealCalendarTrueCountdownToZeroFalse, p_calendarUiConstantsObj, p_activeDropIndicatorObj, f_onDragOver, f_onDrop
  const p_dayObj = props.p_dayObj;
  const p_dayIdx = props.p_dayIdx;
  const p_todayDateKey = props.p_todayDateKey;
  const p_proposalDueDateKey = props.p_proposalDueDateKey;
  const p_zeroDateKey = props.p_zeroDateKey;
  const p_inputDatesRealCalendarTrueCountdownToZeroFalse = props.p_inputDatesRealCalendarTrueCountdownToZeroFalse;
  const p_calendarUiConstantsObj = props.p_calendarUiConstantsObj;
  const p_activeDropIndicatorObj = props.p_activeDropIndicatorObj;
  const f_onDragOver = props.f_onDragOver;
  const f_onDrop = props.f_onDrop;
  
  const bWH = p_calendarUiConstantsObj.DAY_BOX_BORDER_WIDTH_EM + "em";
  const bOff = 0;
  const borderLineStyleString = "1px solid " + p_calendarUiConstantsObj.CALENDAR_GRID_BORDER_HASH_COLOR;

  const dropIndicatorIsOnThisDayTF = (p_activeDropIndicatorObj !== undefined && p_dayObj.dateKey === p_activeDropIndicatorObj.dayKey);
  let dayBgColor = p_dayObj.dayBgColor;
  let dayCellCursor = undefined;
  if(dropIndicatorIsOnThisDayTF) {
    if(p_activeDropIndicatorObj.visualFlag === "move_valid") {
      dayBgColor = p_calendarUiConstantsObj.DRAGOVER_MOVE_START_VALID_BG_HASH_COLOR;
    }
    else if(p_activeDropIndicatorObj.visualFlag === "resize_valid") {
      dayBgColor = p_calendarUiConstantsObj.DRAGOVER_RESIZE_END_VALID_BG_HASH_COLOR;
    }
    else if(p_activeDropIndicatorObj.visualFlag === "resize_invalid_before_start") {
      dayBgColor = p_calendarUiConstantsObj.DRAGOVER_RESIZE_END_INVALID_BG_HASH_COLOR;
      dayCellCursor = "not-allowed";
    }
  }

  var isTodayDateTF = false;
  var isProposalDueDateTF = false;
  if(p_inputDatesRealCalendarTrueCountdownToZeroFalse) {
    isTodayDateTF = (p_dayObj.dateKey === p_todayDateKey);
    isProposalDueDateTF = (JSFUNC.text_or_number_is_filled_out_tf(p_proposalDueDateKey) && p_dayObj.dateKey === p_proposalDueDateKey);
  }
  else {
    isTodayDateTF = false; //countdown calendar cannot be 'today'
    isProposalDueDateTF = (p_dayObj.isZeroDateTF === true && p_dayObj.dateKey === p_zeroDateKey); //countdown proposal due date is the zero date
  }
  const isHighlightedDayTF = (isTodayDateTF || isProposalDueDateTF);

  let highlightedBorderHashColor = undefined;
  if(isTodayDateTF && isProposalDueDateTF) {
    highlightedBorderHashColor = p_calendarUiConstantsObj.TODAY_AND_PROPOSAL_DUE_SAME_DATE_BORDER_HASH_COLOR;
  }
  else if(isProposalDueDateTF) {
    highlightedBorderHashColor = p_calendarUiConstantsObj.PROPOSAL_DUE_BOX_BORDER_HASH_COLOR;
  }
  else if(isTodayDateTF) {
    highlightedBorderHashColor = p_calendarUiConstantsObj.TODAY_BOX_BORDER_HASH_COLOR;
  }

  const dayCellBorderRight = (p_dayIdx < 6) ? (borderLineStyleString) : (undefined);
  const dayCellBorderLeft = (p_dayIdx === 0) ? (borderLineStyleString) : (undefined);
  const dayCellHeaderBorderBottom = borderLineStyleString;

  const dayHoverText = p_dayObj.hoverText;

  return(
    <div
      key={p_dayObj.dateKey}
      className="flex11a displayFlexColumn positionRelative"
      style={{flexBasis:"100em", borderRight:dayCellBorderRight, borderLeft:dayCellBorderLeft, background:dayBgColor, cursor:dayCellCursor}}
      title={dayHoverText}
      onDragOver={(i_domEvent) => f_onDragOver(i_domEvent, p_dayObj)}
      onDrop={(i_domEvent) => f_onDrop(i_domEvent, p_dayObj)}>
      <div className="flex00a displayFlexRow" style={{height:p_calendarUiConstantsObj.WEEK_HEADER_HEIGHT_EM + "em", borderBottom:dayCellHeaderBorderBottom}}>
        <div className="flex11a" style={{paddingTop:p_calendarUiConstantsObj.WEEK_HEADER_TEXT_TOP_OFFSET_EM + "em", paddingLeft:p_calendarUiConstantsObj.WEEK_HEADER_TEXT_SIDE_OFFSET_EM + "em"}}>
          {(p_dayObj.dayLabelTextTF) &&
            <LibraryReact.NowrapEllipsis p_fontClass="font09 fontItalic" p_fontStyleObj={{color:p_dayObj.dayLabelFontHashColor}}>
              {p_dayObj.dayLabelText}
            </LibraryReact.NowrapEllipsis>
          }
        </div>
        <div className="flex00a textRight" style={{flexBasis:"1.8em", paddingTop:p_calendarUiConstantsObj.WEEK_HEADER_TEXT_TOP_OFFSET_EM + "em", paddingRight:p_calendarUiConstantsObj.WEEK_HEADER_TEXT_SIDE_OFFSET_EM + "em"}}>
          <LibraryReact.NowrapEllipsis p_fontClass="font09 fontTextLighter">
            {p_dayObj.dayDisplayText}
          </LibraryReact.NowrapEllipsis>
        </div>
      </div>
      <div className="flex11a" />
      {(isHighlightedDayTF) &&
        <>
          <div className="positionAbsolute pointerEventsNone" style={{zIndex:2, top:bOff, right:bOff, left:bOff, height:bWH, background:highlightedBorderHashColor}} />
          <div className="positionAbsolute pointerEventsNone" style={{zIndex:2, top:bOff, right:bOff, bottom:bOff, width:bWH, background:highlightedBorderHashColor}} />
          <div className="positionAbsolute pointerEventsNone" style={{zIndex:2, right:bOff, bottom:bOff, left:bOff, height:bWH, background:highlightedBorderHashColor}} />
          <div className="positionAbsolute pointerEventsNone" style={{zIndex:2, top:bOff, bottom:bOff, left:bOff, width:bWH, background:highlightedBorderHashColor}} />
        </>
      }
    </div>
  );
}


function ProposalManagementCalendarEventBar(props) { //props: p_segmentObj, p_weekIndex, p_calendarUiConstantsObj, f_getDayObjFromClientX, f_onDragStartResizeHandle, f_onDragEndHandle, f_onDragOverDayCell, f_onDropOnDayCell, f_onClickCalendarEvent, f_onEditSingleEventFields, f_onDeleteEvent
  const p_segmentObj = props.p_segmentObj;
  const p_weekIndex = props.p_weekIndex;
  const p_calendarUiConstantsObj = props.p_calendarUiConstantsObj;
  const f_getDayObjFromClientX = props.f_getDayObjFromClientX;
  const f_onDragStartResizeHandle = props.f_onDragStartResizeHandle;
  const f_onDragEndHandle = props.f_onDragEndHandle;
  const f_onDragOverDayCell = props.f_onDragOverDayCell;
  const f_onDropOnDayCell = props.f_onDropOnDayCell;
  const f_onClickCalendarEvent = props.f_onClickCalendarEvent;
  const f_onEditSingleEventFields = props.f_onEditSingleEventFields;
  const f_onDeleteEvent = props.f_onDeleteEvent;

  const eventObj = p_segmentObj.eventObj;
  const barLeftPct = ((p_segmentObj.startDayIndex / 7) * 100);
  const barWidthPct = (((p_segmentObj.endDayIndex - p_segmentObj.startDayIndex + 1) / 7) * 100);

  const clickCalendarEventIsFunctionTF = JSFUNC.is_function(f_onClickCalendarEvent);
  const editSingleEventFieldIsFunctionTF = JSFUNC.is_function(f_onEditSingleEventFields);
  const deleteEventIsFunctionTF = JSFUNC.is_function(f_onDeleteEvent);

  const eventIconsColor = "44454a";
  const eventContainerTopEm = (p_segmentObj.laneIndex * (p_calendarUiConstantsObj.EVENT_LANE_HEIGHT_EM + p_calendarUiConstantsObj.EVENT_LANE_GAP_EM));

  return(
    <div
      key={p_weekIndex + "_" + eventObj.sourceIndex + "_" + p_segmentObj.startDayIndex + "_" + p_segmentObj.endDayIndex}
      className="positionAbsolute displayFlexRow borderRadius05"
      style={{top:eventContainerTopEm + "em", left:barLeftPct + "%", width:barWidthPct + "%", height:p_calendarUiConstantsObj.EVENT_LANE_HEIGHT_EM + "em", border:"solid 1px " + eventObj.eventBorderHashColor, background:eventObj.eventBackgroundHashColor, pointerEvents:"auto"}}
      title={p_segmentObj.eventObj.eventHoverText}
      onDragOver={(i_domEvent) => { const dayObj = f_getDayObjFromClientX(i_domEvent.clientX); if(dayObj !== undefined) { f_onDragOverDayCell(i_domEvent, dayObj); } }}
      onDrop={(i_domEvent) => { const dayObj = f_getDayObjFromClientX(i_domEvent.clientX); if(dayObj !== undefined) { f_onDropOnDayCell(i_domEvent, dayObj); } }}>
      {(editSingleEventFieldIsFunctionTF) ? (
        <div
          className="flex00a displayFlexColumnHcVc textCenter cursorGrab"
          style={{flexBasis:"1.7em"}}
          title="Drag to move event (keep length constant)"
          draggable={Number.isFinite(eventObj.id)}
          onDragStart={(i_domEvent) => f_onDragStartResizeHandle(i_domEvent, eventObj, "move_start_keep_duration")}
          onDragEnd={f_onDragEndHandle}
          onClick={(i_domEvent) => i_domEvent.stopPropagation()}>
          <CEIconsReact.SvgDraggable4Dots p_sizeEm={0.8} p_color={eventIconsColor} />
        </div>
      ) : (
        <div className="flex00a" style={{flexBasis:"1em"}} />
      )}
      <div
        className={"flex11a displayFlexRowVc " + ((clickCalendarEventIsFunctionTF) ? ("cursorPointer") : (""))}
        style={{minWidth:0}}
        onClick={() => { if(clickCalendarEventIsFunctionTF) { f_onClickCalendarEvent(eventObj); } }}>
        <LibraryReact.NowrapEllipsis p_fontClass={"font09 " + eventObj.eventFontClassString} p_fontStyleObj={{color:eventObj.eventFontHashColor}}>
          {eventObj.eventName}
        </LibraryReact.NowrapEllipsis>
      </div>
      {(deleteEventIsFunctionTF) &&
        <div className="flex00a displayFlexColumnHcVc" style={{flexBasis:"1.2em"}}>
          <CEGeneralReact.DeleteMenu
            p_message={"Are you sure you want to delete event '" + eventObj.eventName + "'?"}
            p_dotsHeightEm={0.8}
            p_dotsFontColor={eventIconsColor}
            f_onDelete={() => { f_onDeleteEvent(eventObj); }}
          />
        </div>
      }
      {(editSingleEventFieldIsFunctionTF) ? (
        <div
          className="flex00a displayFlexColumnHcVc textCenter cursorLRResizeArrows"
          style={{flexBasis:"1.7em"}}
          title="Drag to resize event end"
          draggable={Number.isFinite(eventObj.id)}
          onDragStart={(i_domEvent) => f_onDragStartResizeHandle(i_domEvent, eventObj, "resize_end_only")}
          onDragEnd={f_onDragEndHandle}
          onClick={(i_domEvent) => i_domEvent.stopPropagation()}>
          <CEIconsReact.SvgStretchIconLrCaratsBars p_sizeEm={0.8} p_color={eventIconsColor} />
        </div>
      ) : (
        <div className="flex00a" style={{flexBasis:"1em"}} />
      )}
    </div>
  );
}



//===========================================================================================================================================================
//===========================================================================================================================================================
//Admin - Proposal Management Options
//===========================================================================================================================================================
//===========================================================================================================================================================

export const AdminSubtabProposalManagementOptions = inject("ProposalManagementMobx")(observer(
class AdminSubtabProposalManagementOptions extends Component {
  onselect_proposal_management_options_tab = (i_selectedSubtabDbName) => {
    this.props.ProposalManagementMobx.a_set_admin_setup_tab_proposal_management_options_selected_subtab_db_name(i_selectedSubtabDbName);
  }

  render() {
    const o_adminSetupTabProposalManagementOptionsSelectedSubtabDbName = this.props.ProposalManagementMobx.o_adminSetupTabProposalManagementOptionsSelectedSubtabDbName;

    var proposalManagementOptionsContentComponent = null;
    if(o_adminSetupTabProposalManagementOptionsSelectedSubtabDbName === "proposalThemes") { proposalManagementOptionsContentComponent = (<AdminProposalThemesOptions />); }
    else if(o_adminSetupTabProposalManagementOptionsSelectedSubtabDbName === "proposalManagement") { proposalManagementOptionsContentComponent = (<AdminProposalManagementOptions />); }
  
    return(
      <>
        <div className="flex00a bgLightestGray smallFullPad borderB1bbb">
          <CEGeneralReact.TabsList
            p_tabDbNamesArray={["proposalThemes", "proposalManagement"]}
            p_tabDisplayNamesArray={["Proposal Themes", "Proposal Management"]}
            p_selectedTabDbName={o_adminSetupTabProposalManagementOptionsSelectedSubtabDbName}
            p_tabHeight="2.4em"
            p_textMaxHeight="2em"
            p_tabWidth="18em"
            p_selectedBgClass="bgPurpleGradient"
            p_selectedFontClass="fontBold fontAlmostWhite"
            p_unselectedBgClass="bgLightGrayGradient"
            p_unselectedFontClass="fontTextLight"
            p_canEditTF={true}
            p_rowFlexWrapTF={true}
            p_borderRadiusClass="borderRadius05"
            f_onSelect={this.onselect_proposal_management_options_tab}
          />
        </div>
        {proposalManagementOptionsContentComponent}
      </>
    );
  }
}));


//----------------------------------------------------------------------------------
//Admin Proposal Themes subtab
//----------------------------------------------------------------------------------
const AdminProposalThemesOptions = inject("ProposalManagementMobx", "DatabaseMobx")(observer(
class AdminProposalThemesOptions extends Component {
  render() {
    const c_aptThemeModulesArrayOfObjs = this.props.ProposalManagementMobx.c_aptThemeModulesArrayOfObjs;
    const c_aptAllDifferentiatorsArrayOfObjs = this.props.ProposalManagementMobx.c_aptAllDifferentiatorsArrayOfObjs;
    const c_companyUsingPTDifferentiatorsTF = this.props.DatabaseMobx.c_companyUsingPTDifferentiatorsTF;
    const c_cardNameProposalManagement = this.props.DatabaseMobx.c_cardNameProposalManagement;
    const c_genericTextareaFieldTypeObj = this.props.DatabaseMobx.c_genericTextareaFieldTypeObj;

    var differentiatorsAedTableComponent = null;
    if(c_companyUsingPTDifferentiatorsTF) {
      const differentiatorsAedTableObj = {
        tblName: "tbl_a_pt_differentiators",
        dragToResortFieldDbName: undefined,
        initialSortedFieldDbName: "name",
        tableWidth: "60em",
        itemName: "Differentiator",
        deleteItemNameFieldDbName: "name",
        fieldsArrayOfObjs: [
          {width:"100em", dbName:"name", displayName:"Differentiator Choices", fieldTypeObj:c_genericTextareaFieldTypeObj, initialValue:"", cellHoverTF:true, requiredNotEmptyTF:true}
        ]
      };

      differentiatorsAedTableComponent = (
        <div className="flex00a medFullPad">
          <CEComplexReact.AddEditDeleteTable
            p_dataArrayOfObjs={c_aptAllDifferentiatorsArrayOfObjs}
            p_aedTableObj={differentiatorsAedTableObj}
          />
        </div>
      );
    }



    return (
      <div className="flex11a xyScroll">
        <div className="displayFlexRow">
          <div className="flex00a medFullPad" style={{flexBasis:"55em", borderRight:"solid 1px #ccc"}}>
            <LibraryReact.DivFont p_class="tbPad" p_fontClass="font13">
              {"Use the switches below to turn on/off modules within the " + c_cardNameProposalManagement + " capture card"}
            </LibraryReact.DivFont>
            {c_aptThemeModulesArrayOfObjs.map((m_proposalThemeModuleObj) =>
              <ProposalThemeModuleSwitch
                key={m_proposalThemeModuleObj.adminSwitchTblCompanyColumnDbName}
                p_usingModuleTF={m_proposalThemeModuleObj.usingModuleTF}
                p_moduleName={m_proposalThemeModuleObj.moduleName}
                p_tblCompanyColumnName={m_proposalThemeModuleObj.adminSwitchTblCompanyColumnDbName}
              />
            )}
            <div className="displayFlexColumn" style={{height:"35em"}}>
              <OpenCaptureReact.CardShell
                p_label={c_cardNameProposalManagement}
                p_drawLeftRightButtonsTF={true}>
                <div className="flex11a displayFlexRow">
                  {c_aptThemeModulesArrayOfObjs.map((m_proposalThemeModuleObj) =>
                    (m_proposalThemeModuleObj.usingModuleTF) &&
                    <div key={m_proposalThemeModuleObj.adminSwitchTblCompanyColumnDbName} className="flex11a displayFlexColumn borderR1bbb" style={{flexBasis:"100em", background:"#" + m_proposalThemeModuleObj.bodyLightBgColor}}>
                      <div className="flex00a border1eee">
                        <div className="smallFullPad" style={{background:"#" + m_proposalThemeModuleObj.headerDarkBgColor}}>
                          <LibraryReact.NowrapEllipsis p_fontClass="font12 fontWhite">
                            {m_proposalThemeModuleObj.moduleName}
                          </LibraryReact.NowrapEllipsis>
                        </div>
                      </div>
                      <div className="flex11a" />
                    </div>
                  )}
                </div>
              </OpenCaptureReact.CardShell>
            </div>
          </div>
          {differentiatorsAedTableComponent}
        </div>
      </div>
    );
  }
}));

const ProposalThemeModuleSwitch = inject("AdminMobx", "DatabaseMobx")(observer(
class ProposalThemeModuleSwitch extends Component { //p_usingModuleTF, p_moduleName, p_tblCompanyColumnName
  onswitch_turn_onoff_module = () => {
    const p_usingModuleTF = this.props.p_usingModuleTF;
    const p_tblCompanyColumnName = this.props.p_tblCompanyColumnName;

    const newValue01 = ((p_usingModuleTF) ? (0) : (1));
    this.props.AdminMobx.a_update_tbl_a_company_fields(p_tblCompanyColumnName, newValue01, "i");
  }

  render() {
    const p_usingModuleTF = this.props.p_usingModuleTF;
    const p_moduleName = this.props.p_moduleName;
    const p_tblCompanyColumnName = this.props.p_tblCompanyColumnName;

    const c_cardNameProposalManagement = this.props.DatabaseMobx.c_cardNameProposalManagement;

    return(
      <div className="displayFlexRowVc tbMedMargin">
        <LibraryReact.DivFont p_class="flex00a smallRightMargin" p_styleObj={{flexBasis:"18em"}} p_fontClass="font13 fontBlue">
          {"Using '" + p_moduleName + "' module"}
        </LibraryReact.DivFont>
        <div className="flex11a">
          <LibraryReact.Switch
            p_isOnTF={p_usingModuleTF}
            p_title={"Turn " + ((p_usingModuleTF) ? ("off") : ("on")) + " the " + p_moduleName + " module on the " + c_cardNameProposalManagement + " capture card"}
            f_onClick={this.onswitch_turn_onoff_module}
          />
        </div>
      </div>
    );
  }
}));











//----------------------------------------------------------------------------------
//Admin Proposal Management Options subtab
//----------------------------------------------------------------------------------
const AdminProposalManagementOptions = inject("CaptureExecMobx")(observer(
class AdminProposalManagementOptions extends Component {
  render() {
    const o_mediaQueryFlag = this.props.CaptureExecMobx.o_mediaQueryFlag;

    if(o_mediaQueryFlag <= 3) {
      return(
        <div className="flex11a displayFlexColumn yScroll">
          <div className="flex00a displayFlexColumn borderB1bbb medFullPad">
            <APMTurnaroundsWithSequences />
          </div>
          <div className="flex00a displayFlexColumn borderB1bbb medFullPad">
            <APMAllMilestonesPool />
          </div>
          <div className="flex00a displayFlexColumn medFullPad">
            <APMMilestones p_layoutIsVerticalTF={true} />
          </div>
        </div>
      );
    }

    return(
      <>
        <div className="flex11a displayFlexRow" style={{flexBasis:"100em"}}>
          <div className="flex00a displayFlexColumn borderR1bbb medFullPad yScroll" style={{flexBasis:"32em"}}>
            <APMTurnaroundsWithSequences />
          </div>
          <div className="flex11a displayFlexColumn borderR1bbb medFullPad yScroll" style={{flexBasis:"100em"}}>
            <APMAllMilestonesPool />
          </div>
          <div className="flex11a displayFlexColumn medFullPad yScroll" style={{flexBasis:"125em"}}>
            <APMMilestones p_layoutIsVerticalTF={false} />
          </div>
        </div>
        <div className="flex11a displayFlexColumn borderT1bbb yScroll" style={{flexBasis:"100em"}}>
          <APMCountdownCalendarPreview />
        </div>
      </>
    );
  }
}));


const APMTurnaroundsWithSequences = inject("ProposalManagementMobx")(observer(
class APMTurnaroundsWithSequences extends Component {
  onclick_create_new_turnaround_template = (i_newTurnaroundTemplateNameString) => {
    this.props.ProposalManagementMobx.a_apm_create_new_turnaround_template(i_newTurnaroundTemplateNameString);
  }

  render() {
    const c_apmAllExpandedTurnaroundsSequencesMilestonesArrayOfObjs = this.props.ProposalManagementMobx.c_apmAllExpandedTurnaroundsSequencesMilestonesArrayOfObjs;

    const numTurnarounds = c_apmAllExpandedTurnaroundsSequencesMilestonesArrayOfObjs.length;

    return(
      <>
        <AdminProposalManagementSectionLabel p_text="Turnarounds/Sequences" />
        <div className="displayFlexColumnHcVc bigBottomMargin">
          <CEGeneralReact.ButtonWithConfirmBox
            p_buttonType="blue"
            p_buttonText="Create New Proposal Turnaround Template"
            p_buttonFontClass={undefined}
            p_tabIndex={undefined}
            p_title="Click to create a new 'Proposal Turnaround Template', which can contain multiple parallel 'Sequences' of 'Milestone' dates to set during a Capture's proposal process"
            p_confirmType="inputText"
            p_confirmMessage="Enter a name for this new Proposal Turnaround Template"
            p_button1Name="Create New Turnaround Template"
            p_textMustBeFilledOutTF={true}
            f_onClickConfirm={this.onclick_create_new_turnaround_template}
          />
        </div>
        {(numTurnarounds === 0) ? (
          <div className="medFullPad textCenter">
            <font className="fontItalic fontTextLight">
              {"Create your first Turnaround Template using the 'Create New Turnaround Template' button above"}
            </font>
          </div>
        ) : (
          c_apmAllExpandedTurnaroundsSequencesMilestonesArrayOfObjs.map((m_expandedTurnaroundObj, m_index) =>
            <APMSingleTurnaroundWithSequencesItem
              key={m_expandedTurnaroundObj.id}
              p_expandedTurnaroundObj={m_expandedTurnaroundObj}
              p_isOnlyItemTF={(numTurnarounds === 1)}
              p_isLastItemTF={(m_index === (numTurnarounds - 1))}
            />
          )
        )}
      </>
    );
  }
}));

const APMSingleTurnaroundWithSequencesItem = inject("ProposalManagementMobx")(observer(
class APMSingleTurnaroundWithSequencesItem extends Component { //props: p_expandedTurnaroundObj, p_isOnlyItemTF, p_isLastItemTF
  onsave_edit_turnaround_name = (i_newValue) => {
    const p_expandedTurnaroundObj = this.props.p_expandedTurnaroundObj;
    this.props.ProposalManagementMobx.a_apm_update_turnaround_name(p_expandedTurnaroundObj, i_newValue);
  }

  ondelete_turnaround = () => {
    const p_expandedTurnaroundObj = this.props.p_expandedTurnaroundObj;
    this.props.ProposalManagementMobx.a_apm_delete_turnaround(p_expandedTurnaroundObj);
  }

  render() {
    const p_expandedTurnaroundObj = this.props.p_expandedTurnaroundObj;
    const p_isOnlyItemTF = this.props.p_isOnlyItemTF;
    const p_isLastItemTF = this.props.p_isLastItemTF;

    const c_apmExpandedTurnaroundObjContainingSelectedSequenceOrUndefined = this.props.ProposalManagementMobx.c_apmExpandedTurnaroundObjContainingSelectedSequenceOrUndefined;

    var turnaroundIsSelectedTF = false;
    if(c_apmExpandedTurnaroundObjContainingSelectedSequenceOrUndefined !== undefined) {
      turnaroundIsSelectedTF = (p_expandedTurnaroundObj.id === c_apmExpandedTurnaroundObjContainingSelectedSequenceOrUndefined.id);
    }

    const turnaroundVerticalDotsMenuItemsArrayOfObjs = [
      {
        displayName: "Edit Turnaround Name",
        confirmType: "inputText",
        confirmTitle: "Edit Turnaround Name",
        confirmTextInitialValue: p_expandedTurnaroundObj.name,
        confirmButton1Name: "Save",
        confirmMessage: "Enter a new name for this Proposal Management Turnaround Template",
        functionOnClickConfirmButton: this.onsave_edit_turnaround_name
      },
      {
        displayName: "Delete Turnaround",
        confirmType: "confirmDelete",
        confirmMessage: "Are you sure you want to delete Turnaround '" + p_expandedTurnaroundObj.name + "'?\n\nThis will also delete all Sequences/Milestones within this Template. Captures using this Proposal Template will no longer show their Milestones properly.",
        functionOnClickConfirmButton: this.ondelete_turnaround
      }
    ];

    return(
      <CEGeneralReact.CEDragToResortItemWithinDbTbl
        p_canResortTF={true}
        p_uniqueString="adminProposalManagementTurnaroundItem"
        p_itemID={p_expandedTurnaroundObj.id}
        p_itemSort={p_expandedTurnaroundObj.admin_sort}
        p_itemSortColumnWidth="2em"
        p_itemSortNumberFontClass={undefined}
        p_isOnlyItemTF={p_isOnlyItemTF}
        p_isLastItemTF={p_isLastItemTF}
        p_outerPadClass="medBottomPad"
        p_itemClass={"border bevelBorderColors " + ((turnaroundIsSelectedTF) ? ("bgLighterPurpleGradient") : ("bgLighterGrayGradient"))}
        p_itemStyleObj={undefined}
        p_lastItemExtraDropZoneHeight="4em"
        p_dragEntireItemTrueOnlySortNumberFalse={false}
        p_tblName="tbl_a_pm_turnaround_timeline_templates"
        p_tblSortFieldDbName="admin_sort"
        p_filterFieldNamesArray={[]}
        p_filterValuesArray={[]}
        f_onDropForeignItem={undefined}>
        <div className="flex11a displayFlexColumn">
          <div className="flex00a displayFlexRowVc lrPad borderB1bbb" style={{flexBasis:"2.2em"}} title={p_expandedTurnaroundObj.turnaroundHoverText}>
            <LibraryReact.NowrapEllipsis p_fontClass="font12 fontBold">
              {p_expandedTurnaroundObj.name}
            </LibraryReact.NowrapEllipsis>
          </div>
          <div className="flex00a displayFlexColumn medTopMargin lrPad">
            <APMSequences
              p_expandedTurnaroundObj={p_expandedTurnaroundObj}
            />
          </div>
        </div>
        <div className="flex00a displayFlexColumnHcVc" style={{flexBasis:"2em"}}>
          <CEGeneralReact.VerticalDotsMenu
            p_menuItemsArrayOfObjs={turnaroundVerticalDotsMenuItemsArrayOfObjs}
          />
        </div>
      </CEGeneralReact.CEDragToResortItemWithinDbTbl>
    );
  }
}));


const APMSequences = inject("ProposalManagementMobx")(observer(
class APMSequences extends Component { //props: p_expandedTurnaroundObj
  onclick_create_new_sequence = (i_newSequenceNameString) => {
    const p_expandedTurnaroundObj = this.props.p_expandedTurnaroundObj;
    this.props.ProposalManagementMobx.a_apm_create_new_sequence(p_expandedTurnaroundObj, i_newSequenceNameString);
  }

  render() {
    const p_expandedTurnaroundObj = this.props.p_expandedTurnaroundObj;

    return(
      <>
        <div className="displayFlexColumnHcVc smallBottomMargin font09">
          <CEGeneralReact.ButtonWithConfirmBox
            p_buttonType="add"
            p_buttonText="Add a Sequence of Milestones"
            p_buttonFontClass={undefined}
            p_tabIndex={undefined}
            p_title={"Click to create a new parallel Sequence of Proposal Milestones within Turnaround Template '" + p_expandedTurnaroundObj.name + "'"}
            p_confirmType="inputText"
            p_confirmMessage="Enter a name for this new Sequence"
            p_button1Name="Create New Sequence"
            p_textMustBeFilledOutTF={true}
            f_onClickConfirm={this.onclick_create_new_sequence}
          />
        </div>
        {(p_expandedTurnaroundObj.numSequences === 0) ? (
          <div className="displayFlexColumnHcVc medFullPad textCenter">
            <font className="fontItalic fontTextLight">
              {"--No Sequences created yet--"}
            </font>
          </div>
        ) : (
          p_expandedTurnaroundObj.expandedSequencesArrayOfObjs.map((m_expandedSequenceObj, m_index) =>
            <APMSingleSequenceItem
              key={m_expandedSequenceObj.id}
              p_expandedSequenceObj={m_expandedSequenceObj}
              p_isOnlyItemTF={(p_expandedTurnaroundObj.numSequences === 1)}
              p_isLastItemTF={(m_index === (p_expandedTurnaroundObj.numSequences - 1))}
            />
          )
        )}
      </>
    );
  }
}));

const APMSingleSequenceItem = inject("ProposalManagementMobx")(observer(
class APMSingleSequenceItem extends Component { //props: p_expandedSequenceObj, p_isOnlyItemTF, p_isLastItemTF
  onclick_sequence_button = () => {
    const p_expandedSequenceObj = this.props.p_expandedSequenceObj;
    const o_apmSelectedSequenceIDOrUndefined = this.props.ProposalManagementMobx.o_apmSelectedSequenceIDOrUndefined;

    //set the sequenceID as selected, unless it is currently selected, then unselect it with undefined
    const updatedSelectedSequenceIDOrUndefined = ((p_expandedSequenceObj.id === o_apmSelectedSequenceIDOrUndefined) ? (undefined) : (p_expandedSequenceObj.id));
    this.props.ProposalManagementMobx.a_apm_set_selected_sequence_id_or_undefined_and_set_calendar_selected_sequences(updatedSelectedSequenceIDOrUndefined);
  }

  onsave_edit_sequence_name = (i_newSequenceNameString) => {
    const p_expandedSequenceObj = this.props.p_expandedSequenceObj;
    this.props.ProposalManagementMobx.a_apm_update_sequence_field(p_expandedSequenceObj, "name", i_newSequenceNameString, "s");
  }

  ondelete_sequence = () => {
    const p_expandedSequenceObj = this.props.p_expandedSequenceObj;
    this.props.ProposalManagementMobx.a_apm_delete_sequence(p_expandedSequenceObj);
  }

  render() {
    const p_expandedSequenceObj = this.props.p_expandedSequenceObj;
    const p_isOnlyItemTF = this.props.p_isOnlyItemTF;
    const p_isLastItemTF = this.props.p_isLastItemTF;

    const o_apmSelectedSequenceIDOrUndefined = this.props.ProposalManagementMobx.o_apmSelectedSequenceIDOrUndefined;

    const sequenceIsSelectedTF = (p_expandedSequenceObj.id === o_apmSelectedSequenceIDOrUndefined);

    const sequenceVerticalDotsMenuItemsArrayOfObjs = [
      {
        displayName: "Edit Sequence Name",
        confirmType: "inputText",
        confirmTitle: "Edit Sequence Name",
        confirmTextInitialValue: p_expandedSequenceObj.name,
        confirmButton1Name: "Save",
        confirmMessage: "Enter a new name for this Sequence",
        functionOnClickConfirmButton: this.onsave_edit_sequence_name
      },
      {
        displayName: "Delete Sequence",
        confirmType: "confirmDelete",
        confirmMessage: "Are you sure you want to delete Sequence '" + p_expandedSequenceObj.name + "'?\n\nThis will also delete all Milestones within this Sequence.",
        functionOnClickConfirmButton: this.ondelete_sequence
      }
    ];

    return(
      <CEGeneralReact.CEDragToResortItemWithinDbTbl
        p_canResortTF={true}
        p_uniqueString="adminProposalManagementSequenceItem"
        p_itemID={p_expandedSequenceObj.id}
        p_itemSort={p_expandedSequenceObj.sort}
        p_itemSortColumnWidth="2em"
        p_itemSortNumberFontClass={undefined}
        p_isOnlyItemTF={p_isOnlyItemTF}
        p_isLastItemTF={p_isLastItemTF}
        p_outerPadClass="microBottomPad"
        p_itemClass={"border borderRadius10 bevelBorderColors " + ((sequenceIsSelectedTF) ? ("bgLightPurpleGradient") : ("bgLightGrayGradient hoverLighterBlueGradient"))}
        p_itemStyleObj={{height:"2.5em"}}
        p_lastItemExtraDropZoneHeight="1.5em"
        p_dragEntireItemTrueOnlySortNumberFalse={true}
        p_tblName="tbl_a_pm_sequences"
        p_tblSortFieldDbName="sort"
        p_filterFieldNamesArray={["proposal_turnaround_timeline_template_id"]}
        p_filterValuesArray={[p_expandedSequenceObj.proposal_turnaround_timeline_template_id]}
        f_onDropForeignItem={undefined}>
        <div
          className="flex11a displayFlexColumn lrMicroPad cursorPointer"
          title={p_expandedSequenceObj.sequenceHoverText}
          onClick={this.onclick_sequence_button}>
          <div className="flex00a displayFlexRowVc">
            <LibraryReact.NowrapEllipsis p_fontClass="fontBold">
              {p_expandedSequenceObj.name}
            </LibraryReact.NowrapEllipsis>
          </div>
          <div className="flex00a displayFlexRow">
            <div className="flex11a displayFlexColumn">
              <font className="font09 fontTextLight">
                {"Milestones: " + p_expandedSequenceObj.numMilestones}
              </font>
            </div>
            <div className="flex00a displayFlexColumn" style={{flexBasis:"7em"}}>
              <font className="font09 fontTextLight">
                {"Sequence Color:"}
              </font>
            </div>
            <div className="flex00a displayFlexColumnVc" style={{flexBasis:"3em"}}>
              <div className="flex00a displayFlexColumnHcVc bgAlmostWhite textCenter" style={{height:"1.1em", border:"solid 2px #" + p_expandedSequenceObj.sequence_bg_color}}>
                <font className="font08">
                  {"Text"}
                </font>
              </div>
            </div>
          </div>
        </div>
        <div className="flex00a displayFlexColumnHcVc" style={{flexBasis:"2em"}}>
          <CEGeneralReact.VerticalDotsMenu
            p_menuItemsArrayOfObjs={sequenceVerticalDotsMenuItemsArrayOfObjs}
          />
        </div>
      </CEGeneralReact.CEDragToResortItemWithinDbTbl>
    );
  }
}));



const APMAllMilestonesPool = inject("ProposalManagementMobx", "DatabaseMobx")(observer(
class APMAllMilestonesPool extends Component {
  onclick_add_pool_milestone_to_sequence = (i_allMilestonesPoolID) => {
    const c_apmSelectedExpandedSequenceObjOrUndefined = this.props.ProposalManagementMobx.c_apmSelectedExpandedSequenceObjOrUndefined;
    this.props.ProposalManagementMobx.a_apm_add_pool_milestone_to_sequence(c_apmSelectedExpandedSequenceObjOrUndefined, i_allMilestonesPoolID);
  }

  render() {
    const c_apmAllMilestonesPoolArrayOfObjs = this.props.ProposalManagementMobx.c_apmAllMilestonesPoolArrayOfObjs;
    const c_apmSelectedExpandedSequenceObjOrUndefined = this.props.ProposalManagementMobx.c_apmSelectedExpandedSequenceObjOrUndefined;
    const c_genericTextFieldTypeObj = this.props.DatabaseMobx.c_genericTextFieldTypeObj;
    const c_genericStylingStringAdminFieldTypeObj = this.props.DatabaseMobx.c_genericStylingStringAdminFieldTypeObj;

    var canAddMilestonesToSelectedSequenceTF = false;
    var poolMilestoneIDsAlreadyAddedToSelectedSequenceArray = [];
    if(c_apmSelectedExpandedSequenceObjOrUndefined !== undefined) {
      canAddMilestonesToSelectedSequenceTF = true;
      poolMilestoneIDsAlreadyAddedToSelectedSequenceArray = c_apmSelectedExpandedSequenceObjOrUndefined.poolMilestoneIDsAddedArray;
    }

    const functionOnSuccessDeletePoolMilestoneItems = (i_successfullyDeletedPoolMilestoneRowIDsArray) => {
      this.props.ProposalManagementMobx.a_apm_remove_all_milestones_matching_milestone_pool_ids_from_sequences(i_successfullyDeletedPoolMilestoneRowIDsArray);
    }

    const milestonesAedTableObj = {
      tblName: "tbl_a_pm_all_milestones_pool",
      dragToResortFieldDbName: "admin_sort",
      initialSortedFieldDbName: "admin_sort",
      tableWidth: undefined,
      itemName: "Milestone",
      deleteItemNameFieldDbName: "name",
      canAddItemsFromAddColumnTF: canAddMilestonesToSelectedSequenceTF,
      idsAlreadyAddedArray: poolMilestoneIDsAlreadyAddedToSelectedSequenceArray,
      itemDeleteOnSuccessFunction: functionOnSuccessDeletePoolMilestoneItems,
      fieldsArrayOfObjs: [
        {width:"300em", dbName:"name", displayName:"Milestone Name", fieldTypeObj:c_genericTextFieldTypeObj, initialValue:"", cellHoverTF:true, requiredNotEmptyTF:true},
        {width:"100em", dbName:"calendar_styling_string_comma", displayName:"Calendar Text Color (Optional)", fieldTypeObj:c_genericStylingStringAdminFieldTypeObj, initialValue:"", cellCenterTF:true, cellHoverTF:true, cellDisplayBlankIfNotFilledOutTF:true}
      ]
    };

    return(
      <>
        <AdminProposalManagementSectionLabel p_text="Milestones Pool" />
        <CEComplexReact.AddEditDeleteTable
          p_dataArrayOfObjs={c_apmAllMilestonesPoolArrayOfObjs}
          p_aedTableObj={milestonesAedTableObj}
          f_onClickAddItem={this.onclick_add_pool_milestone_to_sequence}
        />
      </>
    );
  }
}));



const APMMilestones = inject("ProposalManagementMobx")(observer(
class APMMilestones extends Component { //props: p_layoutIsVerticalTF
  render() {
    const p_layoutIsVerticalTF = this.props.p_layoutIsVerticalTF;

    const c_apmSelectedExpandedSequenceObjOrUndefined = this.props.ProposalManagementMobx.c_apmSelectedExpandedSequenceObjOrUndefined;
    const c_apmExpandedTurnaroundObjContainingSelectedSequenceOrUndefined = this.props.ProposalManagementMobx.c_apmExpandedTurnaroundObjContainingSelectedSequenceOrUndefined;

    const sequenceSelectedTF = ((c_apmSelectedExpandedSequenceObjOrUndefined !== undefined) && (c_apmExpandedTurnaroundObjContainingSelectedSequenceOrUndefined !== undefined));

    return(
      <>
        <AdminProposalManagementSectionLabel p_text="Editing Selected Sequence" />
        {(sequenceSelectedTF) ? (
          <APMEditSelectedSequenceOfMilestones
            p_selectedExpandedTurnaroundObj={c_apmExpandedTurnaroundObjContainingSelectedSequenceOrUndefined}
            p_selectedExpandedSequenceObj={c_apmSelectedExpandedSequenceObjOrUndefined}
          />
        ) : (
          <div className="displayFlexColumnHcVc medFullPad textCenter">
            <font className="fontItalic fontTextLighter">
              {"--Select a Turnaround Sequence " + ((p_layoutIsVerticalTF) ? ("above") : ("on the left")) + " to view/edit its Milestones timeline--"}
            </font>
          </div>
        )}
      </>
    );
  }
}));


const APMEditSelectedSequenceOfMilestones = inject("ProposalManagementMobx", "DatabaseMobx")(observer(
class APMEditSelectedSequenceOfMilestones extends Component { //props: p_selectedExpandedTurnaroundObj, p_selectedExpandedSequenceObj
  onsave_edit_turnaround_name = (i_newValueString) => {
    const p_selectedExpandedTurnaroundObj = this.props.p_selectedExpandedTurnaroundObj;
    this.props.ProposalManagementMobx.a_apm_update_turnaround_name(p_selectedExpandedTurnaroundObj, i_newValueString);
  }

  onsave_edit_sequence_name = (i_newValueString) => {
    const p_selectedExpandedSequenceObj = this.props.p_selectedExpandedSequenceObj;
    this.props.ProposalManagementMobx.a_apm_update_sequence_field(p_selectedExpandedSequenceObj, "name", i_newValueString, "s");
  }

  onsave_edit_sequence_bg_color = (i_newValueString) => {
    const p_selectedExpandedSequenceObj = this.props.p_selectedExpandedSequenceObj;
    this.props.ProposalManagementMobx.a_apm_update_sequence_field(p_selectedExpandedSequenceObj, "sequence_bg_color", i_newValueString, "s");
  }

  render() {
    const p_selectedExpandedTurnaroundObj = this.props.p_selectedExpandedTurnaroundObj;
    const p_selectedExpandedSequenceObj = this.props.p_selectedExpandedSequenceObj;

    const c_genericTextFieldTypeObj = this.props.DatabaseMobx.c_genericTextFieldTypeObj;
    const c_genericColorFieldTypeObj = this.props.DatabaseMobx.c_genericColorFieldTypeObj;
    const c_selectAdminFontColorFieldTypeObj = this.props.DatabaseMobx.c_selectAdminFontColorFieldTypeObj;

    const expandedMilestonesArrayOfObjs = p_selectedExpandedSequenceObj.expandedMilestonesArrayOfObjs;
    const numMilestones = p_selectedExpandedSequenceObj.numMilestones;
    
    const editSequenceFieldWidthEm = 10;
    const exampleMilestoneWidthEm = 8;
    const exampleMilestoneHeightEm = 3.5;
    const exampleMilestoneFontClass = "font08 fontBold";

    return(
      <>
        <div className="smallBottomMargin" title={"Editing Turnaround: '" + p_selectedExpandedTurnaroundObj.name}>
          <LibraryReact.NowrapEllipsis p_fontClass="font12">
            {"Editing Turnaround: '"}<font className="fontBold">{p_selectedExpandedTurnaroundObj.name}</font>{"'"}
          </LibraryReact.NowrapEllipsis>
        </div>
        <div className="">
          <CEGeneralReact.CaptureExecFieldEditSaveCancel
            p_ceEditItemString={"adminPropTurnName" + p_selectedExpandedTurnaroundObj.id}
            p_fieldDisplayName="Turnaround Name"
            p_fieldTypeObj={c_genericTextFieldTypeObj}
            p_valueRaw={p_selectedExpandedTurnaroundObj.name}
            p_valueIsEditableTFU={true}
            p_fieldClass="fontBlue"
            p_fieldWidth={editSequenceFieldWidthEm + "em"}
            f_onSaveChanged={this.onsave_edit_turnaround_name}
          />
        </div>
        <div className="hugeTopMargin" title={"Editing Sequence: '" + p_selectedExpandedSequenceObj.name}>
          <LibraryReact.NowrapEllipsis p_fontClass="font12">
            {"Editing Sequence: '"}<font className="fontBold">{p_selectedExpandedSequenceObj.name}</font>{"'"}
          </LibraryReact.NowrapEllipsis>
        </div>
        <div className="smallTopMargin">
          <CEGeneralReact.CaptureExecFieldEditSaveCancel
            p_ceEditItemString={"adminPropSeqName" + p_selectedExpandedSequenceObj.id}
            p_fieldDisplayName="Sequence Name"
            p_fieldTypeObj={c_genericTextFieldTypeObj}
            p_valueRaw={p_selectedExpandedSequenceObj.name}
            p_valueIsEditableTFU={true}
            p_fieldClass="fontBlue"
            p_fieldWidth={editSequenceFieldWidthEm + "em"}
            f_onSaveChanged={this.onsave_edit_sequence_name}
          />
        </div>
        <div className="microTopMargin">
          <CEGeneralReact.CaptureExecFieldEditSaveCancel
            p_ceEditItemString={"adminPropSeqColor" + p_selectedExpandedSequenceObj.id}
            p_fieldDisplayName="Sequence Color"
            p_fieldTypeObj={c_genericColorFieldTypeObj}
            p_valueRaw={p_selectedExpandedSequenceObj.sequence_bg_color}
            p_valueIsEditableTFU={true}
            p_fieldClass="fontBlue"
            p_fieldWidth={editSequenceFieldWidthEm + "em"}
            f_onSaveChanged={this.onsave_edit_sequence_bg_color}
          />
        </div>
        <div className="hugeTopMargin smallBottomMargin">
          <font className="font12 fontBold">
            {"Milestones Timeline"}
          </font>
        </div>
        {(numMilestones === 0) ? (
          <div className="medTopMargin lrBigPad textCenter">
            <font className="fontItalic fontTextLight">
              <div>{"--No Milestones added to this Sequence yet--"}</div>
              <div className="smallTopMargin">{"You can add Milestones by clicking the 'Add ->' button on rows within the Milestones Pool"}</div>
            </font>
          </div>
        ) : (
          <div className="displayFlexRow flexWrap">
            {expandedMilestonesArrayOfObjs.map((m_expandedMilestoneObj) =>
              <APMSingleMilestoneItem
                key={m_expandedMilestoneObj.id}
                p_expandedSequenceObj={p_selectedExpandedSequenceObj}
                p_expandedMilestoneObj={m_expandedMilestoneObj}
              />
            )}
          </div>
        )}
      </>
    );
  }
}));


function APMEditMilestoneFloatingBox(props) { //props: p_isOpenTF, p_expandedSequenceObj, p_expandedMilestoneObj, f_onSaveMilestoneEdits, f_onCancel
  const p_isOpenTF = props.p_isOpenTF;
  const p_expandedSequenceObj = props.p_expandedSequenceObj;
  const p_expandedMilestoneObj = props.p_expandedMilestoneObj;
  const f_onSaveMilestoneEdits = props.f_onSaveMilestoneEdits;
  const f_onCancel = props.f_onCancel;

  const [s_tempMilestoneNumDaysPriorInt, set_temp_milestone_num_days_prior] = React.useState(0);
  const [s_tempMilestoneDurationInt, set_temp_milestone_duration] = React.useState(1);

  React.useEffect(() => {
    if(p_isOpenTF && p_expandedMilestoneObj !== undefined) {
      set_temp_milestone_num_days_prior(p_expandedMilestoneObj.initial_num_days_prior_to_proposal_due_date);
      set_temp_milestone_duration(p_expandedMilestoneObj.initial_duration_num_days);
    }
  }, [p_isOpenTF, p_expandedMilestoneObj]);

  if(!p_isOpenTF || p_expandedMilestoneObj === undefined) {
    return null;
  }

  const sequenceNameString = ((p_expandedSequenceObj !== undefined && JSFUNC.text_or_number_is_filled_out_tf(p_expandedSequenceObj.name)) ? (p_expandedSequenceObj.name) : ("(Unknown Sequence)"));

  const onclick_save_edit_milestone = () => {
    f_onSaveMilestoneEdits(p_expandedMilestoneObj, s_tempMilestoneNumDaysPriorInt, s_tempMilestoneDurationInt);
    f_onCancel();
  };

  return(
    <CEGeneralReact.FloatingBoxWithSaveCancel
      p_trblFlag="confirmBox"
      p_title={"Editing Milestone '" + p_expandedMilestoneObj.name + "' within Sequence '" + sequenceNameString + "'"}
      f_onClickSave={onclick_save_edit_milestone}
      f_onClickCancel={f_onCancel}>
      <div className="flex11a displayFlexColumn medFullPad">
        <LibraryReact.RowVcWithLabel p_class="" p_labelWidthEm={10} p_labelFontClass="fontBlue" p_label="# Days Prior to Proposal Due Date">
          <div className="flex11a displayFlexColumn" style={{maxWidth:"6em"}}>
            <LibraryReact.Integer
              p_value={s_tempMilestoneNumDaysPriorInt}
              p_tabIndex={1}
              f_onChange={set_temp_milestone_num_days_prior}
              f_onKeyDownEnter={onclick_save_edit_milestone}
            />
          </div>
        </LibraryReact.RowVcWithLabel>
        <LibraryReact.RowVcWithLabel p_class="medTopMargin medBottomMargin" p_labelWidthEm={10} p_labelFontClass="fontBlue" p_label="Duration (# Days)">
          <div className="flex11a displayFlexColumn" style={{maxWidth:"6em"}}>
            <LibraryReact.Integer
              p_value={s_tempMilestoneDurationInt}
              p_tabIndex={2}
              f_onChange={set_temp_milestone_duration}
              f_onKeyDownEnter={onclick_save_edit_milestone}
            />
          </div>
        </LibraryReact.RowVcWithLabel>
      </div>
      <div className="flex00a displayFlexRowHcVc borderT1bbb" style={{flexBasis:"3.3em"}}>
        <div className="flex00a displayFlexColumnHcVc" style={{flexBasis:"7em"}}>
          <CEGeneralReact.CEButton
            p_type="blue"
            p_text="Save"
            p_tabIndex={3}
            f_onClick={onclick_save_edit_milestone}
          />
        </div>
        <div className="flex00a displayFlexColumnHcVc" style={{flexBasis:"7em"}}>
          <CEGeneralReact.CEButton
            p_type="gray"
            p_text="Cancel"
            p_tabIndex={4}
            f_onClick={f_onCancel}
          />
        </div>
      </div>
    </CEGeneralReact.FloatingBoxWithSaveCancel>
  );
}


const APMSingleMilestoneItem = inject("ProposalManagementMobx")(observer(
class APMSingleMilestoneItem extends Component { //props: p_expandedSequenceObj, p_expandedMilestoneObj
  constructor(props) {
    super(props);
    this.state = {
      s_editMilestoneFloatingBoxIsOpenTF: false
    };
  }

  onclick_edit_milestone = () => {
    this.setState({s_editMilestoneFloatingBoxIsOpenTF:true});
  }

  onsave_edit_milestone = (p_expandedMilestoneObj, i_numDaysPriorInt, i_durationInt) => {
    //if the value was changed, update it
    if(i_numDaysPriorInt !== p_expandedMilestoneObj.initial_num_days_prior_to_proposal_due_date) {
      this.props.ProposalManagementMobx.a_apm_update_milestone_field(p_expandedMilestoneObj, "initial_num_days_prior_to_proposal_due_date", i_numDaysPriorInt, "i");
    }

    if(i_durationInt !== p_expandedMilestoneObj.initial_duration_num_days) {
      this.props.ProposalManagementMobx.a_apm_update_milestone_field(p_expandedMilestoneObj, "initial_duration_num_days", i_durationInt, "i");
    }
  }

  onclick_cancel_edit_milestone = () => {
    this.setState({s_editMilestoneFloatingBoxIsOpenTF:false});
  }

  onclick_remove_milestone_from_sequence = () => {
    const p_expandedMilestoneObj = this.props.p_expandedMilestoneObj;
    this.props.ProposalManagementMobx.a_apm_remove_milestone_from_sequence(p_expandedMilestoneObj);
  }

  render() {
    const s_editMilestoneFloatingBoxIsOpenTF = this.state.s_editMilestoneFloatingBoxIsOpenTF;

    const p_expandedSequenceObj = this.props.p_expandedSequenceObj;
    const p_expandedMilestoneObj = this.props.p_expandedMilestoneObj;

    const milestoneWidthEm = 14;
    const milestoneCalendarStylingBlockWidthEm = (0.9 * milestoneWidthEm);
    const milestoneHeightEm = 4.5;

    const milestoneVerticalDotsMenuItemsArrayOfObjs = [
      {
        displayName: "Edit Milestone",
        functionOnClickMenuItem: this.onclick_edit_milestone
      },
      {
        displayName: "Remove Milestone",
        confirmType: "confirmDelete",
        confirmMessage: "Are you sure you want to remove milestone '" + p_expandedMilestoneObj.name + "' from Sequence '" + p_expandedSequenceObj.name + "'?",
        functionOnClickConfirmButton: this.onclick_remove_milestone_from_sequence
      }
    ];

    return(
      <div className="displayFlexColumn">
        <MilestoneParallelogram
          p_expandedSequenceObj={p_expandedSequenceObj}
          p_widthEm={milestoneWidthEm}
          p_heightEm={milestoneHeightEm}
          p_isCurrentTF={false}
          p_hoverText={p_expandedMilestoneObj.milestoneHoverText}>
          <div className="flex11a displayFlexRow">
            <div className="flex11a displayFlexColumnVc">
              <div className="lrPad">
                <LibraryReact.NowrapEllipsis p_fontClass="fontBold fontTextLight">
                  {p_expandedMilestoneObj.name}
                </LibraryReact.NowrapEllipsis>
              </div>
              <div
                className="hoverLighterBlueGradient tbMicroPad lrPad cursorPointer"
                title={"Click to edit the '# Days Prior to Proposal Due Date' for Milestone '" + p_expandedMilestoneObj.name + "'"}
                onClick={this.onclick_edit_milestone}>
                <LibraryReact.DivFont p_fontClass="font09 fontItalic fontTextLight">
                  {"# Days Prior: " + p_expandedMilestoneObj.initial_num_days_prior_to_proposal_due_date}
                </LibraryReact.DivFont>
                <LibraryReact.DivFont p_fontClass="font09 fontItalic fontTextLight">
                  {"Duration (# Days): " + p_expandedMilestoneObj.initial_duration_num_days}
                </LibraryReact.DivFont>
              </div>
            </div>
            <div className="flex00a displayFlexColumnHcVc" style={{flexBasis:"1em"}}>
              <CEGeneralReact.VerticalDotsMenu
                p_menuItemsArrayOfObjs={milestoneVerticalDotsMenuItemsArrayOfObjs}
              />
            </div>
          </div>
        </MilestoneParallelogram>
        <div
          className={"flex00a displayFlexColumnHcVc microBottomMargin " + ((p_expandedMilestoneObj.milestoneStylingObj.anyStylingAppliedTF) ? ("border bevelBorderColors") : ("")) + " textCenter"}
          style={{width:milestoneCalendarStylingBlockWidthEm + "em", height:"1.2em", background:p_expandedMilestoneObj.milestoneStylingObj.highlightHashColorOrUndefined}}>
          {(p_expandedMilestoneObj.milestoneStylingObj.anyStylingAppliedTF) &&
            <LibraryReact.DivFont p_fontClass={"font09 " + ((p_expandedMilestoneObj.milestoneStylingObj.boldTF) ? ("fontBold") : ("")) + " " + ((p_expandedMilestoneObj.milestoneStylingObj.italicTF) ? ("fontItalic") : (""))} p_fontStyleObj={{color:p_expandedMilestoneObj.milestoneStylingObj.fontHashColorOrUndefined}}>
              {"Calendar Styling"}
            </LibraryReact.DivFont>
          }
        </div>
        <APMEditMilestoneFloatingBox
          p_isOpenTF={s_editMilestoneFloatingBoxIsOpenTF}
          p_expandedSequenceObj={p_expandedSequenceObj}
          p_expandedMilestoneObj={p_expandedMilestoneObj}
          f_onSaveMilestoneEdits={this.onsave_edit_milestone}
          f_onCancel={this.onclick_cancel_edit_milestone}
        />
      </div>
    );
  }
}));


function AdminProposalManagementSectionLabel(props) { //props: p_text
  const p_text = props.p_text;

  return(
    <div className="bigBottomMargin">
      <font className="font12 fontBold fontDarkBlue">
        {p_text}
      </font>
    </div>
  );
}


function MilestoneParallelogram(props) { //props: p_expandedSequenceObj, p_widthEm, p_heightEm, p_isCurrentTF, p_hoverText, children
  const p_expandedSequenceObj = props.p_expandedSequenceObj;
  const p_widthEm = props.p_widthEm;
  const p_heightEm = props.p_heightEm;
  const p_isCurrentTF = props.p_isCurrentTF;
  const p_hoverText = props.p_hoverText;

  return(
    <CEIconsReact.Parallelogram
      p_widthEm={p_widthEm}
      p_heightEm={p_heightEm}
      p_slantWidthRatioToHeightDecimal={0.33}
      p_borderWidthEm={0.2}
      p_borderColor={p_expandedSequenceObj.sequence_bg_color}
      p_bgColor="ffffff"
      p_hoverText={p_hoverText}>
      {props.children}
    </CEIconsReact.Parallelogram>
  );
}



const APMCountdownCalendarPreview = inject("ProposalManagementMobx", "UserMobx", "DatabaseMobx")(observer(
class APMCountdownCalendarPreview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      s_editMilestoneFloatingBoxIsOpenTF: false,
      s_selectedExpandedMilestoneObjOrUndefined: undefined,
      s_selectedExpandedSequenceObjOrUndefined: undefined
    };
  }

  onchange_week_height_em = (i_newWeekHeightEm) => {
    this.props.ProposalManagementMobx.a_apm_set_calendar_preview_week_height(i_newWeekHeightEm);
  }

  onchange_display_number_of_weeks = (i_newDisplayNumWeeks) => {
    this.props.ProposalManagementMobx.a_apm_set_calendar_preview_display_num_weeks(i_newDisplayNumWeeks);
  }

  onselect_show_sequences = (i_newShowSequenceIDsComma) => {
    this.props.ProposalManagementMobx.a_apm_set_calendar_preview_selected_show_sequence_ids_comma(i_newShowSequenceIDsComma);
  }

  on_click_calendar_event = (i_eventObj) => {
    const expandedMilestoneObj = i_eventObj.expandedMilestoneObj;
    const expandedSequenceObj = i_eventObj.expandedSequenceObj;
    if(expandedMilestoneObj !== undefined) {
      this.setState({
        s_editMilestoneFloatingBoxIsOpenTF: true,
        s_selectedExpandedMilestoneObjOrUndefined: expandedMilestoneObj,
        s_selectedExpandedSequenceObjOrUndefined: expandedSequenceObj
      });
    }
  }

  onsave_edit_milestone = (p_expandedMilestoneObj, i_numDaysPriorInt, i_durationInt) => {
    //if the value was changed, update it
    if(i_numDaysPriorInt !== p_expandedMilestoneObj.initial_num_days_prior_to_proposal_due_date) {
      this.props.ProposalManagementMobx.a_apm_update_milestone_field(p_expandedMilestoneObj, "initial_num_days_prior_to_proposal_due_date", i_numDaysPriorInt, "i");
    }

    if(i_durationInt !== p_expandedMilestoneObj.initial_duration_num_days) {
      this.props.ProposalManagementMobx.a_apm_update_milestone_field(p_expandedMilestoneObj, "initial_duration_num_days", i_durationInt, "i");
    }
  }

  onclick_cancel_edit_milestone = () => {
    this.setState({
      s_editMilestoneFloatingBoxIsOpenTF: false,
      s_selectedExpandedMilestoneObjOrUndefined: undefined,
      s_selectedExpandedSequenceObjOrUndefined: undefined
    });
  }

  on_delete_calendar_event = (i_eventObj) => {
    const expandedMilestoneObj = i_eventObj.expandedMilestoneObj;
    if(expandedMilestoneObj !== undefined) {
      this.props.ProposalManagementMobx.a_apm_remove_milestone_from_sequence(expandedMilestoneObj);
    }
  }

  on_edit_calendar_event_fields = (i_eventObj, i_fieldNamesArray, i_fieldValuesArray) => {
    const expandedMilestoneObj = i_eventObj.expandedMilestoneObj;
    if(expandedMilestoneObj === undefined || !JSFUNC.is_array(i_fieldNamesArray) || !JSFUNC.is_array(i_fieldValuesArray)) {
      return;
    }

    const startFieldIndex = i_fieldNamesArray.indexOf("start_ce_datetime_utc");
    const endFieldIndex = i_fieldNamesArray.indexOf("end_ce_datetime_utc");

    if(startFieldIndex >= 0) {
      //move_start_keep_duration: compute day offset between old start and new start, shift numDaysPrior by the same amount
      const newStartCEDateTimeUtc = i_fieldValuesArray[startFieldIndex];
      const oldStartDateObj = JSFUNC.convert_ce_datetimeutc_to_jsdateobj(i_eventObj.startCEDateTimeUtc);
      const newStartDateObj = JSFUNC.convert_ce_datetimeutc_to_jsdateobj(newStartCEDateTimeUtc);
      const daysDiff = Math.round(JSFUNC.num_days_from_jsDateObj1_to_jsDateObj2(oldStartDateObj, newStartDateObj));
      const newNumDaysPrior = i_eventObj.numDaysPriorToZeroDate - daysDiff;
      if(newNumDaysPrior !== expandedMilestoneObj.initial_num_days_prior_to_proposal_due_date) {
        this.props.ProposalManagementMobx.a_apm_update_milestone_field(expandedMilestoneObj, "initial_num_days_prior_to_proposal_due_date", newNumDaysPrior, "i");
      }
    }
    else if(endFieldIndex >= 0) {
      //resize_end_only: compute day offset between old end and new end, adjust duration by the same amount
      const newEndCEDateTimeUtc = i_fieldValuesArray[endFieldIndex];
      const oldEndDateObj = JSFUNC.convert_ce_datetimeutc_to_jsdateobj(i_eventObj.endCEDateTimeUtc);
      const newEndDateObj = JSFUNC.convert_ce_datetimeutc_to_jsdateobj(newEndCEDateTimeUtc);
      const endDaysDiff = Math.round(JSFUNC.num_days_from_jsDateObj1_to_jsDateObj2(oldEndDateObj, newEndDateObj));
      const newDuration = expandedMilestoneObj.initial_duration_num_days + endDaysDiff;
      if(newDuration >= 1 && newDuration !== expandedMilestoneObj.initial_duration_num_days) {
        this.props.ProposalManagementMobx.a_apm_update_milestone_field(expandedMilestoneObj, "initial_duration_num_days", newDuration, "i");
      }
    }
  }

  get_normalized_week_start_day_index_0to6 = (i_weekStartDayIndex0To6Raw) => {
    const dayIndexNumber = Number(i_weekStartDayIndex0To6Raw);
    if(!Number.isInteger(dayIndexNumber) || dayIndexNumber < 0 || dayIndexNumber > 6) {
      return 0;
    }
    return dayIndexNumber;
  }

  get_synthetic_zero_reference_date_obj = (i_normalizedWeekStartDayIndex0To6) => {
    const targetDayIndex0To6 = (i_normalizedWeekStartDayIndex0To6 + 6) % 7;
    const baseDateObj = JSFUNC.convert_mysqldate_to_jsdateobj("2024-01-01");
    const daysForwardToTarget = (targetDayIndex0To6 - baseDateObj.getDay() + 7) % 7;
    return JSFUNC.jsdateobj_add_days(baseDateObj, daysForwardToTarget);
  }

  convert_to_hash_color = (i_colorStringOrUndefined, i_defaultHashColor) => {
    const rawColorString = ((JSFUNC.text_or_number_is_filled_out_tf(i_colorStringOrUndefined)) ? (String(i_colorStringOrUndefined).trim()) : (""));
    if(!JSFUNC.is_string_not_empty(rawColorString)) {
      return i_defaultHashColor;
    }
    return ((rawColorString.startsWith("#")) ? (rawColorString) : ("#" + rawColorString));
  }

  get_countdown_calendar_events_array_of_objs = (i_selectedExpandedTurnaroundObj, i_syntheticZeroReferenceDateObj) => {
    const o_apmCalendarPreviewSelectedShowSequenceIDsComma = this.props.ProposalManagementMobx.o_apmCalendarPreviewSelectedShowSequenceIDsComma;
    
    var countdownCalendarEventsArrayOfObjs = [];

    const selectedShowSequenceIDsArray = JSFUNC.convert_comma_list_to_int_array(o_apmCalendarPreviewSelectedShowSequenceIDsComma);
    if(selectedShowSequenceIDsArray.length > 0) {
      const expandedSequencesArrayOfObjs = ((JSFUNC.is_array(i_selectedExpandedTurnaroundObj.expandedSequencesArrayOfObjs)) ? (i_selectedExpandedTurnaroundObj.expandedSequencesArrayOfObjs) : ([]));
      for(let expandedSequenceObj of expandedSequencesArrayOfObjs) {
        if(JSFUNC.in_array(expandedSequenceObj.id, selectedShowSequenceIDsArray)) {
          const expandedMilestonesArrayOfObjs = ((JSFUNC.is_array(expandedSequenceObj.expandedMilestonesArrayOfObjs)) ? (expandedSequenceObj.expandedMilestonesArrayOfObjs) : ([]));
          for(let expandedMilestoneObj of expandedMilestonesArrayOfObjs) {
            const startNumDaysPriorToZeroDate = Number(expandedMilestoneObj.initial_num_days_prior_to_proposal_due_date);
            if(!Number.isFinite(startNumDaysPriorToZeroDate)) {
              continue;
            }

            let durationNumDays = Number(expandedMilestoneObj.initial_duration_num_days);
            if(!Number.isFinite(durationNumDays) || durationNumDays < 1) {
              durationNumDays = 1;
            }
            durationNumDays = Math.round(durationNumDays);

            const endNumDaysPriorToZeroDate = startNumDaysPriorToZeroDate - (durationNumDays - 1);

            const startDateObj = JSFUNC.jsdateobj_add_days(i_syntheticZeroReferenceDateObj, -startNumDaysPriorToZeroDate);
            const endDateObj = JSFUNC.jsdateobj_add_days(i_syntheticZeroReferenceDateObj, -endNumDaysPriorToZeroDate);
            const startCEDateTimeUtc = JSFUNC.get_naturalDateTimeYmdHis_local_or_utc_from_jsDateObj_and_utctf(startDateObj, true);
            const endCEDateTimeUtc = JSFUNC.get_naturalDateTimeYmdHis_local_or_utc_from_jsDateObj_and_utctf(endDateObj, true);

            const sequenceNameString = ((JSFUNC.text_or_number_is_filled_out_tf(expandedSequenceObj.name)) ? (String(expandedSequenceObj.name)) : ("(Unnamed Sequence)"));
            const milestoneNameString = ((JSFUNC.text_or_number_is_filled_out_tf(expandedMilestoneObj.name)) ? (String(expandedMilestoneObj.name)) : ("(Unnamed Milestone)"));
            const eventNameString = milestoneNameString + " [" + sequenceNameString + "]";
            const eventHoverTextLinesArray = [
              "Milestone: " + milestoneNameString,
              "Start (# Days Prior): " + startNumDaysPriorToZeroDate,
              "Duration (# Days): " + durationNumDays,
              "",
              "Turnaround: " + i_selectedExpandedTurnaroundObj.name,
              "Sequence: " + sequenceNameString,
            ];
            var eventHoverTextString = eventHoverTextLinesArray.join("\r\n");

            const eventSourceIndex = countdownCalendarEventsArrayOfObjs.length;
            countdownCalendarEventsArrayOfObjs.push({
              id: expandedMilestoneObj.id,
              sourceIndex: eventSourceIndex,
              eventName: eventNameString,
              eventHoverText: eventHoverTextString,
              eventBorderHashColor: this.convert_to_hash_color(expandedMilestoneObj.calSeqBorderColor, "#777777"),
              eventBackgroundHashColor: this.convert_to_hash_color(expandedMilestoneObj.calSeqBgColor, "#f6f6f6"),
              eventFontHashColor: this.convert_to_hash_color(expandedMilestoneObj.calSeqFontColor, "#333333"),
              eventFontClassString: expandedMilestoneObj.calSeqFontClassString,
              startCEDateTimeUtc: startCEDateTimeUtc,
              endCEDateTimeUtc: endCEDateTimeUtc,
              numDaysPriorToZeroDate: startNumDaysPriorToZeroDate,
              endNumDaysPriorToZeroDate: endNumDaysPriorToZeroDate,
              expandedSequenceObj: expandedSequenceObj,
              expandedMilestoneObj: expandedMilestoneObj
            });
          }
        }
      }
    }
    return(countdownCalendarEventsArrayOfObjs);
  }

  render() {
    const o_apmCalendarPreviewSelectedShowSequenceIDsComma = this.props.ProposalManagementMobx.o_apmCalendarPreviewSelectedShowSequenceIDsComma;
    const o_apmCalendarPreviewDisplayNumWeeks = this.props.ProposalManagementMobx.o_apmCalendarPreviewDisplayNumWeeks;
    const o_apmCalendarPreviewWeekHeight = this.props.ProposalManagementMobx.o_apmCalendarPreviewWeekHeight;
    const c_apmExpandedTurnaroundObjContainingSelectedSequenceOrUndefined = this.props.ProposalManagementMobx.c_apmExpandedTurnaroundObjContainingSelectedSequenceOrUndefined;
    const c_apmSelectCalendarPreviewDisplayNumWeeksFieldTypeObj = this.props.ProposalManagementMobx.c_apmSelectCalendarPreviewDisplayNumWeeksFieldTypeObj;
    const c_ocpmSelectWeekHeightEmFieldTypeObj = this.props.ProposalManagementMobx.c_ocpmSelectWeekHeightEmFieldTypeObj;
    const c_combinedUserObj = this.props.UserMobx.c_combinedUserObj;

    const s_editMilestoneFloatingBoxIsOpenTF = this.state.s_editMilestoneFloatingBoxIsOpenTF;
    const s_selectedExpandedMilestoneObjOrUndefined = this.state.s_selectedExpandedMilestoneObjOrUndefined;
    const s_selectedExpandedSequenceObjOrUndefined = this.state.s_selectedExpandedSequenceObjOrUndefined;

    const weekStartDayIndex0To6 = JSFUNC.prop_value(c_combinedUserObj.propmgmt_card_calendar_week_start_day_0to6, 0);

    if(c_apmExpandedTurnaroundObjContainingSelectedSequenceOrUndefined === undefined) {
      return(
        <CEGeneralReact.EmptyScreenGray>
          {"Select any Sequence to preview that Turnaround on the countdown calendar"}
        </CEGeneralReact.EmptyScreenGray>
      );
    }

    const valueDisplayArraysObj = this.props.DatabaseMobx.create_value_display_arrays_obj_from_arrayOfObjs_and_vd_column_names("Sequence(s)", c_apmExpandedTurnaroundObjContainingSelectedSequenceOrUndefined.expandedSequencesArrayOfObjs, "id", false, "name");
    const swsOptionsObj = {isMultiSelectTF:true, hasSearchTF:true, hasClearSelectionTF:true};
    const selectWithSearchDataObj = this.props.DatabaseMobx.create_sws_data_obj_from_value_display_arrays_obj(valueDisplayArraysObj, swsOptionsObj);
    const showSequencesFieldTypeObj = this.props.DatabaseMobx.create_field_type_obj("select", selectWithSearchDataObj);

    const normalizedWeekStartDayIndex0To6 = this.get_normalized_week_start_day_index_0to6(weekStartDayIndex0To6);
    const syntheticZeroReferenceDateObj = this.get_synthetic_zero_reference_date_obj(normalizedWeekStartDayIndex0To6);
    const countdownCalendarEventsArrayOfObjs = this.get_countdown_calendar_events_array_of_objs(c_apmExpandedTurnaroundObjContainingSelectedSequenceOrUndefined, syntheticZeroReferenceDateObj);

    return(
      <>
        <div className="flex00a displayFlexRow tbPad">
          <div className="flex11a displayFlexColumnHcVc">
            <LibraryReact.DivFont p_class="textCenter" p_fontClass="font12 fontBold fontDarkBlue">
              {"Countdown Calendar Preview"}
            </LibraryReact.DivFont>
            <LibraryReact.DivFont p_class="textCenter" p_fontClass="fontTextLight">
              {"Viewing Turnaround: '" + c_apmExpandedTurnaroundObjContainingSelectedSequenceOrUndefined.name + "'"}
            </LibraryReact.DivFont>
            <LibraryReact.DivFont p_class="microTopMargin textCenter" p_styleObj={{maxWidth:"80%"}} p_fontClass="fontItalic fontTextLighter">
              {"This 'countdown' calendar is relative to the proposal due date, with 'Day 0' representing the proposal due date. Milestones are positioned on the calendar based on their '# Days Prior to Proposal Due Date' value, and their duration is represented by the span of days they cover on the calendar."}
            </LibraryReact.DivFont>
          </div>
          <div className="flex00a displayFlexColumnHcVc" style={{flexBasis:"17em"}}>
            <LibraryReact.DivFont p_class="microBottomMargin textCenter" p_fontClass="fontTextLight">
              {"Show Sequences"}
            </LibraryReact.DivFont>
            <div className="flex00a displayFlexColumn" style={{width:"16em"}}>
              <CEGeneralReact.GenericInputOrSelectFromInputType
                p_fieldTypeObj={showSequencesFieldTypeObj}
                p_valueRaw={o_apmCalendarPreviewSelectedShowSequenceIDsComma}
                f_onChangeOrOnSelect={this.onselect_show_sequences}
              />
            </div>
          </div>
          <div className="flex00a displayFlexColumnHcVc" style={{flexBasis:"8.5em"}} title="The number of weeks (as a minimum) to display on the calendar preview. This helps to expand the calendar area for ease of dragging and dropping events.">
            <LibraryReact.DivFont p_class="microBottomMargin textCenter" p_fontClass="fontTextLight">
              {"Display # Weeks"}
            </LibraryReact.DivFont>
            <div className="flex00a displayFlexColumn" style={{width:"5em"}}>
              <CEGeneralReact.GenericInputOrSelectFromInputType
                p_fieldTypeObj={c_apmSelectCalendarPreviewDisplayNumWeeksFieldTypeObj}
                p_valueRaw={o_apmCalendarPreviewDisplayNumWeeks}
                f_onChangeOrOnSelect={this.onchange_display_number_of_weeks}
              />
            </div>
          </div>
          <div className="flex00a displayFlexColumnHcVc" style={{flexBasis:"7.5em"}} title="The height of each week row in the calendar preview. 'Auto' automatically adjusts the to the day with the maximum number of events.">
            <LibraryReact.DivFont p_class="microBottomMargin textCenter" p_fontClass="fontTextLight">
              {"Week Height"}
            </LibraryReact.DivFont>
            <div className="flex00a displayFlexColumn" style={{width:"5em"}}>
              <CEGeneralReact.GenericInputOrSelectFromInputType
                p_fieldTypeObj={c_ocpmSelectWeekHeightEmFieldTypeObj}
                p_valueRaw={o_apmCalendarPreviewWeekHeight}
                f_onChangeOrOnSelect={this.onchange_week_height_em}
              />
            </div>
          </div>
        </div>
        {(countdownCalendarEventsArrayOfObjs.length === 0) ? (
          <LibraryReact.DivFont p_class="flex00a tbMedPad textCenter" p_fontClass="fontItalic fontTextLighter">
            {"--No Milestones in this Turnaround yet--"}
          </LibraryReact.DivFont>
        ) : (
          <div className="flex00a" style={{width:"100%", minWidth:"62em"}}>
            <ProposalManagementCalendar
              p_inputDatesRealCalendarTrueCountdownToZeroFalse={false}
              p_calendarEventsArrayOfObjs={countdownCalendarEventsArrayOfObjs}
              p_proposalDueDateCeDateTimeUtc={undefined}
              p_startDateYmd={undefined}
              p_endDateYmd={undefined}
              p_weekHeightEm={o_apmCalendarPreviewWeekHeight}
              p_weekStartDayIndex0To6={normalizedWeekStartDayIndex0To6}
              p_countdownMustDrawNumDaysPriorMax={Math.max(0, (Number(o_apmCalendarPreviewDisplayNumWeeks) * 7) - 1)}
              p_countdownMustDrawNumDaysPriorMin={0}
              f_onClickCalendarEvent={this.on_click_calendar_event}
              f_onEditSingleEventFields={this.on_edit_calendar_event_fields}
              f_onDeleteEvent={this.on_delete_calendar_event}
            />
          </div>
        )}
        <APMEditMilestoneFloatingBox
          p_isOpenTF={s_editMilestoneFloatingBoxIsOpenTF}
          p_expandedSequenceObj={s_selectedExpandedSequenceObjOrUndefined}
          p_expandedMilestoneObj={s_selectedExpandedMilestoneObjOrUndefined}
          f_onSaveMilestoneEdits={this.onsave_edit_milestone}
          f_onCancel={this.onclick_cancel_edit_milestone}
        />
      </>
    );
  }
}));
